import { useState, useMemo } from "react";
import * as XLSX from "xlsx";

const PRO_HABILITADO = false;
const ASESOR_HABILITADO = false;

// ============================================================
// API - Conexion con el backend PHP
// ============================================================
const API_BASE = "https://inversorapp.com.ar/api";

async function apiFetch(endpoint, options) {
  options = options || {};
  const method = options.method || "GET";
  const body = options.body || null;
  const token = localStorage.getItem("inversorapp_token");
  const headers = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = "Bearer " + token;

  let res, data;
  try {
    res = await fetch(API_BASE + "/" + endpoint, { method, headers, body: body ? JSON.stringify(body) : null });
    data = await res.json();
  } catch (err) {
    return { ok: false, error: "No se pudo conectar con el servidor. Revisa tu conexion." };
  }
  return data;
}

const api = {
  login: (email, password) => apiFetch("login.php", { method: "POST", body: { email, password } }),
  registro: (datos) => apiFetch("registro.php", { method: "POST", body: datos }),
  operacionesListar: () => apiFetch("operaciones_listar.php"),
  operacionesListarAdmin: (f) => apiFetch("operaciones_listar.php?todas=1&limit=" + (f.limit||50) + "&offset=" + (f.offset||0) + (f.userId?"&userId="+f.userId:"") + (f.ticker?"&ticker="+f.ticker:"") + (f.desde?"&desde="+f.desde:"") + (f.hasta?"&hasta="+f.hasta:"")),
  operacionesCrear: (op) => apiFetch("operaciones_crear.php", { method: "POST", body: op }),
  operacionesEliminar: (id) => apiFetch("operaciones_eliminar.php?id=" + id, { method: "DELETE" }),
  activosListar: () => apiFetch("activos_listar.php"),
  activosCrear: (a) => apiFetch("activos_crear.php", { method: "POST", body: a }),
  solicitudesCrear: (s) => apiFetch("solicitudes_crear.php", { method: "POST", body: s }),
  solicitudesAprobar: (id, accion, datos) => apiFetch("solicitudes_aprobar.php", { method: "POST", body: Object.assign({ solicitudId: id, accion: accion }, datos || {}) }),
  favoritosListar: () => apiFetch("favoritos.php"),
  favoritosToggle: (ticker) => apiFetch("favoritos.php", { method: "POST", body: { ticker } }),
  usuariosListar: () => apiFetch("usuarios_listar.php"),
  usuariosEditar: (datos) => apiFetch("usuarios_editar.php", { method: "POST", body: datos }),
  usuariosCrear: (datos) => apiFetch("usuarios_crear.php", { method: "POST", body: datos }),
  usuariosActivos: (userId) => apiFetch("usuarios_activos.php?userId=" + userId),
  rankingVariaciones: (periodo,moneda,tipo,limit) => apiFetch("ranking_variaciones.php?periodo=" + periodo + "&moneda=" + moneda + (tipo?"&tipo="+encodeURIComponent(tipo):"") + "&limit=" + (limit||10)),
  logout: () => apiFetch("logout.php", { method: "POST" }),
  auditoriaListar: (userId,limit,offset) => apiFetch("auditoria_listar.php" + "?limit=" + (limit||50) + "&offset=" + (offset||0) + (userId?"&userId="+userId:"")),
  usuariosResetearPassword: (userId) => apiFetch("usuarios_resetear_password.php", { method: "POST", body: { userId } }),
  perfilEditar: (datos) => apiFetch("perfil_editar.php", { method: "POST", body: datos }),
  perfilPassword: (datos) => apiFetch("perfil_password.php", { method: "POST", body: datos }),
  usuariosRolSolicitar: (userId, nuevoRol) => apiFetch("usuarios_rol_solicitar.php", { method: "POST", body: { userId, nuevoRol } }),
  usuariosRolConfirmar: (codigo) => apiFetch("usuarios_rol_confirmar.php", { method: "POST", body: { codigo } }),
  usuariosEliminarSolicitar: (userId) => apiFetch("usuarios_eliminar_solicitar.php", { method: "POST", body: { userId } }),
  usuariosEliminarConfirmar: (codigo) => apiFetch("usuarios_eliminar_confirmar.php", { method: "POST", body: { codigo } }),
  recuperarSolicitar: (email) => apiFetch("recuperar_solicitar.php", { method: "POST", body: { email } }),
  recuperarConfirmar: (token, passwordNueva) => apiFetch("recuperar_confirmar.php", { method: "POST", body: { token, passwordNueva } }),
  reenviarVerificacion: (email) => apiFetch("reenviar_verificacion.php", { method: "POST", body: { email } }),
  tiposActivoListar: () => apiFetch("tipos_activo.php"),
  tipoActivoCambiarVisibilidad: (tipoNombre, visible) => apiFetch("tipos_activo.php", { method: "POST", body: { ambito: "tipo", tipoNombre, visible } }),
  activoCambiarVisibilidad: (activoId, visible) => apiFetch("tipos_activo.php", { method: "POST", body: { ambito: "activo", activoId, visible } }),
  lotesDisponibles: (ticker) => apiFetch("operaciones_lotes_disponibles.php?ticker=" + encodeURIComponent(ticker)),
  venderPorLote: (datos) => apiFetch("operaciones_vender_lote.php", { method: "POST", body: datos }),
  ventaDetalleLotes: (ventaId) => apiFetch("ventas_detalle_lotes.php?ventaId=" + ventaId),
  preciosListar: (tickers) => apiFetch("precios_activos.php" + (tickers ? "?tickers=" + encodeURIComponent(tickers.join(",")) : "")),
  actualizarPrecios: () => apiFetch("actualizar_precios.php"),
  planesListar: (todos) => apiFetch("planes.php" + (todos ? "?todos=1" : "")),
  planesEditar: (datos) => apiFetch("planes.php", { method: "POST", body: { accion: "editar", ...datos } }),
  planesCrear: (datos) => apiFetch("planes.php", { method: "POST", body: { accion: "crear", ...datos } }),
  usuariosPlan: (datos) => apiFetch("usuarios_plan.php", { method: "POST", body: datos }),
  bloquesListar: (todos) => apiFetch("bloques_activo.php" + (todos ? "?todos=1" : "")),
  bloqueEditar: (datos) => apiFetch("bloques_activo.php", { method: "POST", body: datos }),
  activoDetalle: (ticker, periodo) => apiFetch("activo_detalle.php?ticker=" + encodeURIComponent(ticker) + "&periodo=" + (periodo||"3mo")),
  mensajesListar: (ticker, pagina) => apiFetch("mensajes_activo.php?ticker=" + encodeURIComponent(ticker) + "&pagina=" + (pagina||1)),
  mensajesPublicar: (ticker, mensaje) => apiFetch("mensajes_activo.php", { method: "POST", body: { ticker, mensaje } }),
  mensajesEliminar: (id) => apiFetch("mensajes_activo.php?id=" + id, { method: "DELETE" }),
  simulacionesListar: () => apiFetch("simulaciones_listar.php"),
  simulacionesCrear: (datos) => apiFetch("simulaciones_crear.php", { method: "POST", body: datos }),
  simulacionesEliminar: (id) => apiFetch("simulaciones_eliminar.php?id=" + id, { method: "DELETE" }),
  simulacionesActualizarPrecio: (id, precioActual) => apiFetch("simulaciones_actualizar_precio.php", { method: "POST", body: { id, precioActual } }),
};

const formatMoney = (amount, moneda) => {
  const num = parseFloat(amount) || 0;
  if (moneda === "USD") return "US$ " + num.toLocaleString("es-AR", {minimumFractionDigits:2,maximumFractionDigits:2});
  return "$ " + num.toLocaleString("es-AR", {minimumFractionDigits:2,maximumFractionDigits:2});
};
const parseFecha = (fecha) => {
  if (!fecha) return null;
  const [d,m,y] = fecha.split("/");
  return new Date(y+"-"+m+"-"+d);
};
const calcPosicion = (operaciones, userId, ticker) => {
  const ops = operaciones.filter(o=>o.userId===userId&&o.ticker===ticker).sort((a,b)=>parseFecha(a.fecha)-parseFecha(b.fecha));
  let cantidad=0, costoTotal=0;
  for (const op of ops) {
    const cant=parseFloat(op.cantidad||0), precio=parseFloat(op.precio||0), com=precio*cant*(parseFloat(op.comision||1)/100);
    if (op.tipo==="COMPRA") { costoTotal+=precio*cant+com; cantidad+=cant; }
    else if (cantidad>0) { const pct=cant/cantidad; costoTotal-=costoTotal*pct; cantidad-=cant; }
  }
  return { cantidad: Math.max(0,cantidad), promedio: cantidad>0 ? costoTotal/cantidad : 0 };
};
const esPro = (u) => {
  if (!u||u.plan!=="pro") return false;
  if (u.planVence==="31/12/2099") return true;
  if (!u.planVence) return false;
  const [d,m,y] = u.planVence.split("/");
  return new Date(y+"-"+m+"-"+d) >= new Date();
};
const filtrarPorPeriodo = (ops, periodo, desde, hasta) => {
  const hoy = new Date();
  return ops.filter(op => {
    const f = parseFecha(op.fecha); if (!f) return true;
    if (periodo==="15D") { const l=new Date(hoy); l.setDate(l.getDate()-15); return f>=l; }
    if (periodo==="1M") { const l=new Date(hoy); l.setMonth(l.getMonth()-1); return f>=l; }
    if (periodo==="3M") { const l=new Date(hoy); l.setMonth(l.getMonth()-3); return f>=l; }
    if (periodo==="RANGO") {
      if (desde) { const [dd,mm,yy]=desde.split("/"); const d2=new Date(yy+"-"+mm+"-"+dd); if (!isNaN(d2)&&f<d2) return false; }
      if (hasta) { const [dd,mm,yy]=hasta.split("/"); const d2=new Date(yy+"-"+mm+"-"+dd); if (!isNaN(d2)&&f>d2) return false; }
    }
    return true;
  });
};
const importarActivosExcel = (file, activosExistentes, onSuccess, onError) => {
  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const data=new Uint8Array(e.target.result), wb=XLSX.read(data,{type:"array"}), ws=wb.Sheets[wb.SheetNames[0]], rows=XLSX.utils.sheet_to_json(ws);
      const tickers = new Set(activosExistentes.map(a=>a.ticker.toUpperCase()));
      const nuevos = rows.filter(r=>r.ticker&&r.nombre).map(r=>({id:Date.now().toString()+Math.random(),ticker:String(r.ticker).toUpperCase().trim(),nombre:String(r.nombre).trim(),tipo:String(r.tipo||"Cedear").trim()})).filter(a=>!tickers.has(a.ticker));
      onSuccess(nuevos, rows.length-nuevos.length);
    } catch(err) { onError("Error al leer el archivo Excel"); }
  };
  reader.readAsArrayBuffer(file);
};
const exportarExcel = (operaciones, nombre) => {
  const datos = operaciones.map(op => {
    const t=parseFloat(op.precio)*parseFloat(op.cantidad), c=t*parseFloat(op.comision)/100;
    return { Fecha:op.fecha, Activo:op.ticker, Tipo:op.tipo, Cantidad:parseFloat(op.cantidad), Precio:parseFloat(op.precio), Moneda:op.moneda, Subtotal:t, Comision:c, "Total Neto":op.tipo==="COMPRA"?t+c:t-c, Broker:op.broker, Notas:op.notas||"" };
  });
  const ws=XLSX.utils.json_to_sheet(datos), wb=XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Operaciones");
  XLSX.writeFile(wb, nombre+".xlsx");
};
const exportarPDF = (operaciones, titulo) => {
  const filas = operaciones.map(function(op) {
    const t=parseFloat(op.precio)*parseFloat(op.cantidad), c=t*parseFloat(op.comision)/100, n=op.tipo==="COMPRA"?t+c:t-c;
    return "<tr><td>"+op.fecha+"</td><td><b>"+op.ticker+"</b></td><td>"+op.tipo+"</td><td>"+op.cantidad+"</td><td>"+formatMoney(op.precio,op.moneda)+"</td><td>"+formatMoney(n,op.moneda)+"</td><td>"+op.broker+"</td></tr>";
  }).join("");
  const html = "<!DOCTYPE html><html><head><meta charset='utf-8'><title>"+titulo+"</title><style>body{font-family:Arial;font-size:11px;padding:20px}table{width:100%;border-collapse:collapse}th{background:#0a0e1a;color:#fff;padding:6px}td{padding:5px;border-bottom:1px solid #eee}</style></head><body><h2>InversorApp - "+titulo+"</h2><table><thead><tr><th>Fecha</th><th>Activo</th><th>Tipo</th><th>Cant</th><th>Precio</th><th>Total</th><th>Broker</th></tr></thead><tbody>"+filas+"</tbody></table></body></html>";
  const b=new Blob([html],{type:"text/html"}), u=URL.createObjectURL(b), a=document.createElement("a");
  a.href=u; a.download="InversorApp_"+titulo.replace(/\s/g,"_")+".html";
  document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(u);
};

const DEMO_USUARIOS = [
  {id:"1",nombre:"Admin",email:"admin@inversorapp.com",password:"admin123",rol:"admin",plan:"pro",planVence:"31/12/2099",celular:"",pais:"Argentina",comision:"1"},
  {id:"2",nombre:"Demo",email:"demo@inversorapp.com",password:"demo123",rol:"usuario",plan:"free",planVence:null,celular:"",pais:"Argentina",comision:"1"},
];
const DEMO_CONFIG = {comision:"1"};
const DEMO_IPC = [
  {id:"1",mes:"01/2026",valor:"2.4"},{id:"2",mes:"02/2026",valor:"2.1"},
  {id:"3",mes:"03/2026",valor:"3.2"},{id:"4",mes:"04/2026",valor:"2.8"},{id:"5",mes:"05/2026",valor:"3.5"},
];
const DEMO_ALERTAS = [
  {id:"1",userId:"1",ticker:"MELI",tipo:"COMPRA",precio:"17000",moneda:"ARS",notas:"Soporte",activa:true,notificada:false,canalNotificacion:"push"},
  {id:"2",userId:"1",ticker:"AAPL",tipo:"VENTA",precio:"65.00",moneda:"USD",notas:"Resistencia",activa:true,notificada:false,canalNotificacion:"push"},
];
const PAISES = ["Argentina","Bolivia","Brasil","Chile","Colombia","Costa Rica","Ecuador","El Salvador","Espana","Guatemala","Honduras","Mexico","Nicaragua","Panama","Paraguay","Peru","Puerto Rico","Republica Dominicana","Uruguay","Venezuela","Otro"];

const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=Inter:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap');
    *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
    :root{--bg:#0a0e1a;--surface:#111827;--surface2:#1a2235;--border:#1e2d45;--accent:#00d4ff;--accent2:#7c3aed;--green:#00e5a0;--red:#ff4d6d;--yellow:#fbbf24;--text:#e2e8f0;--text2:#64748b;--text3:#94a3b8;--font:'Syne',sans-serif;--font-input:'Inter',sans-serif;--mono:'DM Mono',monospace;--r:12px;--rs:8px;}
    html,body,#root{height:100%;background:var(--bg);color:var(--text);font-family:var(--font-input);-webkit-font-smoothing:antialiased}
    h1,h2{font-family:var(--font)}
    ::-webkit-scrollbar{width:5px;height:5px}
    ::-webkit-scrollbar-track{background:transparent}
    ::-webkit-scrollbar-thumb{background:rgba(100,116,139,.35);border-radius:4px}
    ::-webkit-scrollbar-thumb:hover{background:rgba(100,116,139,.6)}
    .scroll-area{scrollbar-width:thin;scrollbar-color:rgba(100,116,139,.35) transparent}
    .scroll-area::-webkit-scrollbar-thumb{background:rgba(100,116,139,.35)}
    .scroll-area::-webkit-scrollbar-thumb:hover{background:rgba(100,116,139,.6)}
    input,select,textarea{background:var(--surface2);border:1px solid var(--border);color:var(--text);font-family:var(--font-input);font-size:15px;font-weight:500;letter-spacing:0.2px;border-radius:var(--rs);padding:10px 11px;width:100%;outline:none;transition:border-color .2s}
    input:focus,select:focus{border-color:var(--accent)}
    input::placeholder{color:var(--text2);font-family:var(--font-input)}
    select option{background:var(--surface2);font-family:var(--font-input)}
    button{cursor:pointer;border:none;outline:none}
    @keyframes fadeIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}
    @keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
    .fi{animation:fadeIn .2s ease forwards}
  `}</style>
);
const Badge = ({children,variant="default",size="md"}) => {
  const c={default:{bg:"var(--surface2)",c:"var(--text3)"},compra:{bg:"rgba(0,229,160,.15)",c:"var(--green)"},venta:{bg:"rgba(255,77,109,.15)",c:"var(--red)"},usd:{bg:"rgba(0,212,255,.15)",c:"var(--accent)"},ars:{bg:"rgba(251,191,36,.15)",c:"var(--yellow)"},admin:{bg:"rgba(124,58,237,.2)",c:"#a78bfa"}};
  const col=c[variant]||c.default;
  return <span style={{display:"inline-flex",alignItems:"center",background:col.bg,color:col.c,padding:size==="sm"?"2px 7px":"4px 10px",borderRadius:"100px",fontSize:size==="sm"?"11px":"12px",fontWeight:600,whiteSpace:"nowrap"}}>{children}</span>;
};
const Card = ({children,style={},onClick}) => (
  <div onClick={onClick} style={{background:"var(--surface)",border:"1px solid var(--border)",borderRadius:"var(--r)",padding:"13px",transition:"border-color .2s",cursor:onClick?"pointer":"default",...style}} onMouseEnter={e=>onClick&&(e.currentTarget.style.borderColor="var(--accent)")} onMouseLeave={e=>onClick&&(e.currentTarget.style.borderColor="var(--border)")}>{children}</div>
);
const Btn = ({children,onClick,variant="primary",size="md",style={},disabled=false}) => {
  const v={primary:{background:"var(--accent)",color:"#0a0e1a"},ghost:{background:"transparent",color:"var(--text3)",border:"1px solid var(--border)"},danger:{background:"rgba(255,77,109,.15)",color:"var(--red)",border:"1px solid rgba(255,77,109,.3)"},success:{background:"rgba(0,229,160,.15)",color:"var(--green)",border:"1px solid rgba(0,229,160,.3)"},excel:{background:"rgba(0,229,160,.12)",color:"var(--green)",border:"1px solid rgba(0,229,160,.3)"},pdf:{background:"rgba(255,77,109,.12)",color:"var(--red)",border:"1px solid rgba(255,77,109,.3)"}};
  const s={sm:{padding:"5px 12px",fontSize:"12px"},md:{padding:"10px 16px",fontSize:"14px"},lg:{padding:"12px 20px",fontSize:"15px"}};
  return <button onClick={onClick} disabled={disabled} style={{...v[variant],...s[size],borderRadius:"var(--rs)",fontWeight:700,transition:"opacity .15s",opacity:disabled?.4:1,...style}} onMouseEnter={e=>!disabled&&(e.currentTarget.style.opacity=".8")} onMouseLeave={e=>!disabled&&(e.currentTarget.style.opacity="1")}>{children}</button>;
};
const FilterBtn = ({label,active,onClick}) => (
  <button onClick={onClick} style={{padding:"5px 12px",borderRadius:"100px",fontSize:"12px",fontWeight:600,whiteSpace:"nowrap",background:active?"var(--accent)":"var(--surface2)",color:active?"#0a0e1a":"var(--text3)",border:active?"1px solid var(--accent)":"1px solid var(--border)",cursor:"pointer"}}>{label}</button>
);
const Field = ({label,children,hint}) => (
  <div style={{marginBottom:"10px"}}>
    <label style={{display:"block",fontSize:"11px",fontWeight:700,color:"var(--text3)",marginBottom:"4px",letterSpacing:".06em",textTransform:"uppercase"}}>{label}</label>
    {children}
    {hint&&<p style={{fontSize:"11px",color:"var(--text2)",marginTop:"3px"}}>{hint}</p>}
  </div>
);

// Convierte DD/MM/AAAA (formato usado en toda la app) a AAAA-MM-DD (formato que pide input type=date)
const fechaAFormatoInput = (fechaDDMMAAAA) => {
  if (!fechaDDMMAAAA) return "";
  const partes = fechaDDMMAAAA.split("/");
  if (partes.length!==3) return "";
  let [d,m,y] = partes;
  d = d.padStart(2,"0"); m = m.padStart(2,"0");
  if (y.length!==4) return "";
  return y+"-"+m+"-"+d;
};
// Convierte AAAA-MM-DD (lo que devuelve input type=date) a DD/MM/AAAA (formato usado en toda la app)
const fechaDesdeInput = (fechaISO) => {
  if (!fechaISO) return "";
  const [y,m,d] = fechaISO.split("-");
  if (!y||!m||!d) return "";
  return d+"/"+m+"/"+y;
};
// Input de fecha con selector de calendario nativo (celular/navegador).
// Internamente siempre maneja y devuelve el formato DD/MM/AAAA que ya
// usa toda la app, asi no rompe ningun calculo ni filtro existente.
const InputFecha = ({value,onChange,placeholder}) => (
  <input
    type="date"
    value={fechaAFormatoInput(value)}
    onChange={e=>onChange(fechaDesdeInput(e.target.value))}
    placeholder={placeholder}
    style={{colorScheme:"dark"}}
  />
);

const Divider = ({label}) => (
  <div style={{display:"flex",alignItems:"center",gap:"8px",margin:"12px 0 8px"}}>
    <div style={{flex:1,height:"1px",background:"var(--border)"}}/>
    {label&&<span style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",textTransform:"uppercase",whiteSpace:"nowrap"}}>{label}</span>}
    <div style={{flex:1,height:"1px",background:"var(--border)"}}/>
  </div>
);

// Buscador predictivo de activos  -  reemplaza todos los <select> de activos
const BuscadorActivo = ({activos, value, onChange, placeholder}) => {
  const [busqueda, setBusqueda] = useState(value||"");
  const [abierto, setAbierto] = useState(false);

  const sugerencias = busqueda.trim().length>=1
    ? activos.filter(a=>
        a.ticker.toLowerCase().includes(busqueda.toLowerCase()) ||
        a.nombre.toLowerCase().includes(busqueda.toLowerCase())
      ).slice(0,8)
    : [];

  const seleccionar = (a) => {
    onChange(a.ticker);
    setBusqueda(a.ticker + "  -  " + a.nombre);
    setAbierto(false);
  };

  const limpiar = () => { onChange(""); setBusqueda(""); setAbierto(false); };

  return (
    <div style={{position:"relative"}}>
      <div style={{position:"relative"}}>
        <input
          value={busqueda}
          onChange={e=>{ setBusqueda(e.target.value); onChange(""); setAbierto(true); }}
          onFocus={()=>setAbierto(true)}
          placeholder={placeholder||"Buscar ticker o nombre..."}
          style={{paddingRight:"32px", fontFamily:"var(--font-input)"}}
        />
        {busqueda&&(
          <button onClick={limpiar} style={{position:"absolute",right:"8px",top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:"var(--text3)",cursor:"pointer",fontSize:"14px",lineHeight:1}}>x</button>
        )}
      </div>
      {abierto&&sugerencias.length>0&&(
        <div style={{position:"absolute",top:"calc(100% + 3px)",left:0,right:0,background:"var(--surface)",border:"1px solid var(--accent)",borderRadius:"var(--rs)",zIndex:100,maxHeight:"220px",overflowY:"auto",boxShadow:"0 8px 24px rgba(0,0,0,.5)"}}>
          {sugerencias.map(a=>(
            <div key={a.id} onMouseDown={()=>seleccionar(a)}
              style={{padding:"9px 12px",cursor:"pointer",borderBottom:"1px solid var(--border)",display:"flex",justifyContent:"space-between",alignItems:"center"}}
              onMouseEnter={e=>e.currentTarget.style.background="var(--surface2)"}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <div>
                <span style={{fontWeight:700,fontSize:"13px",fontFamily:"var(--mono)",color:"var(--accent)"}}>{a.ticker}</span>
                <span style={{fontSize:"12px",color:"var(--text3)",marginLeft:"8px"}}>{a.nombre}</span>
              </div>
              <Badge variant="default" size="sm">{a.tipo}</Badge>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
const BuscadorUsuario = ({usuarios, value, onChange, placeholder}) => {
  const [busqueda, setBusqueda] = useState("");
  const [abierto, setAbierto] = useState(false);

  const sugerencias = busqueda.trim().length>=1
    ? usuarios.filter(u=>
        u.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
        u.email.toLowerCase().includes(busqueda.toLowerCase())
      ).slice(0,8)
    : [];

  const seleccionar = (u) => {
    onChange(u.id);
    setBusqueda(u.nombre + "  -  " + u.email);
    setAbierto(false);
  };

  const limpiar = () => { onChange(""); setBusqueda(""); setAbierto(false); };

  return (
    <div style={{position:"relative"}}>
      <div style={{position:"relative"}}>
        <input
          value={busqueda}
          onChange={e=>{ setBusqueda(e.target.value); onChange(""); setAbierto(true); }}
          onFocus={()=>setAbierto(true)}
          placeholder={placeholder||"Buscar usuario por nombre o email..."}
          style={{paddingRight:"32px", fontFamily:"var(--font-input)"}}
        />
        {busqueda&&(
          <button onClick={limpiar} style={{position:"absolute",right:"8px",top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:"var(--text3)",cursor:"pointer",fontSize:"14px",lineHeight:1}}>x</button>
        )}
      </div>
      {abierto&&sugerencias.length>0&&(
        <div style={{position:"absolute",top:"calc(100% + 3px)",left:0,right:0,background:"var(--surface)",border:"1px solid var(--accent)",borderRadius:"var(--rs)",zIndex:100,maxHeight:"220px",overflowY:"auto",boxShadow:"0 8px 24px rgba(0,0,0,.5)"}}>
          {sugerencias.map(u=>(
            <div key={u.id} onMouseDown={()=>seleccionar(u)}
              style={{padding:"9px 12px",cursor:"pointer",borderBottom:"1px solid var(--border)"}}
              onMouseEnter={e=>e.currentTarget.style.background="var(--surface2)"}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <div style={{fontWeight:700,fontSize:"13px"}}>{u.nombre}</div>
              <div style={{fontSize:"11px",color:"var(--text3)"}}>{u.email}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
const FiltroPeriodo = ({valor,setValor,desde,setDesde,hasta,setHasta}) => (
  <>
    <div style={{display:"flex",gap:"5px",marginBottom:valor==="RANGO"?"8px":"0",flexWrap:"wrap"}}>
      {[["TODOS","Todo"],["15D","15 dias"],["1M","Este mes"],["3M","3 meses"],["RANGO","Rango"]].map(([v,l])=>(
        <FilterBtn key={v} label={l} active={valor===v} onClick={()=>setValor(v)} />
      ))}
    </div>
    {valor==="RANGO"&&(
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"8px",marginTop:"8px"}}>
        <Field label="Desde"><InputFecha value={desde} onChange={setDesde} placeholder="DD/MM/AAAA" /></Field>
        <Field label="Hasta"><InputFecha value={hasta} onChange={setHasta} placeholder="DD/MM/AAAA" /></Field>
      </div>
    )}
  </>
);
const LogoIcon = ({size=32}) => (
  <svg width={size} height={size} viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="lg1" x1="0%" y1="100%" x2="100%" y2="0%"><stop offset="0%" stopColor="#0099cc"/><stop offset="100%" stopColor="#00d4ff"/></linearGradient>
      <linearGradient id="lg2" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#00d4ff" stopOpacity="0.15"/><stop offset="100%" stopColor="#7c3aed" stopOpacity="0.15"/></linearGradient>
    </defs>
    <polygon points="28,4 50,16 50,40 28,52 6,40 6,16" fill="url(#lg2)" stroke="url(#lg1)" strokeWidth="1.5"/>
    <line x1="14" y1="35" x2="14" y2="37" stroke="url(#lg1)" strokeWidth="1.2" strokeLinecap="round" opacity="0.55"/>
    <rect x="11.5" y="37" width="5" height="7" rx="1" fill="url(#lg1)" opacity="0.55"/>
    <line x1="14" y1="44" x2="14" y2="46" stroke="url(#lg1)" strokeWidth="1.2" strokeLinecap="round" opacity="0.55"/>
    <line x1="21" y1="28" x2="21" y2="31" stroke="url(#lg1)" strokeWidth="1.5" strokeLinecap="round" opacity="0.55"/>
    <rect x="18.5" y="31" width="5" height="13" rx="1" fill="url(#lg1)" opacity="0.55"/>
    <line x1="21" y1="44" x2="21" y2="47" stroke="url(#lg1)" strokeWidth="1.5" strokeLinecap="round" opacity="0.55"/>
    <line x1="28" y1="13" x2="28" y2="17" stroke="url(#lg1)" strokeWidth="2" strokeLinecap="round"/>
    <rect x="24.5" y="17" width="7" height="27" rx="1.5" fill="url(#lg1)"/>
    <line x1="28" y1="44" x2="28" y2="47" stroke="url(#lg1)" strokeWidth="2" strokeLinecap="round"/>
    <line x1="21" y1="17" x2="35" y2="17" stroke="url(#lg1)" strokeWidth="2" strokeLinecap="round"/>
    <line x1="21" y1="44" x2="35" y2="44" stroke="url(#lg1)" strokeWidth="2" strokeLinecap="round"/>
    <line x1="35" y1="28" x2="35" y2="31" stroke="url(#lg1)" strokeWidth="1.5" strokeLinecap="round" opacity="0.55"/>
    <rect x="32.5" y="31" width="5" height="13" rx="1" fill="url(#lg1)" opacity="0.55"/>
    <line x1="35" y1="44" x2="35" y2="47" stroke="url(#lg1)" strokeWidth="1.5" strokeLinecap="round" opacity="0.55"/>
    <line x1="42" y1="35" x2="42" y2="37" stroke="url(#lg1)" strokeWidth="1.2" strokeLinecap="round" opacity="0.55"/>
    <rect x="39.5" y="37" width="5" height="7" rx="1" fill="url(#lg1)" opacity="0.55"/>
    <line x1="42" y1="44" x2="42" y2="46" stroke="url(#lg1)" strokeWidth="1.2" strokeLinecap="round" opacity="0.55"/>
  </svg>
);
const LogoFull = () => (
  <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
    <LogoIcon size={36}/>
    <div>
      <div style={{fontWeight:900,fontSize:"16px",letterSpacing:"-0.5px",lineHeight:1,color:"white",fontFamily:"var(--font)"}}>INVERSOR<span style={{color:"var(--accent)"}}>App</span></div>
      <div style={{fontSize:"9px",letterSpacing:"3px",color:"var(--text3)",lineHeight:1.3}}>Registro de operaciones bursatiles</div>
    </div>
  </div>
);

const UpgradeScreen = ({onClose}) => (
  <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.9)",zIndex:500,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px"}} onClick={e=>e.target===e.currentTarget&&onClose()}>
    <div className="fi" style={{background:"var(--surface)",border:"1px solid var(--border)",borderRadius:"16px",width:"100%",maxWidth:"380px",padding:"24px",position:"relative"}}>
      <button onClick={onClose} style={{position:"absolute",top:"14px",right:"14px",background:"var(--surface2)",border:"1px solid var(--border)",color:"var(--text3)",borderRadius:"50%",width:"28px",height:"28px",cursor:"pointer",fontSize:"13px"}}>X</button>
      <div style={{textAlign:"center",marginBottom:"20px"}}>
        <h2 style={{fontSize:"20px",fontWeight:800}}>InversorApp Pro</h2>
        <p style={{color:"var(--text3)",fontSize:"13px",marginTop:"4px"}}>Lleva tus inversiones al siguiente nivel</p>
      </div>
      {[["Precios en tiempo real","Cedears, acciones, bonos y criptos actualizados"],["Asesor con IA","Analisis personalizado de tu cartera"],["Alertas automaticas","Notificaciones de precio objetivo"]].map(([t,d])=>(
        <div key={t} style={{display:"flex",gap:"10px",marginBottom:"12px"}}>
          <span style={{color:"var(--green)",fontWeight:700}}>OK</span>
          <div><div style={{fontWeight:700,fontSize:"13px"}}>{t}</div><div style={{fontSize:"11px",color:"var(--text3)"}}>{d}</div></div>
        </div>
      ))}
      <div style={{borderTop:"1px solid var(--border)",paddingTop:"16px",marginTop:"8px",textAlign:"center"}}>
        <div style={{fontSize:"28px",fontWeight:900,color:"var(--accent)",fontFamily:"var(--mono)"}}>$12.000<span style={{fontSize:"14px",color:"var(--text3)"}}>/mes</span></div>
        <div style={{fontSize:"12px",color:"var(--green)",marginBottom:"14px"}}>o $120.000/anio - 2 meses gratis</div>
        <Btn style={{width:"100%",marginBottom:"8px"}} size="lg">Suscribirme con MercadoPago</Btn>
      </div>
    </div>
  </div>
);
const ProLock = ({children,user,onUpgrade}) => {
  if (esPro(user)) return children;
  return (
    <div style={{position:"relative"}}>
      <div style={{filter:"blur(3px)",pointerEvents:"none",opacity:0.5}}>{children}</div>
      <div style={{position:"absolute",inset:0,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",background:"rgba(10,14,26,.85)",borderRadius:"var(--r)",textAlign:"center",padding:"20px"}}>
        <div style={{fontWeight:800,fontSize:"15px",marginBottom:"6px"}}>Funcion Pro</div>
        <div style={{fontSize:"12px",color:"var(--text3)",marginBottom:"14px"}}>Actualiza tu plan para acceder</div>
        <Btn onClick={onUpgrade} size="sm">Ver planes Pro</Btn>
      </div>
    </div>
  );
};

const MAX_INTENTOS = 3;
const BLOQUEO_MS = 15*60*1000;
const LoginScreen = ({onLogin,onRegistro,usuarios}) => {
  const [email,setEmail] = useState("");
  const [pw,setPw] = useState("");
  const [err,setErr] = useState("");
  const [loading,setLoading] = useState(false);
  const [intentos,setIntentos] = useState(0);
  const [bloqueadoHasta,setBloqueadoHasta] = useState(null);
  const [showPw,setShowPw] = useState(false);
  const [pantalla,setPantalla] = useState("login");
  const [emailRecuperar,setEmailRecuperar] = useState("");
  const [errRecuperar,setErrRecuperar] = useState("");
  const [enviandoRecuperar,setEnviandoRecuperar] = useState(false);
  const [emailSinVerificar,setEmailSinVerificar] = useState("");
  const [reenviando,setReenviando] = useState(false);
  const [reenviado,setReenviado] = useState(false);
  const estaBloqueado = bloqueadoHasta && Date.now()<bloqueadoHasta;
  const tiempoRestante = () => bloqueadoHasta ? Math.ceil((bloqueadoHasta-Date.now())/60000) : 0;
  const go = async () => {
    if (estaBloqueado) return;
    if (!email||!pw) { setErr("Completa email y contrasena"); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setErr("Email invalido"); return; }
    setLoading(true); setErr(""); setEmailSinVerificar("");
    const resp = await api.login(email, pw);
    if (resp.ok) {
      localStorage.setItem("inversorapp_token", resp.token);
      setIntentos(0); setBloqueadoHasta(null);
      onLogin(resp.usuario);
    } else {
      if (resp.emailNoVerificado) {
        setEmailSinVerificar(resp.email||email);
      } else if (resp.error && resp.error.toLowerCase().includes("bloquead")) {
        setBloqueadoHasta(Date.now()+BLOQUEO_MS);
      } else {
        setIntentos(i=>i+1);
        setErr(resp.error||"Email o contrasena incorrectos.");
      }
    }
    setLoading(false);
  };
  const reenviarVerificacion = async () => {
    setReenviando(true); setReenviado(false);
    await api.reenviarVerificacion(emailSinVerificar);
    setReenviando(false); setReenviado(true);
  };
  const enviarRecuperacion = async () => {
    if (!emailRecuperar) { setErrRecuperar("Ingresa tu email"); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailRecuperar)) { setErrRecuperar("Email invalido"); return; }
    setErrRecuperar(""); setEnviandoRecuperar(true);
    const resp = await api.recuperarSolicitar(emailRecuperar);
    setEnviandoRecuperar(false);
    if (resp.ok) { setPantalla("recuperar-enviado"); }
    else { setErrRecuperar(resp.error||"No se pudo enviar el link"); }
  };

  if (pantalla==="recuperar"||pantalla==="recuperar-enviado") {
    return (
      <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",padding:"24px",background:"radial-gradient(ellipse at 50% 0%,rgba(0,212,255,.08) 0%,var(--bg) 60%)"}}>
        <div className="fi" style={{width:"100%",maxWidth:"320px"}}>
          <div style={{display:"flex",justifyContent:"center",marginBottom:"32px"}}>
            <div style={{background:"rgba(0,212,255,.06)",border:"1px solid rgba(0,212,255,.2)",borderRadius:"20px",padding:"16px 24px",display:"inline-flex",alignItems:"center",gap:"12px"}}>
              <LogoIcon size={48}/>
              <div>
                <div style={{fontWeight:900,fontSize:"22px",color:"white",lineHeight:1,fontFamily:"var(--font)"}}>INVERSOR<span style={{color:"var(--accent)"}}>App</span></div>
                <div style={{fontSize:"9px",letterSpacing:"3px",color:"var(--text3)",lineHeight:1.3,marginTop:"3px"}}>Registro de operaciones bursatiles</div>
              </div>
            </div>
          </div>
          {pantalla==="recuperar"?(
            <Card>
              <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"14px"}}>
                <button onClick={()=>{setPantalla("login");setErrRecuperar("");}} style={{width:"30px",height:"30px",borderRadius:"50%",background:"var(--surface2)",border:"1px solid var(--accent)",color:"var(--accent)",fontSize:"15px",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0}}>{"<"}</button>
                <div><div style={{fontWeight:700,fontSize:"15px"}}>Recuperar contrasena</div></div>
              </div>
              <p style={{fontSize:"13px",color:"var(--text3)",marginBottom:"14px"}}>Ingresa el email de tu cuenta y te enviaremos un link para crear una nueva contrasena.</p>
              <Field label="Email"><input type="email" value={emailRecuperar} onChange={e=>setEmailRecuperar(e.target.value)} placeholder="tu@email.com" autoCapitalize="none" onKeyDown={e=>e.key==="Enter"&&enviarRecuperacion()}/></Field>
              {errRecuperar&&<div style={{background:"rgba(255,77,109,.1)",border:"1px solid rgba(255,77,109,.3)",borderRadius:"var(--rs)",padding:"8px 12px",marginBottom:"10px",color:"var(--red)",fontSize:"12px"}}>{errRecuperar}</div>}
              <Btn onClick={enviarRecuperacion} disabled={enviandoRecuperar} style={{width:"100%"}} size="lg">{enviandoRecuperar?"Enviando...":"Enviar link de recuperacion"}</Btn>
            </Card>
          ):(
            <Card style={{textAlign:"center"}}>
              <div style={{fontSize:"40px",marginBottom:"10px",color:"var(--green)"}}>{"\u2713"}</div>
              <div style={{fontWeight:700,fontSize:"16px",marginBottom:"8px"}}>Revisa tu email</div>
              <p style={{fontSize:"13px",color:"var(--text3)",marginBottom:"16px"}}>Si <b style={{color:"var(--text)"}}>{emailRecuperar}</b> esta registrado en InversorApp, vas a recibir un link para crear una nueva contrasena en los proximos minutos.</p>
              <Btn variant="ghost" onClick={()=>{setPantalla("login");setEmailRecuperar("");}} style={{width:"100%"}}>Volver al inicio de sesion</Btn>
            </Card>
          )}
        </div>
      </div>
    );
  }

  return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",padding:"24px",background:"radial-gradient(ellipse at 50% 0%,rgba(0,212,255,.08) 0%,var(--bg) 60%)"}}>
      <div className="fi" style={{width:"100%",maxWidth:"320px"}}>
        <div style={{display:"flex",justifyContent:"center",marginBottom:"16px"}}>
          <div style={{background:"rgba(0,212,255,.06)",border:"1px solid rgba(0,212,255,.2)",borderRadius:"20px",padding:"16px 24px",display:"inline-flex",alignItems:"center",gap:"12px"}}>
            <LogoIcon size={48}/>
            <div>
              <div style={{fontWeight:900,fontSize:"22px",color:"white",lineHeight:1,fontFamily:"var(--font)"}}>INVERSOR<span style={{color:"var(--accent)"}}>App</span></div>
              <div style={{fontSize:"9px",letterSpacing:"3px",color:"var(--text3)",lineHeight:1.3,marginTop:"3px"}}>Registro de operaciones bursatiles</div>
            </div>
          </div>
        </div>
        <p style={{textAlign:"center",fontSize:"15px",fontWeight:700,color:"var(--text)",marginBottom:"16px"}}>Bienvenido</p>
        <Card>
          <Field label="Email"><input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="tu@email.com" disabled={estaBloqueado} onKeyDown={e=>e.key==="Enter"&&go()} autoCapitalize="none"/></Field>
          <Field label="Contrasena">
            <div style={{position:"relative"}}>
              <input type={showPw?"text":"password"} value={pw} onChange={e=>setPw(e.target.value)} placeholder="..." disabled={estaBloqueado} onKeyDown={e=>e.key==="Enter"&&go()} style={{paddingRight:"42px"}}/>
              <button onClick={()=>setShowPw(s=>!s)} style={{position:"absolute",right:"10px",top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:"var(--text3)",cursor:"pointer",fontSize:"14px"}}>{showPw?"O":"o"}</button>
            </div>
          </Field>
          {intentos>0&&intentos<MAX_INTENTOS&&(
            <div style={{display:"flex",justifyContent:"center",gap:"5px",marginBottom:"8px"}}>
              {[...Array(MAX_INTENTOS)].map((_,i)=><div key={i} style={{width:"8px",height:"8px",borderRadius:"50%",background:i<intentos?"var(--red)":"var(--border)"}}/>)}
            </div>
          )}
          {err&&<div style={{background:"rgba(255,77,109,.1)",border:"1px solid rgba(255,77,109,.3)",borderRadius:"var(--rs)",padding:"8px 12px",marginBottom:"10px",color:"var(--red)",fontSize:"12px"}}>{estaBloqueado?"Bloqueado "+tiempoRestante()+" min":err}</div>}
          {emailSinVerificar&&(
            <div style={{background:"rgba(251,191,36,.08)",border:"1px solid rgba(251,191,36,.35)",borderRadius:"var(--rs)",padding:"12px",marginBottom:"10px"}}>
              <p style={{fontSize:"12px",color:"var(--text)",margin:0,lineHeight:1.5}}>Verifica tu email para ingresar. Enviamos un link de confirmacion a <b>{emailSinVerificar}</b>.</p>
              <Btn onClick={reenviarVerificacion} disabled={reenviando||reenviado} style={{width:"100%",marginTop:"10px",background:reenviado?"var(--green)":undefined}} size="sm">{reenviando?"Enviando...":reenviado?"Email enviado, revisa tu bandeja":"Reenviar email de verificacion"}</Btn>
              <p style={{textAlign:"center",marginTop:"8px",fontSize:"11px",color:"var(--text3)",cursor:"pointer"}} onClick={()=>{setEmailSinVerificar("");setReenviado(false);}}>Volver al login</p>
            </div>
          )}
          <Btn onClick={go} disabled={loading||estaBloqueado} style={{width:"100%"}} size="lg">{loading?"Ingresando...":estaBloqueado?"Bloqueado":"Ingresar"}</Btn>
          <p style={{textAlign:"center",marginTop:"12px",fontSize:"12px",color:"var(--text2)"}}>Olvidaste tu contrasena? <span style={{color:"var(--accent)",cursor:"pointer"}} onClick={()=>setPantalla("recuperar")}>Recuperar acceso</span></p>
        </Card>
        <div style={{marginTop:"14px",padding:"14px",background:"var(--surface)",border:"1px solid var(--border)",borderRadius:"var(--r)",textAlign:"center"}}>
          <p style={{fontSize:"13px",color:"var(--text3)",marginBottom:"10px"}}>No tenes cuenta?</p>
          <Btn variant="ghost" onClick={()=>onRegistro()} style={{width:"100%"}}>Crear cuenta gratis</Btn>
        </div>
      </div>
    </div>
  );
};

const NuevaPasswordScreen = ({token,onListo}) => {
  const [pw,setPw] = useState("");
  const [pw2,setPw2] = useState("");
  const [showPw,setShowPw] = useState(false);
  const [err,setErr] = useState("");
  const [loading,setLoading] = useState(false);
  const [exito,setExito] = useState(false);

  const guardar = async () => {
    if (pw.length<6) { setErr("La contrasena debe tener al menos 6 caracteres"); return; }
    if (pw!==pw2) { setErr("Las contrasenas no coinciden"); return; }
    setErr(""); setLoading(true);
    const resp = await api.recuperarConfirmar(token, pw);
    setLoading(false);
    if (resp.ok) { setExito(true); }
    else { setErr(resp.error||"El link vencio o no es valido"); }
  };

  return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",padding:"24px",background:"radial-gradient(ellipse at 50% 0%,rgba(0,212,255,.08) 0%,var(--bg) 60%)"}}>
      <div className="fi" style={{width:"100%",maxWidth:"320px"}}>
        <div style={{display:"flex",justifyContent:"center",marginBottom:"16px"}}>
          <div style={{background:"rgba(0,212,255,.06)",border:"1px solid rgba(0,212,255,.2)",borderRadius:"20px",padding:"16px 24px",display:"inline-flex",alignItems:"center",gap:"12px"}}>
            <LogoIcon size={48}/>
            <div>
              <div style={{fontWeight:900,fontSize:"22px",color:"white",lineHeight:1,fontFamily:"var(--font)"}}>INVERSOR<span style={{color:"var(--accent)"}}>App</span></div>
              <div style={{fontSize:"9px",letterSpacing:"3px",color:"var(--text3)",lineHeight:1.3,marginTop:"3px"}}>Registro de operaciones bursatiles</div>
            </div>
          </div>
        </div>
        {exito?(
          <Card style={{textAlign:"center"}}>
            <div style={{fontSize:"40px",marginBottom:"10px",color:"var(--green)"}}>{"\u2713"}</div>
            <div style={{fontWeight:700,fontSize:"16px",marginBottom:"8px"}}>Contrasena actualizada</div>
            <p style={{fontSize:"13px",color:"var(--text3)",marginBottom:"16px"}}>Ya podes ingresar con tu nueva contrasena.</p>
            <Btn onClick={onListo} style={{width:"100%"}}>Ir a iniciar sesion</Btn>
          </Card>
        ):(
          <Card>
            <p style={{fontWeight:700,fontSize:"15px",marginBottom:"12px",textAlign:"center"}}>Crear nueva contrasena</p>
            <Field label="Nueva contrasena" hint="Minimo 6 caracteres">
              <div style={{position:"relative"}}>
                <input type={showPw?"text":"password"} value={pw} onChange={e=>setPw(e.target.value)} placeholder="..." style={{paddingRight:"42px"}}/>
                <button onClick={()=>setShowPw(s=>!s)} style={{position:"absolute",right:"10px",top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:"var(--text3)",cursor:"pointer"}}>{showPw?"O":"o"}</button>
              </div>
            </Field>
            <Field label="Confirmar nueva contrasena"><input type={showPw?"text":"password"} value={pw2} onChange={e=>setPw2(e.target.value)} placeholder="..." onKeyDown={e=>e.key==="Enter"&&guardar()}/></Field>
            {err&&<div style={{background:"rgba(255,77,109,.1)",border:"1px solid rgba(255,77,109,.3)",borderRadius:"var(--rs)",padding:"8px 12px",marginBottom:"10px",color:"var(--red)",fontSize:"12px"}}>{err}</div>}
            <Btn onClick={guardar} disabled={loading} style={{width:"100%"}} size="lg">{loading?"Guardando...":"Guardar nueva contrasena"}</Btn>
          </Card>
        )}
      </div>
    </div>
  );
};

const RegistroScreen = ({onVolver,onRegistroExitoso,usuarios}) => {
  const [form,setForm] = useState({nombre:"",email:"",password:"",confirmPassword:"",celular:"",pais:"Argentina",fechaNacimiento:"",direccion:"",localidad:"",provincia:""});
  const [showPw,setShowPw] = useState(false);
  const [showPw2,setShowPw2] = useState(false);
  const [err,setErr] = useState("");
  const [loading,setLoading] = useState(false);
  const [exito,setExito] = useState(false);
  const set = (k,v) => { setForm(f=>({...f,[k]:v})); setErr(""); };
  const validar = () => {
    if (!form.nombre.trim()) return "El nombre es obligatorio";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) return "Email invalido";
    if (form.password.length<6) return "Contrasena minimo 6 caracteres";
    if (form.password!==form.confirmPassword) return "Las contrasenas no coinciden";
    if (!form.celular.trim()) return "El celular es obligatorio";
    return null;
  };
  const handleRegistro = async () => {
    const error=validar(); if (error) { setErr(error); return; }
    setLoading(true); setErr("");
    const resp = await api.registro({
      nombre: form.nombre.trim(),
      email: form.email.toLowerCase(),
      password: form.password,
      celular: form.celular,
      pais: form.pais,
      fechaNacimiento: form.fechaNacimiento,
      direccion: form.direccion,
      localidad: form.localidad,
      provincia: form.provincia
    });
    if (resp.ok) {
      setExito(true); setLoading(false);
      setTimeout(()=>onRegistroExitoso(resp.usuario),1500);
    } else {
      setErr(resp.error || "No se pudo crear la cuenta");
      setLoading(false);
    }
  };
  if (exito) return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"var(--bg)"}}>
      <div style={{textAlign:"center"}} className="fi">
        <div style={{fontSize:"56px",marginBottom:"14px",color:"var(--green)"}}>OK</div>
        <h2 style={{fontSize:"22px",fontWeight:800,marginBottom:"8px"}}>Cuenta creada!</h2>
        <p style={{color:"var(--text3)"}}>Bienvenido, {form.nombre.split(" ")[0]}!</p>
      </div>
    </div>
  );
  return (
    <div style={{minHeight:"100vh",background:"var(--bg)",overflowY:"auto"}}>
      <div style={{maxWidth:"360px",margin:"0 auto",padding:"24px"}}>
        <div style={{display:"flex",alignItems:"center",gap:"12px",marginBottom:"24px"}}>
          <button onClick={onVolver} style={{width:"36px",height:"36px",borderRadius:"50%",background:"var(--surface)",border:"1px solid var(--accent)",color:"var(--accent)",fontSize:"18px",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>{"<"}</button>
          <div><h1 style={{fontSize:"20px",fontWeight:800}}>Crear cuenta</h1><p style={{fontSize:"12px",color:"var(--text3)"}}>InversorApp - Gratis</p></div>
        </div>
        <Card>
          <Field label="Nombre completo"><input value={form.nombre} onChange={e=>set("nombre",e.target.value)} placeholder="Juan Perez"/></Field>
          <Field label="Email"><input type="email" value={form.email} onChange={e=>set("email",e.target.value)} placeholder="tu@email.com" autoCapitalize="none"/></Field>
          <Field label="Celular" hint="Con codigo de pais. Ej: +54 9 11 1234-5678"><input type="tel" value={form.celular} onChange={e=>set("celular",e.target.value)} placeholder="+54 9 11 1234-5678"/></Field>
          <Field label="Pais"><select value={form.pais} onChange={e=>set("pais",e.target.value)}>{PAISES.map(p=><option key={p}>{p}</option>)}</select></Field>
          <Field label="Fecha de nacimiento" hint="Opcional"><InputFecha value={form.fechaNacimiento} onChange={v=>set("fechaNacimiento",v)}/></Field>
          <Field label="Direccion" hint="Opcional"><input value={form.direccion} onChange={e=>set("direccion",e.target.value)} placeholder="Av. Siempreviva 742"/></Field>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px"}}>
            <Field label="Localidad" hint="Opcional"><input value={form.localidad} onChange={e=>set("localidad",e.target.value)} placeholder="Springfield"/></Field>
            <Field label="Provincia" hint="Opcional"><input value={form.provincia} onChange={e=>set("provincia",e.target.value)} placeholder="Buenos Aires"/></Field>
          </div>
          <Field label="Contrasena" hint="Minimo 6 caracteres">
            <div style={{position:"relative"}}>
              <input type={showPw?"text":"password"} value={form.password} onChange={e=>set("password",e.target.value)} placeholder="..." style={{paddingRight:"42px"}}/>
              <button onClick={()=>setShowPw(s=>!s)} style={{position:"absolute",right:"10px",top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:"var(--text3)",cursor:"pointer"}}>{showPw?"O":"o"}</button>
            </div>
          </Field>
          {form.password.length>0&&(
            <div style={{marginBottom:"10px"}}>
              <div style={{display:"flex",gap:"4px",marginBottom:"3px"}}>
                {[1,2,3,4].map(i=><div key={i} style={{flex:1,height:"3px",borderRadius:"2px",background:form.password.length>=8&&/[A-Z]/.test(form.password)&&/[0-9]/.test(form.password)?"var(--green)":form.password.length>=6?(i<=2?"var(--yellow)":"var(--border)"):(i<=1?"var(--red)":"var(--border)")}}/>)}
              </div>
              <p style={{fontSize:"10px",color:"var(--text2)"}}>{form.password.length>=8&&/[A-Z]/.test(form.password)&&/[0-9]/.test(form.password)?"Contrasena fuerte":form.password.length>=6?"Contrasena aceptable":"Contrasena debil"}</p>
            </div>
          )}
          <Field label="Confirmar contrasena">
            <div style={{position:"relative"}}>
              <input type={showPw2?"text":"password"} value={form.confirmPassword} onChange={e=>set("confirmPassword",e.target.value)} placeholder="..." style={{paddingRight:"42px"}}/>
              <button onClick={()=>setShowPw2(s=>!s)} style={{position:"absolute",right:"10px",top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:"var(--text3)",cursor:"pointer"}}>{showPw2?"O":"o"}</button>
            </div>
          </Field>
          {err&&<div style={{background:"rgba(255,77,109,.1)",border:"1px solid rgba(255,77,109,.3)",borderRadius:"var(--rs)",padding:"8px 12px",marginBottom:"10px",color:"var(--red)",fontSize:"12px"}}>{err}</div>}
          <Btn onClick={handleRegistro} disabled={loading} style={{width:"100%"}} size="lg">{loading?"Creando cuenta...":"Crear cuenta"}</Btn>
        </Card>
        <p style={{textAlign:"center",marginTop:"14px",fontSize:"12px",color:"var(--text3)"}}>Ya tenes cuenta? <span onClick={onVolver} style={{color:"var(--accent)",cursor:"pointer"}}>Iniciar sesion</span></p>
      </div>
    </div>
  );
};

const PerfilScreen = ({user,onClose,onSave}) => {
  const [form,setForm] = useState({nombre:user.nombre||"",celular:user.celular||"",pais:user.pais||"Argentina",fechaNacimiento:user.fechaNacimiento||"",direccion:user.direccion||"",localidad:user.localidad||"",provincia:user.provincia||"",comision:user.comision||"1"});
  const [pwForm,setPwForm] = useState({pwActual:"",pwNuevo:"",pwConfirm:""});
  const [showPw,setShowPw] = useState(false);
  const [guardando,setGuardando] = useState(false);
  const [saved,setSaved] = useState(false);
  const [cambiandoPw,setCambiandoPw] = useState(false);
  const [pwSaved,setPwSaved] = useState(false);
  const [err,setErr] = useState("");
  const [errPw,setErrPw] = useState("");
  const set = (k,v) => { setForm(f=>({...f,[k]:v})); setErr(""); };
  const setPw = (k,v) => { setPwForm(f=>({...f,[k]:v})); setErrPw(""); };

  const guardar = async () => {
    if (!form.nombre.trim()) { setErr("El nombre es obligatorio"); return; }
    if (parseFloat(form.comision)<0||parseFloat(form.comision)>10) { setErr("Comision entre 0 y 10%"); return; }
    setGuardando(true);
    const resp = await api.perfilEditar({
      nombre: form.nombre.trim(), celular: form.celular, pais: form.pais,
      fechaNacimiento: form.fechaNacimiento, direccion: form.direccion,
      localidad: form.localidad, provincia: form.provincia, comision: form.comision
    });
    setGuardando(false);
    if (!resp.ok) { setErr(resp.error||"No se pudo guardar"); return; }
    onSave({...user,...form,nombre:form.nombre.trim()});
    setSaved(true); setTimeout(()=>setSaved(false),2000);
  };

  const cambiarPassword = async () => {
    if (!pwForm.pwActual||!pwForm.pwNuevo) { setErrPw("Completa ambos campos"); return; }
    if (pwForm.pwNuevo.length<6) { setErrPw("Nueva contrasena minimo 6 caracteres"); return; }
    if (pwForm.pwNuevo!==pwForm.pwConfirm) { setErrPw("Las contrasenas no coinciden"); return; }
    setCambiandoPw(true);
    const resp = await api.perfilPassword({ passwordActual: pwForm.pwActual, passwordNueva: pwForm.pwNuevo });
    setCambiandoPw(false);
    if (!resp.ok) { setErrPw(resp.error||"No se pudo cambiar la contrasena"); return; }
    setPwForm({pwActual:"",pwNuevo:"",pwConfirm:""});
    setPwSaved(true); setTimeout(()=>setPwSaved(false),2500);
  };

  return (
    <div style={{display:"flex",flexDirection:"column",height:"100%"}}>
      <div style={{display:"flex",alignItems:"center",gap:"12px",padding:"14px 16px",borderBottom:"1px solid var(--border)",background:"var(--surface)",flexShrink:0}}>
        <button onClick={onClose} style={{width:"32px",height:"32px",borderRadius:"50%",background:"var(--surface2)",border:"1px solid var(--accent)",color:"var(--accent)",fontSize:"16px",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>{"<"}</button>
        <h2 style={{fontSize:"17px",fontWeight:700}}>Mi perfil</h2>
      </div>
      <div style={{flex:1,overflowY:"auto",padding:"16px"}}>
        <div style={{textAlign:"center",marginBottom:"20px"}}>
          <div style={{width:"60px",height:"60px",borderRadius:"50%",background:"linear-gradient(135deg,var(--accent),var(--accent2))",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"22px",fontWeight:800,color:"#0a0e1a",margin:"0 auto 8px"}}>{user.nombre.charAt(0).toUpperCase()}</div>
          <div style={{fontSize:"13px",color:"var(--text3)"}}>{user.email}</div>
          <div style={{marginTop:"4px",display:"flex",justifyContent:"center",gap:"6px"}}>
            <Badge variant={user.rol==="admin"?"admin":"default"} size="sm">{user.rol}</Badge>
            {esPro(user)&&<Badge variant="compra" size="sm">PRO</Badge>}
          </div>
        </div>
        <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",textTransform:"uppercase",marginBottom:"10px"}}>Datos personales</p>
        <Field label="Nombre completo"><input value={form.nombre} onChange={e=>set("nombre",e.target.value)}/></Field>
        <Field label="Celular"><input value={form.celular} onChange={e=>set("celular",e.target.value)}/></Field>
        <Field label="Pais"><select value={form.pais} onChange={e=>set("pais",e.target.value)}>{PAISES.map(p=><option key={p}>{p}</option>)}</select></Field>
        <Field label="Fecha de nacimiento" hint="Opcional"><InputFecha value={form.fechaNacimiento} onChange={v=>set("fechaNacimiento",v)}/></Field>
        <Field label="Direccion" hint="Opcional"><input value={form.direccion} onChange={e=>set("direccion",e.target.value)}/></Field>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px"}}>
          <Field label="Localidad" hint="Opcional"><input value={form.localidad} onChange={e=>set("localidad",e.target.value)}/></Field>
          <Field label="Provincia" hint="Opcional"><input value={form.provincia} onChange={e=>set("provincia",e.target.value)}/></Field>
        </div>
        <p style={{fontSize:"11px",color:"var(--accent)",fontWeight:700,letterSpacing:".06em",textTransform:"uppercase",marginBottom:"10px",marginTop:"16px"}}>Mi comision habitual</p>
        <Card style={{marginBottom:"16px",border:"1px solid rgba(0,212,255,.2)"}}>
          <Field label="Comision (%)" hint="Se pre-rellena en cada operacion nueva">
            <input type="number" step="0.1" min="0" max="10" value={form.comision} onChange={e=>set("comision",e.target.value)}/>
          </Field>
          <div style={{display:"flex",gap:"6px",flexWrap:"wrap",marginTop:"4px"}}>
            {[["Galicia","1.2"],["Balanz","0.5"],["IOL","1.0"],["PPI","0.5"]].map(([b,c])=>(
              <button key={b} onClick={()=>set("comision",c)} style={{padding:"4px 10px",borderRadius:"100px",fontSize:"11px",fontWeight:600,background:form.comision===c?"var(--accent)":"var(--surface2)",color:form.comision===c?"#0a0e1a":"var(--text3)",border:form.comision===c?"1px solid var(--accent)":"1px solid var(--border)",cursor:"pointer"}}>{b} ({c}%)</button>
            ))}
          </div>
        </Card>
        {err&&<div style={{background:"rgba(255,77,109,.1)",border:"1px solid rgba(255,77,109,.3)",borderRadius:"var(--rs)",padding:"8px 12px",marginBottom:"10px",color:"var(--red)",fontSize:"12px"}}>{err}</div>}
        <Btn onClick={guardar} disabled={guardando} variant={saved?"success":"primary"} style={{width:"100%",marginBottom:"24px"}}>{guardando?"Guardando...":saved?"Guardado":"Guardar cambios"}</Btn>

        <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",textTransform:"uppercase",marginBottom:"10px"}}>Cambiar contrasena</p>
        <Field label="Contrasena actual"><input type={showPw?"text":"password"} value={pwForm.pwActual} onChange={e=>setPw("pwActual",e.target.value)} placeholder="..."/></Field>
        <Field label="Nueva contrasena"><input type={showPw?"text":"password"} value={pwForm.pwNuevo} onChange={e=>setPw("pwNuevo",e.target.value)} placeholder="Minimo 6 caracteres"/></Field>
        <div style={{position:"relative"}}>
          <Field label="Confirmar nueva contrasena"><input type={showPw?"text":"password"} value={pwForm.pwConfirm} onChange={e=>setPw("pwConfirm",e.target.value)} placeholder="..." style={{paddingRight:"42px"}}/></Field>
          <button onClick={()=>setShowPw(s=>!s)} style={{position:"absolute",right:"10px",bottom:"9px",background:"none",border:"none",color:"var(--text3)",cursor:"pointer",fontSize:"14px"}}>{showPw?"O":"o"}</button>
        </div>
        {errPw&&<div style={{background:"rgba(255,77,109,.1)",border:"1px solid rgba(255,77,109,.3)",borderRadius:"var(--rs)",padding:"8px 12px",marginBottom:"10px",color:"var(--red)",fontSize:"12px"}}>{errPw}</div>}
        <Btn onClick={cambiarPassword} disabled={cambiandoPw} variant={pwSaved?"success":"primary"} style={{width:"100%",marginBottom:"16px"}}>{cambiandoPw?"Cambiando...":pwSaved?"Contrasena actualizada":"Cambiar contrasena"}</Btn>
      </div>
    </div>
  );
};

const CambioObligatorioScreen = ({user,onCambiado}) => {
  const [pwActual,setPwActual] = useState("");
  const [pwNuevo,setPwNuevo] = useState("");
  const [pwConfirm,setPwConfirm] = useState("");
  const [showPw,setShowPw] = useState(false);
  const [cambiando,setCambiando] = useState(false);
  const [err,setErr] = useState("");

  const confirmar = async () => {
    if (!pwActual||!pwNuevo) { setErr("Completa ambos campos"); return; }
    if (pwNuevo.length<6) { setErr("La nueva contrasena debe tener al menos 6 caracteres"); return; }
    if (pwNuevo!==pwConfirm) { setErr("Las contrasenas no coinciden"); return; }
    setCambiando(true);
    const resp = await api.perfilPassword({ passwordActual: pwActual, passwordNueva: pwNuevo });
    setCambiando(false);
    if (!resp.ok) { setErr(resp.error||"No se pudo cambiar la contrasena"); return; }
    onCambiado();
  };

  return (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100%",padding:"24px"}}>
      <div style={{width:"100%",maxWidth:"360px"}}>
        <div style={{textAlign:"center",marginBottom:"20px"}}>
          <LogoIcon size={44}/>
          <h2 style={{fontSize:"18px",fontWeight:700,marginTop:"12px"}}>Tenes que cambiar tu contrasena</h2>
          <p style={{fontSize:"13px",color:"var(--text3)",marginTop:"6px"}}>Un admin reseteo tu acceso. Antes de seguir, elegi una contrasena nueva que solo vos conozcas.</p>
        </div>
        <Field label="Contrasena temporal (la que te pasaron)"><input type={showPw?"text":"password"} value={pwActual} onChange={e=>{setPwActual(e.target.value);setErr("");}} placeholder="..."/></Field>
        <Field label="Nueva contrasena"><input type={showPw?"text":"password"} value={pwNuevo} onChange={e=>{setPwNuevo(e.target.value);setErr("");}} placeholder="Minimo 6 caracteres"/></Field>
        <div style={{position:"relative"}}>
          <Field label="Confirmar nueva contrasena"><input type={showPw?"text":"password"} value={pwConfirm} onChange={e=>{setPwConfirm(e.target.value);setErr("");}} placeholder="..." style={{paddingRight:"42px"}}/></Field>
          <button onClick={()=>setShowPw(s=>!s)} style={{position:"absolute",right:"10px",bottom:"9px",background:"none",border:"none",color:"var(--text3)",cursor:"pointer",fontSize:"14px"}}>{showPw?"O":"o"}</button>
        </div>
        {err&&<div style={{background:"rgba(255,77,109,.1)",border:"1px solid rgba(255,77,109,.3)",borderRadius:"var(--rs)",padding:"8px 12px",marginBottom:"10px",color:"var(--red)",fontSize:"12px"}}>{err}</div>}
        <Btn onClick={confirmar} disabled={cambiando} style={{width:"100%",marginTop:"6px"}} size="lg">{cambiando?"Cambiando...":"Confirmar y continuar"}</Btn>
      </div>
    </div>
  );
};

const NavBar = ({tab,setTab,user}) => {
  const tabs = [
    {id:"operaciones",icon:"OPS",label:"Ops"},
    {id:"activos",icon:"ACT",label:"Activos"},
    {id:"resumen",icon:"RES",label:"Resumen"},
    {id:"simulador",icon:"SIM",label:"Simular"},
    ...(ASESOR_HABILITADO?[{id:"asesor",icon:"IA",label:"Asesor"}]:[]),
    {id:"alertas",icon:"ALE",label:"Alertas"},
    ...(user.rol==="admin"?[{id:"admin",icon:"ADM",label:"Admin"}]:[]),
  ];
  return (
    <div style={{display:"flex",justifyContent:"space-between",background:"rgba(17,24,39,.97)",borderTop:"1px solid var(--border)",padding:"8px 4px 12px",overflowX:"auto",gap:"2px"}}>
      {tabs.map(t=>(
        <button key={t.id} onClick={()=>setTab(t.id)} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:"2px",background:tab===t.id?"rgba(0,212,255,.1)":"transparent",border:"none",padding:"5px 6px",borderRadius:"9px",cursor:"pointer",flex:"1 1 0",minWidth:0}}>
          <span style={{fontSize:"10px",fontWeight:800,color:tab===t.id?"var(--accent)":"var(--text3)"}}>{t.icon}</span>
          <span style={{fontSize:"9px",fontWeight:700,color:tab===t.id?"var(--accent)":"var(--text2)",whiteSpace:"nowrap"}}>{t.label}</span>
        </button>
      ))}
    </div>
  );
};

const PantallaNewOp = ({activos,configData,user,operaciones,onClose,onGuardar,onListo}) => {
  const comisionDefault = user.comision||configData.comision||"1";
  const [form,setForm] = useState({ticker:"",tipo:"COMPRA",tipoActivo:"Cedear",fecha:new Date().toLocaleDateString("es-AR"),cantidad:"",precio:"",moneda:"ARS",broker:"Galicia",notas:"",comision:comisionDefault});
  const [error,setError] = useState("");
  const [guardando,setGuardando] = useState(false);
  const [operacionGuardada,setOperacionGuardada] = useState(null);
  const set = (k,v) => { setForm(f=>({...f,[k]:v})); setError(""); };
  const comision = parseFloat(form.comision||comisionDefault)/100;
  const total = parseFloat(form.precio||0)*parseFloat(form.cantidad||0);
  const totalNeto = total*(1+comision);
  const tiposDisponibles = [...new Set(activos.map(a=>a.tipo))].sort();
  const activosDelTipo = activos.filter(a=>a.tipo===form.tipoActivo);
  const esCripto = activos.find(a=>a.ticker===form.ticker)?.tipo==="Cripto";
  const posActual = form.ticker ? calcPosicion(operaciones,user.id,form.ticker) : null;
  const yaTiene = posActual&&posActual.cantidad>0;
  const ok = form.ticker&&form.cantidad&&form.precio;

  const handleGuardar = async () => {
    if (!ok) return;
    setError(""); setGuardando(true);
    const activo = activos.find(a=>a.ticker===form.ticker);
    const opData = {id:Date.now().toString(),userId:user.id,activoId:activo?.id||"",ticker:form.ticker,tipo:form.tipo,fecha:form.fecha,cantidad:form.cantidad,precio:form.precio,moneda:form.moneda,broker:form.broker,notas:form.notas,comision:form.comision};
    const resultado = await onGuardar(opData);
    setGuardando(false);
    if (resultado) { setOperacionGuardada(resultado); }
    else { setError("No se pudo registrar la compra"); }
  };

  if (operacionGuardada) {
    return (
      <div style={{display:"flex",flexDirection:"column",height:"100%"}}>
        <div style={{background:"var(--surface)",borderBottom:"1px solid var(--border)",padding:"12px 14px",flexShrink:0}}>
          <h2 style={{fontSize:"16px",fontWeight:700}}>Compra registrada</h2>
        </div>
        <div className="scroll-area" style={{flex:1,overflowY:"auto",padding:"14px"}}>
          <Card style={{marginBottom:"14px",border:"1px solid rgba(0,212,255,.25)",textAlign:"center"}}>
            <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginBottom:"6px"}}>TOTAL INVERTIDO</p>
            <div style={{fontFamily:"var(--mono)",fontWeight:800,fontSize:"22px",color:"var(--accent)"}}>{formatMoney(totalNeto,form.moneda)}</div>
          </Card>
          <p style={{fontSize:"13px",color:"var(--text3)",textAlign:"center",lineHeight:1.5}}>Compraste {form.cantidad} titulos de {form.ticker} a un precio de {formatMoney(form.precio,form.moneda)} cada uno.</p>
          <Btn onClick={onListo} style={{width:"100%",marginTop:"20px"}} size="lg">Listo</Btn>
        </div>
      </div>
    );
  }

  return (
    <div style={{display:"flex",flexDirection:"column",height:"100%"}}>
      <div style={{background:"var(--surface)",borderBottom:"1px solid var(--border)",padding:"12px 14px",flexShrink:0}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"10px"}}>
          <button onClick={onClose} style={{width:"32px",height:"32px",borderRadius:"50%",background:"var(--surface2)",border:"1px solid var(--accent)",color:"var(--accent)",fontSize:"16px",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>{"<"}</button>
          <h2 style={{fontSize:"16px",fontWeight:700}}>{form.ticker?"Comprar "+form.ticker:"Registrar Compra"}</h2>
        </div>
        {error&&<div style={{background:"rgba(255,77,109,.1)",border:"1px solid rgba(255,77,109,.3)",borderRadius:"var(--rs)",padding:"7px 10px",marginBottom:"8px",color:"var(--red)",fontSize:"12px"}}>{error}</div>}
        <div style={{display:"flex",gap:"8px"}}>
          <Btn variant="ghost" onClick={onClose} style={{flex:1}}>Cancelar</Btn>
          <Btn onClick={handleGuardar} disabled={!ok||guardando} style={{flex:2}}>{guardando?"Guardando...":"Registrar compra"}</Btn>
        </div>
      </div>
      <div className="scroll-area" style={{flex:1,overflowY:"auto",padding:"14px"}}>
        <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginBottom:"8px"}}>DATOS DEL ACTIVO</p>
        <Field label="Moneda"><select value={form.moneda} onChange={e=>set("moneda",e.target.value)}><option value="ARS">Pesos</option><option value="USD">Dolares</option></select></Field>
        <Field label="Tipo de activo"><select value={form.tipoActivo} onChange={e=>{set("tipoActivo",e.target.value);set("ticker","");}}>{tiposDisponibles.map(t=><option key={t}>{t}</option>)}</select></Field>
        <Field label={"Activo ("+form.tipoActivo+")"}><BuscadorActivo activos={activosDelTipo} value={form.ticker} onChange={v=>set("ticker",v)} placeholder="Buscar ticker o nombre..."/></Field>

        {yaTiene&&(
          <Card style={{marginBottom:"14px",border:"1px solid rgba(0,212,255,.2)"}}>
            <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginBottom:"8px"}}>YA TENES {form.ticker}</p>
            <div style={{display:"flex",gap:"8px"}}>
              <div style={{flex:1,background:"var(--surface2)",borderRadius:"var(--rs)",padding:"8px",textAlign:"center"}}>
                <div style={{fontSize:"10px",color:"var(--text3)",marginBottom:"2px"}}>Titulos que tenes</div>
                <div style={{fontFamily:"var(--mono)",fontWeight:800,fontSize:"16px"}}>{posActual.cantidad}</div>
              </div>
              <div style={{flex:1,background:"var(--surface2)",borderRadius:"var(--rs)",padding:"8px",textAlign:"center"}}>
                <div style={{fontSize:"10px",color:"var(--text3)",marginBottom:"2px"}}>Precio promedio actual</div>
                <div style={{fontFamily:"var(--mono)",fontWeight:800,fontSize:"16px",color:"var(--yellow)"}}>{formatMoney(posActual.promedio,form.moneda)}</div>
              </div>
            </div>
          </Card>
        )}

        <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginTop:"14px",marginBottom:"8px"}}>DATOS DE LA COMPRA</p>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px"}}>
          <Field label="Cantidad"><input type="number" step={esCripto?"any":"1"} value={form.cantidad} onChange={e=>set("cantidad",e.target.value)} placeholder="0"/></Field>
          <Field label="Precio unitario"><input type="number" value={form.precio} onChange={e=>set("precio",e.target.value)} placeholder="0.00"/></Field>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px"}}>
          <Field label="Fecha de la compra"><InputFecha value={form.fecha} onChange={v=>set("fecha",v)} placeholder="DD/MM/AAAA"/></Field>
          <Field label="Broker"><select value={form.broker} onChange={e=>set("broker",e.target.value)}>{["Galicia","Balanz","IOL","PPI","Otro"].map(b=><option key={b}>{b}</option>)}</select></Field>
        </div>
        <Field label="Comision (%)" hint="Se aplica sobre el total de la compra"><input type="number" step="0.1" min="0" max="10" value={form.comision} onChange={e=>set("comision",e.target.value)}/></Field>
        <Field label="Notas" hint="Opcional"><input value={form.notas} onChange={e=>set("notas",e.target.value)} placeholder="Observaciones..."/></Field>

        {total>0&&(
          <Card style={{background:"var(--surface2)",marginTop:"4px"}}>
            {[["Subtotal",formatMoney(total,form.moneda)],["Comision ("+form.comision+"%)","- "+formatMoney(total*comision,form.moneda)]].map(([k,v])=>(
              <div key={k} style={{display:"flex",justifyContent:"space-between",fontSize:"13px",marginBottom:"5px"}}><span style={{color:"var(--text3)"}}>{k}</span><span style={{fontFamily:"var(--mono)"}}>{v}</span></div>
            ))}
            <div style={{display:"flex",justifyContent:"space-between",fontSize:"14px",fontWeight:700,borderTop:"1px solid var(--border)",paddingTop:"7px",marginTop:"2px"}}><span>Total invertido</span><span style={{fontFamily:"var(--mono)",color:"var(--accent)"}}>{formatMoney(totalNeto,form.moneda)}</span></div>
          </Card>
        )}
      </div>
    </div>
  );
};

// ============================================================
// VENDER POR LOTE - componente NUEVO, no reemplaza PantallaNewOp
// ============================================================
const PantallaVenderLote = ({activos,operaciones,user,configData,ipc,onClose,onSave}) => {
  const comisionDefault = user.comision||configData.comision||"1";
  const misTickersOperados = [...new Set(operaciones.filter(o=>o.userId===user.id).map(o=>o.ticker))];
  const posiciones = misTickersOperados.map(ticker=>{
    const a = activos.find(x=>x.ticker===ticker);
    return {ticker,nombre:a?.nombre||ticker,tipo:a?.tipo||"",pos:calcPosicion(operaciones,user.id,ticker)};
  }).filter(a=>a.pos.cantidad>0);
  const [ticker,setTicker] = useState("");
  const [lotes,setLotes] = useState([]);
  const [cantidadesElegidas,setCantidadesElegidas] = useState({});
  const [preciosElegidos,setPreciosElegidos] = useState({});
  const [cargandoLotes,setCargandoLotes] = useState(false);
  const [form,setForm] = useState({fecha:new Date().toLocaleDateString("es-AR"),moneda:"ARS",broker:"Galicia",notas:"",comision:comisionDefault});
  const [error,setError] = useState("");
  const [guardando,setGuardando] = useState(false);
  const [resultadoVenta,setResultadoVenta] = useState(null);
  const [operacionGuardada,setOperacionGuardada] = useState(null);

  // Esta es la pantalla donde registras de verdad las ventas que
  // hiciste, lote por lote (misma interfaz que Simular ventas). Cada
  // compra tuya es un renglon independiente y elegis vos de cual (o
  // de varias a la vez) vender, cuanto, y a que precio, para que el
  // registro refleje exactamente lo que paso.
  const elegirTicker = async (t) => {
    setTicker(t); setCantidadesElegidas({}); setPreciosElegidos({}); setError("");
    if (!t) { setLotes([]); return; }
    setCargandoLotes(true);
    const resp = await api.lotesDisponibles(t);
    setCargandoLotes(false);
    // El backend devuelve la fecha de compra como "fecha"; la
    // guardamos tambien como "fechaCompra" para los calculos.
    if (resp.ok) setLotes(resp.lotes.map(l=>({...l,fechaCompra:l.fecha}))); else setLotes([]);
    const opTicker = operaciones.find(o=>o.ticker===t);
    if (opTicker) setForm(f=>({...f,moneda:opTicker.moneda}));
  };

  const setCantidadLote = (loteId, valor, maxDisp) => {
    let v = valor===""?"":Math.min(parseFloat(valor)||0, maxDisp);
    setCantidadesElegidas(p=>({...p,[loteId]:v}));
  };
  const setPrecioLote = (loteId, valor) => {
    setPreciosElegidos(p=>({...p,[loteId]:valor}));
  };

  const posicionActual = ticker ? calcPosicion(operaciones,user.id,ticker) : null;
  const monedaLotes = lotes[0]?.moneda||form.moneda||"ARS";
  const totalElegido = Object.values(cantidadesElegidas).reduce((s,v)=>s+(parseFloat(v)||0),0);
  const lotesElegidos = lotes.filter(l=>parseFloat(cantidadesElegidas[l.id])>0);
  const comPct = parseFloat(form.comision)/100;
  // Cada lote tiene su propio precio de venta editable (preciosElegidos),
  // ya no existe un precio unico global para toda la operacion.
  const precioLote = (l) => parseFloat(preciosElegidos[l.id]||0);
  const todosConPrecio = lotesElegidos.length>0 && lotesElegidos.every(l=>precioLote(l)>0);

  const costoTotalPosicion = posicionActual ? posicionActual.cantidad*posicionActual.promedio : 0;
  const costoVendido = lotes.reduce((s,l)=>s+((parseFloat(cantidadesElegidas[l.id])||0)*parseFloat(l.precio)),0);
  const cantidadRestante = posicionActual ? posicionActual.cantidad-totalElegido : 0;
  const costoRestante = costoTotalPosicion-costoVendido;
  const promedioRestante = cantidadRestante>0 ? costoRestante/cantidadRestante : 0;

  const calcInflacion = (desde,hasta) => {
    if (!desde||!hasta||!ipc||ipc.length===0) return null;
    const d=parseFecha(desde),h=parseFecha(hasta);
    if (!d||!h||h<=d) return null;
    let acum=1,n=0;
    for (const item of ipc) {
      const [mm,yy]=item.mes.split("/");
      const fm=new Date(yy+"-"+mm+"-01");
      if (fm>=d&&fm<=h) { acum*=(1+parseFloat(item.valor)/100); n++; }
    }
    return n>0?(acum-1)*100:null;
  };
  const calcularLote = (l) => {
    const cant = parseFloat(cantidadesElegidas[l.id])||0;
    const precioVentaLote = precioLote(l);
    const costo = parseFloat(l.precio)*cant;
    const ventaBruta = precioVentaLote*cant;
    const comisionMonto = ventaBruta*comPct;
    const ingreso = ventaBruta-comisionMonto;
    const ganancia = ingreso-costo;
    const rendPctLote = costo>0?(ganancia/costo)*100:0;
    const infl = calcInflacion(l.fechaCompra, form.fecha);
    const leGanaLote = infl!==null?rendPctLote>infl:null;
    return {cant,precioVentaLote,costo,ventaBruta,comisionMonto,ingreso,ganancia,rendPctLote,infl,leGanaLote};
  };
  const gananciaTotal = lotesElegidos.reduce((s,l)=>s+calcularLote(l).ganancia,0);
  const costoTotal = lotesElegidos.reduce((s,l)=>s+calcularLote(l).costo,0);
  const ventaBrutaTotal = lotesElegidos.reduce((s,l)=>s+calcularLote(l).ventaBruta,0);
  const comisionTotal = lotesElegidos.reduce((s,l)=>s+calcularLote(l).comisionMonto,0);
  const ventaNetaTotal = ventaBrutaTotal-comisionTotal;
  const rendPctTotal = costoTotal>0?(gananciaTotal/costoTotal)*100:0;
  const resColor = gananciaTotal>=0?"var(--green)":"var(--red)";

  const ok = ticker && totalElegido>0 && todosConPrecio && form.fecha;

  if (resultadoVenta) {
    const {venta,lotes:lotesDetalle,gananciaTotalLotes,nota} = resultadoVenta;
    const monedaResultado = venta?.moneda||form.moneda;
    return (
      <div style={{display:"flex",flexDirection:"column",height:"100%"}}>
        <div style={{background:"var(--surface)",borderBottom:"1px solid var(--border)",padding:"12px 14px",flexShrink:0}}>
          <h2 style={{fontSize:"16px",fontWeight:700}}>Venta registrada</h2>
        </div>
        <div className="scroll-area" style={{flex:1,overflowY:"auto",padding:"14px"}}>
          <Card style={{marginBottom:"14px",border:"1px solid rgba(0,229,160,.2)",textAlign:"center"}}>
            <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginBottom:"6px"}}>{gananciaTotalLotes>=0?"GANANCIA TOTAL":"PERDIDA TOTAL"}</p>
            <div style={{fontFamily:"var(--mono)",fontWeight:800,fontSize:"22px",color:gananciaTotalLotes>=0?"var(--green)":"var(--red)"}}>{gananciaTotalLotes>=0?"+":""}{formatMoney(gananciaTotalLotes,monedaResultado)}</div>
          </Card>
          {nota&&<p style={{fontSize:"12px",color:"var(--text3)",textAlign:"center",marginBottom:"14px"}}>{nota}</p>}
          {lotesDetalle&&lotesDetalle.length>0&&(
            <div style={{display:"flex",flexDirection:"column",gap:"9px"}}>
              {lotesDetalle.map(l=>(
                <Card key={l.loteId}>
                  <div style={{display:"flex",justifyContent:"space-between",marginBottom:"6px"}}>
                    <span style={{fontSize:"12px",color:"var(--text3)"}}>{l.fechaCompra} {"->"} {l.fechaVenta}</span>
                    <span style={{fontSize:"12px",color:"var(--text3)"}}>{l.cantidad} tit.</span>
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"4px"}}>
                    <span style={{fontFamily:"var(--mono)",fontSize:"13px"}}>{formatMoney(l.precioCompra,monedaResultado)} {"->"} {formatMoney(l.precioVenta,monedaResultado)}</span>
                    <span style={{fontWeight:700,fontFamily:"var(--mono)",fontSize:"14px",color:l.ganancia>=0?"var(--green)":"var(--red)"}}>{l.ganancia>=0?"+":""}{formatMoney(l.ganancia,monedaResultado)}</span>
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span style={{fontSize:"11px",fontWeight:600,color:l.rendimientoPct>=0?"var(--green)":"var(--red)"}}>{l.rendimientoPct>=0?"+":""}{l.rendimientoPct}%</span>
                    {l.inflacionPeriodoPct!==null&&(
                      <Badge variant={l.leGanaInflacion?"compra":"venta"} size="sm">{l.leGanaInflacion?"Le gana a inflacion":"No le gana a inflacion"} ({l.inflacionPeriodoPct}%)</Badge>
                    )}
                  </div>
                </Card>
              ))}
            </div>
          )}
          <Btn onClick={()=>onSave(operacionGuardada)} style={{width:"100%",marginTop:"16px"}} size="lg">Listo</Btn>
        </div>
      </div>
    );
  }

  const handleGuardar = async () => {
    if (!ok) return;
    setError(""); setGuardando(true);
    const lotesPayload = Object.entries(cantidadesElegidas)
      .filter(([,cant])=>parseFloat(cant)>0)
      .map(([loteId,cant])=>({loteId:parseInt(loteId,10),cantidad:String(cant),precioVenta:String(preciosElegidos[loteId]||0)}));

    const resp = await api.venderPorLote({
      ticker, fecha:form.fecha, moneda:form.moneda,
      broker:form.broker, comision:form.comision, notas:form.notas,
      lotes:lotesPayload
    });
    setGuardando(false);
    if (resp.ok) {
      setOperacionGuardada(resp.operacion);
      const detalle = await api.ventaDetalleLotes(resp.operacion.id);
      if (detalle.ok) setResultadoVenta(detalle); else onSave(resp.operacion);
    }
    else { setError(resp.error||"No se pudo registrar la venta"); }
  };

  return (
    <div style={{display:"flex",flexDirection:"column",height:"100%"}}>
      <div style={{background:"var(--surface)",borderBottom:"1px solid var(--border)",padding:"12px 14px",flexShrink:0}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"10px"}}>
          <button onClick={onClose} style={{width:"32px",height:"32px",borderRadius:"50%",background:"var(--surface2)",border:"1px solid var(--accent)",color:"var(--accent)",fontSize:"16px",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>{"<"}</button>
          <h2 style={{fontSize:"16px",fontWeight:700}}>{ticker?"Vender "+ticker:"Registrar Venta"}</h2>
        </div>
        {error&&<div style={{background:"rgba(255,77,109,.1)",border:"1px solid rgba(255,77,109,.3)",borderRadius:"var(--rs)",padding:"7px 10px",marginBottom:"8px",color:"var(--red)",fontSize:"12px"}}>{error}</div>}
        <div style={{display:"flex",gap:"8px"}}>
          <Btn variant="ghost" onClick={onClose} style={{flex:1}}>Cancelar</Btn>
          <Btn onClick={handleGuardar} disabled={!ok||guardando} style={{flex:2}}>{guardando?"Guardando...":"Registrar venta"}</Btn>
        </div>
      </div>
      <div className="scroll-area" style={{flex:1,overflowY:"auto",padding:"14px"}}>
        <Field label="Activo con posicion abierta">
          <BuscadorActivo activos={posiciones} value={ticker} onChange={v=>elegirTicker(v)} placeholder="Buscar ticker o nombre..."/>
        </Field>

        {!ticker&&posiciones.length>0&&(
          <>
            <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginTop:"6px",marginBottom:"8px"}}>O ELEGI UNO DE TUS ACTIVOS</p>
            <div style={{display:"flex",flexDirection:"column",gap:"8px",marginBottom:"14px"}}>
              {posiciones.map(p=>(
                <Card key={p.ticker} onClick={()=>elegirTicker(p.ticker)} style={{cursor:"pointer"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div>
                      <div style={{fontWeight:700,fontSize:"14px"}}>{p.ticker}</div>
                      <div style={{fontSize:"11px",color:"var(--text3)"}}>{p.nombre}</div>
                    </div>
                    <div style={{textAlign:"right"}}>
                      <div style={{fontFamily:"var(--mono)",fontWeight:700,fontSize:"14px"}}>{p.pos.cantidad}</div>
                      <div style={{fontSize:"10px",color:"var(--text3)"}}>titulos</div>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </>
        )}

        {cargandoLotes&&<p style={{fontSize:"12px",color:"var(--text3)",padding:"10px 0"}}>Cargando lotes...</p>}

        {!cargandoLotes&&ticker&&lotes.length>0&&(
          <>
            {posicionActual&&(
              <Card style={{marginBottom:"14px",border:"1px solid rgba(0,212,255,.2)"}}>
                <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginBottom:"8px"}}>TU POSICION ACTUAL EN {ticker}</p>
                <div style={{display:"flex",gap:"8px"}}>
                  <div style={{flex:1,background:"var(--surface2)",borderRadius:"var(--rs)",padding:"8px",textAlign:"center"}}>
                    <div style={{fontSize:"10px",color:"var(--text3)",marginBottom:"2px"}}>Titulos que tenes</div>
                    <div style={{fontFamily:"var(--mono)",fontWeight:800,fontSize:"16px"}}>{posicionActual.cantidad}</div>
                  </div>
                  <div style={{flex:1,background:"var(--surface2)",borderRadius:"var(--rs)",padding:"8px",textAlign:"center"}}>
                    <div style={{fontSize:"10px",color:"var(--text3)",marginBottom:"2px"}}>Precio promedio de compra</div>
                    <div style={{fontFamily:"var(--mono)",fontWeight:800,fontSize:"16px",color:"var(--yellow)"}}>{formatMoney(posicionActual.promedio,monedaLotes)}</div>
                  </div>
                  <div style={{flex:1,background:"var(--surface2)",borderRadius:"var(--rs)",padding:"8px",textAlign:"center"}}>
                    <div style={{fontSize:"10px",color:"var(--text3)",marginBottom:"2px"}}>Total invertido</div>
                    <div style={{fontFamily:"var(--mono)",fontWeight:800,fontSize:"14px"}}>{formatMoney(posicionActual.cantidad*posicionActual.promedio,monedaLotes)}</div>
                  </div>
                </div>
              </Card>
            )}

            <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginTop:"6px",marginBottom:"8px"}}>ELEGI DE QUE COMPRA VENDER</p>
            <p style={{fontSize:"12px",color:"var(--text3)",marginBottom:"10px"}}>Cada compra tuya es un lote independiente, como un renglon de una factura. Elegi de cual (o de varios a la vez) queres vender, cuanto, y a que precio - asi el registro queda exacto, sin mezclar con el promedio general.</p>
            <div style={{display:"flex",flexDirection:"column",gap:"10px",marginBottom:"14px"}}>
              {lotes.map(l=>{
                const cantLote = parseFloat(cantidadesElegidas[l.id])||0;
                const precioVentaLote = parseFloat(preciosElegidos[l.id])||0;
                const resultadoLote = cantLote>0&&precioVentaLote>0 ? calcularLote(l) : null;
                return (
                <Card key={l.id} style={{border:cantLote>0?"1px solid rgba(0,212,255,.3)":"1px solid var(--border)"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"9px"}}>
                    <div>
                      <div style={{fontSize:"11px",color:"var(--text3)"}}>Compraste el {l.fechaCompra}</div>
                      <div style={{fontFamily:"var(--mono)",fontWeight:700,fontSize:"14px",color:"var(--yellow)"}}>a {formatMoney(l.precio,l.moneda)} cada uno</div>
                    </div>
                    <Badge variant="default" size="sm">{l.cantidadDisponible} disponibles</Badge>
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px"}}>
                    <Field label="Cantidad a vender">
                      <input type="number" step="any" min="0" max={l.cantidadDisponible}
                        value={cantidadesElegidas[l.id]??""}
                        onChange={e=>setCantidadLote(l.id,e.target.value,parseFloat(l.cantidadDisponible))}
                        placeholder="0"/>
                    </Field>
                    <Field label={"Precio de venta ("+l.moneda+")"}>
                      <input type="number" step="any" min="0"
                        value={preciosElegidos[l.id]??""}
                        onChange={e=>setPrecioLote(l.id,e.target.value)}
                        placeholder="0.00"/>
                    </Field>
                  </div>
                  {resultadoLote&&(
                    <div style={{marginTop:"9px",paddingTop:"9px",borderTop:"1px solid var(--border)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <span style={{fontSize:"12px",color:"var(--text3)"}}>{resultadoLote.ganancia>=0?"Ganarias":"Perderias"} en esta porcion</span>
                      <span style={{fontWeight:800,fontFamily:"var(--mono)",fontSize:"15px",color:resultadoLote.ganancia>=0?"var(--green)":"var(--red)"}}>{resultadoLote.ganancia>=0?"+":""}{formatMoney(resultadoLote.ganancia,l.moneda)} ({resultadoLote.rendPctLote>=0?"+":""}{resultadoLote.rendPctLote.toFixed(2)}%)</span>
                    </div>
                  )}
                </Card>
                );
              })}
            </div>

            {totalElegido>0&&(
              <Card style={{marginBottom:"14px",border:"1px solid rgba(251,191,36,.3)"}}>
                <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,marginBottom:"8px"}}>ASI TE QUEDA DESPUES DE ESTA VENTA</p>
                <div style={{display:"flex",gap:"8px"}}>
                  <div style={{flex:1,textAlign:"center"}}>
                    <div style={{fontSize:"10px",color:"var(--text3)"}}>Titulos que te quedan</div>
                    <div style={{fontFamily:"var(--mono)",fontWeight:700,fontSize:"15px"}}>{Math.max(0,cantidadRestante)}</div>
                  </div>
                  <div style={{flex:1,textAlign:"center"}}>
                    <div style={{fontSize:"10px",color:"var(--text3)"}}>Nuevo precio promedio</div>
                    <div style={{fontFamily:"var(--mono)",fontWeight:700,fontSize:"15px",color:"var(--yellow)"}}>{cantidadRestante>0?formatMoney(promedioRestante,monedaLotes):"--"}</div>
                  </div>
                </div>
              </Card>
            )}

            <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginTop:"14px",marginBottom:"8px"}}>DATOS DE LA VENTA</p>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px"}}>
              <Field label="Fecha de la venta"><InputFecha value={form.fecha} onChange={v=>setForm(f=>({...f,fecha:v}))}/></Field>
              <Field label="Broker"><select value={form.broker} onChange={e=>setForm(f=>({...f,broker:e.target.value}))}>{["Galicia","Balanz","IOL","PPI","Otro"].map(b=><option key={b}>{b}</option>)}</select></Field>
            </div>
            <Field label="Comision (%)" hint="Se aplica sobre el total de la venta"><input type="number" step="0.1" min="0" max="10" value={form.comision} onChange={e=>setForm(f=>({...f,comision:e.target.value}))}/></Field>
            <Field label="Notas" hint="Opcional"><input value={form.notas} onChange={e=>setForm(f=>({...f,notas:e.target.value}))} placeholder="Observaciones..."/></Field>

            {todosConPrecio&&lotesElegidos.length>0&&(
              <div style={{display:"flex",flexDirection:"column",gap:"10px",marginTop:"18px"}}>
                <Card style={{border:"1px solid "+(gananciaTotal>=0?"rgba(0,229,160,.4)":"rgba(255,77,109,.4)")}}>
                  <div style={{textAlign:"center",padding:"8px 0"}}>
                    <div style={{fontSize:"12px",color:"var(--text3)",marginBottom:"4px",fontWeight:700}}>{gananciaTotal>=0?"Ganancia total estimada":"Perdida total estimada"}</div>
                    <div style={{fontFamily:"var(--mono)",fontWeight:800,fontSize:"26px",color:resColor}}>{gananciaTotal>=0?"+":""}{formatMoney(gananciaTotal,monedaLotes)}</div>
                    <div style={{fontFamily:"var(--mono)",fontSize:"17px",fontWeight:700,color:resColor,marginTop:"2px"}}>{rendPctTotal>=0?"+":""}{rendPctTotal.toFixed(2)}% de rendimiento</div>
                  </div>
                </Card>
                <Card>
                  <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,marginBottom:"8px",letterSpacing:".05em"}}>RESUMEN COMPLETO DE LA VENTA</p>
                  {[
                    ["Cantidad total de titulos", totalElegido+" titulos"],
                    ["Total de la venta (antes de comision)", formatMoney(ventaBrutaTotal,monedaLotes)],
                    ["Comision de la venta", "- "+formatMoney(comisionTotal,monedaLotes)],
                    ["Total que vas a recibir", formatMoney(ventaNetaTotal,monedaLotes)],
                    ["Costo de lo que compraste (esos lotes)", "- "+formatMoney(costoTotal,monedaLotes)]
                  ].map(([k,v])=>(
                    <div key={k} style={{display:"flex",justifyContent:"space-between",gap:"10px",padding:"6px 0",borderBottom:"1px solid var(--border)"}}><span style={{fontSize:"12px",color:"var(--text3)"}}>{k}</span><span style={{fontFamily:"var(--mono)",fontSize:"12px",fontWeight:600,whiteSpace:"nowrap"}}>{v}</span></div>
                  ))}
                  <div style={{display:"flex",justifyContent:"space-between",padding:"8px 0"}}><span style={{fontWeight:700}}>{gananciaTotal>=0?"Ganancia neta":"Perdida neta"}</span><span style={{fontFamily:"var(--mono)",fontWeight:800,color:resColor}}>{gananciaTotal>=0?"+":""}{formatMoney(gananciaTotal,monedaLotes)}</span></div>
                </Card>
                <Card>
                  <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,marginBottom:"8px",letterSpacing:".05em"}}>DETALLE, LOTE POR LOTE</p>
                  {lotesElegidos.map(l=>{
                    const s = calcularLote(l);
                    return (
                      <div key={l.id} style={{padding:"9px 0",borderBottom:"1px solid var(--border)"}}>
                        <div style={{display:"flex",justifyContent:"space-between",marginBottom:"4px"}}>
                          <span style={{fontSize:"12px",color:"var(--text3)"}}>Comprado el {l.fechaCompra}: {s.cant} titulos a {formatMoney(l.precio,monedaLotes)} c/u</span>
                        </div>
                        <div style={{display:"flex",justifyContent:"space-between",marginBottom:"4px"}}>
                          <span style={{fontSize:"12px",color:"var(--text3)"}}>Vendido ahora a {formatMoney(s.precioVentaLote,monedaLotes)} c/u</span>
                          <span style={{fontWeight:700,fontFamily:"var(--mono)",fontSize:"13px",color:s.ganancia>=0?"var(--green)":"var(--red)"}}>{s.ganancia>=0?"+":""}{formatMoney(s.ganancia,monedaLotes)}</span>
                        </div>
                        <div style={{display:"flex",justifyContent:"space-between",marginBottom:"4px"}}>
                          <span style={{fontSize:"10px",color:"var(--text3)"}}>Recibis {formatMoney(s.ingreso,monedaLotes)} despues de comision ({formatMoney(s.comisionMonto,monedaLotes)}) - Te costo {formatMoney(s.costo,monedaLotes)}</span>
                        </div>
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                          <span style={{fontSize:"12px",fontWeight:700,color:s.ganancia>=0?"var(--green)":"var(--red)"}}>{s.ganancia>=0?"Ganaste":"Perdiste"} {s.rendPctLote>=0?"+":""}{s.rendPctLote.toFixed(2)}%</span>
                          {monedaLotes==="ARS"&&s.infl!==null&&(
                            <Badge variant={s.leGanaLote?"compra":"venta"} size="sm">{s.leGanaLote?"Le gana a la inflacion":"No le gana a la inflacion"} ({s.infl.toFixed(1)}%)</Badge>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </Card>
              </div>
            )}
            {lotesElegidos.length>0&&!todosConPrecio&&(
              <p style={{fontSize:"12px",color:"var(--yellow)",textAlign:"center",padding:"14px 0"}}>Falta el precio de venta en alguno de los lotes elegidos.</p>
            )}
          </>
        )}

        {!cargandoLotes&&ticker&&lotes.length===0&&(
          <p style={{fontSize:"12px",color:"var(--text2)",textAlign:"center",padding:"20px 0"}}>No hay lotes disponibles para este activo.</p>
        )}

        {posiciones.length===0&&<div style={{textAlign:"center",padding:"40px 0",color:"var(--text2)"}}><p>No tenes posiciones abiertas para vender</p></div>}
      </div>
    </div>
  );
};

const DetalleModal = ({op,onClose,misOps,configData}) => {
  const total=parseFloat(op.precio)*parseFloat(op.cantidad);
  const comPct=parseFloat(op.comision||configData.comision)/100;
  const totalNeto=op.tipo==="COMPRA"?total*(1+comPct):total*(1-comPct);
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.8)",zIndex:999,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px"}} onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="fi" style={{background:"var(--surface)",border:"1px solid var(--border)",borderRadius:"14px",width:"100%",maxWidth:"380px",padding:"18px",maxHeight:"90vh",overflowY:"auto"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"14px"}}>
          <div style={{display:"flex",alignItems:"center",gap:"9px"}}>
            <div style={{width:"40px",height:"40px",borderRadius:"9px",background:op.tipo==="COMPRA"?"rgba(0,229,160,.1)":"rgba(255,77,109,.1)",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:"11px",color:op.tipo==="COMPRA"?"var(--green)":"var(--red)"}}>{op.tipo==="COMPRA"?"COM":"VEN"}</div>
            <div>
              <div style={{fontWeight:800,fontSize:"17px"}}>{op.ticker}</div>
              <div style={{display:"flex",gap:"4px",marginTop:"3px"}}>
                <Badge variant={op.tipo==="COMPRA"?"compra":"venta"} size="sm">{op.tipo}</Badge>
                <Badge variant={op.moneda==="USD"?"usd":"ars"} size="sm">{op.moneda}</Badge>
              </div>
            </div>
          </div>
          <button onClick={onClose} style={{background:"var(--surface2)",border:"1px solid var(--border)",color:"var(--text3)",borderRadius:"50%",width:"28px",height:"28px",cursor:"pointer"}}>X</button>
        </div>
        {[["Fecha",op.fecha],["Broker",op.broker],["Cantidad",op.cantidad+" titulos"],["Precio unit.",formatMoney(op.precio,op.moneda)],["Comision",op.comision+"%"],["Subtotal",formatMoney(total,op.moneda)]].map(([k,v])=>(
          <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"7px 0",borderBottom:"1px solid var(--border)"}}><span style={{color:"var(--text3)",fontSize:"13px"}}>{k}</span><span style={{fontFamily:"var(--mono)",fontSize:"13px"}}>{v}</span></div>
        ))}
        <div style={{display:"flex",justifyContent:"space-between",padding:"9px 0",borderBottom:"1px solid var(--border)"}}><span style={{fontWeight:700}}>Total neto</span><span style={{fontFamily:"var(--mono)",fontWeight:700,color:"var(--accent)"}}>{formatMoney(totalNeto,op.moneda)}</span></div>
        {op.notas&&<div style={{marginTop:"9px",padding:"7px 9px",background:"var(--surface2)",borderRadius:"var(--rs)"}}><p style={{fontSize:"11px",color:"var(--text3)",marginBottom:"2px"}}>NOTAS</p><p style={{fontSize:"13px"}}>{op.notas}</p></div>}
        <Btn onClick={onClose} variant="ghost" style={{width:"100%",marginTop:"12px"}}>Cerrar</Btn>
      </div>
    </div>
  );
};

const OperacionesTab = ({user,operaciones,activos,configData,ipc,onAdd,onAgregarLocal,planInfo}) => {
  const [filtroActivo,setFiltroActivo] = useState("TODOS");
  const [filtroTipo,setFiltroTipo] = useState("TODOS");
  const [filtroMoneda,setFiltroMoneda] = useState("TODOS");
  const [periodo,setPeriodo] = useState("TODOS");
  const [desde,setDesde] = useState("");
  const [hasta,setHasta] = useState("");
  const [nuevaOp,setNuevaOp] = useState(false);
  const [venderLote,setVenderLote] = useState(false);
  const [elegirTipoOp,setElegirTipoOp] = useState(false);
  const [selectedOp,setSelectedOp] = useState(null);
  const misOps = operaciones.filter(op=>user.rol==="admin"||op.userId===user.id);
  // Chips rapidos: SOLO los activos que hoy tenes con posicion abierta
  // (cantidad > 0), que son los que cuentan para el limite del plan.
  const tickersOperados = [...new Set(misOps.map(op=>op.ticker))];
  const tickers = tickersOperados.filter(t=>calcPosicion(misOps,user.id,t).cantidad>0);
  // Buscador predictivo: TODO tu historial, incluidos activos ya
  // vendidos del todo hace tiempo, para poder encontrar cualquier
  // operacion vieja.
  const activosOperados = tickersOperados.map(t=>{
    const a = activos.find(x=>x.ticker===t);
    return {id:t,ticker:t,nombre:a?.nombre||t,tipo:a?.tipo||""};
  });
  const opsFiltradas = useMemo(()=>{
    let ops = misOps;
    if (filtroActivo!=="TODOS") ops=ops.filter(op=>op.ticker===filtroActivo);
    if (filtroTipo!=="TODOS") ops=ops.filter(op=>op.tipo===filtroTipo);
    if (filtroMoneda!=="TODOS") ops=ops.filter(op=>op.moneda===filtroMoneda);
    ops = filtrarPorPeriodo(ops,periodo,desde,hasta);
    return ops.sort((a,b)=>parseFecha(b.fecha)-parseFecha(a.fecha));
  },[misOps,filtroActivo,filtroTipo,filtroMoneda,periodo,desde,hasta]);
  if (nuevaOp) return <PantallaNewOp activos={activos} configData={configData} user={user} operaciones={operaciones} onClose={()=>setNuevaOp(false)} onGuardar={onAdd} onListo={()=>setNuevaOp(false)}/>;
  if (venderLote) return <PantallaVenderLote activos={activos} configData={configData} user={user} operaciones={operaciones} ipc={ipc} onClose={()=>setVenderLote(false)} onSave={op=>{onAgregarLocal(op);setVenderLote(false);}}/>;
  return (
    <>
      <div className="scroll-area" style={{padding:"14px 14px 90px",overflowY:"auto",height:"100%"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"12px"}}>
          <h1 style={{fontSize:"20px",fontWeight:800}}>Operaciones</h1>
          <Badge variant="default">{opsFiltradas.length} ops</Badge>
        </div>
        {planInfo&&planInfo.limite!==null&&(
          <div style={{marginBottom:"12px",background:"var(--surface)",border:"1px solid "+(planInfo.activos>=planInfo.limite?"rgba(255,77,109,.4)":planInfo.activos>=(planInfo.limite*0.8)?"rgba(251,191,36,.3)":"var(--border)"),borderRadius:"var(--rs)",padding:"8px 12px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontSize:"12px",color:"var(--text3)"}}>Activos activos</span>
            <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
              <span style={{fontFamily:"var(--mono)",fontWeight:700,fontSize:"13px",color:planInfo.activos>=planInfo.limite?"var(--red)":planInfo.activos>=(planInfo.limite*0.8)?"var(--yellow)":"var(--green)"}}>{planInfo.activos}/{planInfo.limite}</span>
              <span style={{fontSize:"11px",color:"var(--text3)"}}>{planInfo.planNombre}</span>
            </div>
          </div>
        )}
        <div style={{display:"flex",gap:"7px",marginBottom:"12px"}}>
          <Btn variant="excel" size="sm" onClick={()=>exportarExcel(opsFiltradas,"Operaciones")}>Excel</Btn>
          <Btn variant="pdf" size="sm" onClick={()=>exportarPDF(opsFiltradas,"Operaciones")}>PDF</Btn>
        </div>
        <Field label="Buscar activo (incluye todo tu historial)">
          <BuscadorActivo activos={activosOperados} value={filtroActivo==="TODOS"?"":filtroActivo} onChange={v=>setFiltroActivo(v||"TODOS")} placeholder="Buscar ticker o nombre, aunque ya no lo tengas..."/>
        </Field>
        <p style={{fontSize:"10px",color:"var(--text2)",marginBottom:"5px"}}>Accesos rapidos - tus activos activos ({tickers.length})</p>
        <div style={{overflowX:"auto",paddingBottom:"4px",marginBottom:"7px"}}>
          <div style={{display:"flex",gap:"5px",width:"max-content"}}>
            <FilterBtn label="Todos los activos" active={filtroActivo==="TODOS"} onClick={()=>setFiltroActivo("TODOS")}/>
            {tickers.map(t=><FilterBtn key={t} label={t} active={filtroActivo===t} onClick={()=>setFiltroActivo(t)}/>)}
          </div>
        </div>
        <div style={{display:"flex",gap:"5px",marginBottom:"7px",flexWrap:"wrap"}}>
          <FilterBtn label="Compras y ventas" active={filtroTipo==="TODOS"} onClick={()=>setFiltroTipo("TODOS")}/>
          <FilterBtn label="Compras" active={filtroTipo==="COMPRA"} onClick={()=>setFiltroTipo("COMPRA")}/>
          <FilterBtn label="Ventas" active={filtroTipo==="VENTA"} onClick={()=>setFiltroTipo("VENTA")}/>
        </div>
        <div style={{display:"flex",gap:"5px",marginBottom:"7px",flexWrap:"wrap"}}>
          <FilterBtn label="Todas monedas" active={filtroMoneda==="TODOS"} onClick={()=>setFiltroMoneda("TODOS")}/>
          <FilterBtn label="Pesos" active={filtroMoneda==="ARS"} onClick={()=>setFiltroMoneda("ARS")}/>
          <FilterBtn label="Dolares" active={filtroMoneda==="USD"} onClick={()=>setFiltroMoneda("USD")}/>
        </div>
        <div style={{marginBottom:"14px"}}><FiltroPeriodo valor={periodo} setValor={setPeriodo} desde={desde} setDesde={setDesde} hasta={hasta} setHasta={setHasta}/></div>
        <div style={{display:"flex",flexDirection:"column",gap:"9px"}}>
          {opsFiltradas.length===0&&<div style={{textAlign:"center",padding:"44px 0",color:"var(--text2)"}}><p>Sin operaciones con estos filtros</p></div>}
          {opsFiltradas.map(op=>{
            const total=parseFloat(op.precio)*parseFloat(op.cantidad);
            return (
              <Card key={op.id} onClick={()=>setSelectedOp(op)}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"7px"}}>
                  <div style={{display:"flex",alignItems:"center",gap:"9px"}}>
                    <div style={{width:"36px",height:"36px",borderRadius:"8px",background:op.tipo==="COMPRA"?"rgba(0,229,160,.1)":"rgba(255,77,109,.1)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"11px",fontWeight:700,color:op.tipo==="COMPRA"?"var(--green)":"var(--red)",flexShrink:0}}>{op.tipo==="COMPRA"?"COM":"VEN"}</div>
                    <div>
                      <div style={{display:"flex",alignItems:"center",gap:"5px"}}>
                        <span style={{fontWeight:700,fontSize:"14px"}}>{op.ticker}</span>
                        <Badge variant={op.tipo==="COMPRA"?"compra":"venta"} size="sm">{op.tipo}</Badge>
                      </div>
                      <div style={{fontSize:"11px",color:"var(--text3)",marginTop:"1px"}}>{op.fecha} - {op.broker} - {op.comision}%</div>
                    </div>
                  </div>
                  <Badge variant={op.moneda==="USD"?"usd":"ars"} size="sm">{op.moneda}</Badge>
                </div>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span style={{fontSize:"12px",color:"var(--text3)"}}>{op.cantidad} x {formatMoney(op.precio,op.moneda)}</span>
                  <span style={{fontWeight:700,fontFamily:"var(--mono)",fontSize:"14px"}}>{formatMoney(total,op.moneda)}</span>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
      <button onClick={()=>setElegirTipoOp(true)} style={{position:"absolute",bottom:"80px",right:"16px",padding:"12px 20px 12px 18px",borderRadius:"100px",background:"linear-gradient(135deg,var(--accent),var(--accent2))",boxShadow:"0 4px 16px rgba(0,212,255,.4)",fontSize:"14px",fontWeight:800,display:"flex",alignItems:"center",gap:"8px",border:"none",cursor:"pointer",zIndex:10,color:"#0a0e1a"}}><span style={{fontSize:"18px",lineHeight:1}}>+</span> Operaciones</button>
      {elegirTipoOp&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.75)",zIndex:400,display:"flex",alignItems:"flex-end",justifyContent:"center"}} onClick={e=>e.target===e.currentTarget&&setElegirTipoOp(false)}>
          <div className="fi" style={{width:"100%",maxWidth:"480px",background:"var(--surface)",borderTop:"1px solid var(--border)",borderRadius:"20px 20px 0 0",padding:"20px 16px 28px"}}>
            <p style={{textAlign:"center",fontSize:"15px",fontWeight:700,marginBottom:"4px"}}>Que queres registrar?</p>
            <p style={{textAlign:"center",fontSize:"12px",color:"var(--text3)",marginBottom:"18px"}}>Elegi una opcion para continuar</p>
            <div style={{display:"flex",flexDirection:"column",gap:"10px"}}>
              <Card onClick={()=>{setElegirTipoOp(false);setNuevaOp(true);}} style={{cursor:"pointer",border:"1px solid rgba(0,229,160,.3)"}}>
                <div style={{display:"flex",alignItems:"center",gap:"12px"}}>
                  <div style={{width:"42px",height:"42px",borderRadius:"10px",background:"rgba(0,229,160,.12)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"11px",fontWeight:800,color:"var(--green)",flexShrink:0}}>COM</div>
                  <div><div style={{fontWeight:700,fontSize:"15px"}}>Comprar</div><div style={{fontSize:"12px",color:"var(--text3)"}}>Registrar una compra nueva</div></div>
                </div>
              </Card>
              <Card onClick={()=>{setElegirTipoOp(false);setVenderLote(true);}} style={{cursor:"pointer",border:"1px solid rgba(255,77,109,.3)"}}>
                <div style={{display:"flex",alignItems:"center",gap:"12px"}}>
                  <div style={{width:"42px",height:"42px",borderRadius:"10px",background:"rgba(255,77,109,.12)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"11px",fontWeight:800,color:"var(--red)",flexShrink:0}}>VEN</div>
                  <div><div style={{fontWeight:700,fontSize:"15px"}}>Vender</div><div style={{fontSize:"12px",color:"var(--text3)"}}>Elegir de que compras vender, y a que precio</div></div>
                </div>
              </Card>
            </div>
            <Btn variant="ghost" onClick={()=>setElegirTipoOp(false)} style={{width:"100%",marginTop:"14px"}}>Cancelar</Btn>
          </div>
        </div>
      )}
      {selectedOp&&<DetalleModal op={selectedOp} onClose={()=>setSelectedOp(null)} misOps={misOps} configData={configData}/>}
    </>
  );
};

const PrecioLock = ({moneda, ticker, precios}) => {
  const dato = precios && ticker ? precios[ticker] : null;
  const precioReal = dato ? (moneda==="ARS" ? dato.precioARS : dato.precioUSD) : null;
  const variacion = dato ? (moneda==="ARS" ? dato.variacionPctARS : dato.variacionPctUSD) : null;
  const colorVar = variacion>0?"var(--green)":variacion<0?"var(--red)":"var(--text3)";
  if (precioReal) {
    return (
      <div style={{flex:1,textAlign:"center",borderRadius:"6px"}}>
        <div style={{fontWeight:700,fontFamily:"var(--mono)",fontSize:"12px",color:"var(--accent)"}}>{formatMoney(precioReal,moneda)}</div>
        {variacion!==null&&variacion!==undefined&&(
          <div style={{fontWeight:700,fontFamily:"var(--font-input)",fontSize:"11px",color:colorVar,marginTop:"1px"}}>{variacion>0?"+":""}{variacion.toFixed(2)}%</div>
        )}
        <div style={{fontSize:"9px",color:"var(--text3)",marginTop:"1px"}}>Precio {moneda}</div>
      </div>
    );
  }
  return (
    <div style={{flex:1,textAlign:"center",position:"relative",overflow:"hidden",borderRadius:"6px"}}>
      <div style={{filter:"blur(4px)",userSelect:"none",pointerEvents:"none"}}>
        <div style={{fontWeight:700,fontFamily:"var(--mono)",fontSize:"12px",color:"var(--text)"}}>{moneda==="ARS"?"$ 0000":"US$ 00"}</div>
      </div>
      <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
        <span style={{fontSize:"12px"}}>{"\uD83D\uDD12"}</span>
      </div>
      <div style={{fontSize:"9px",color:"var(--text3)",marginTop:"1px"}}>Precio {moneda}</div>
    </div>
  );
};

// ============================================================
// DETALLE DE ACTIVO ENRIQUECIDO - con bloques configurables
// ============================================================
const DetalleActivoEnriquecido = ({ticker,activo,user,operaciones,precios,onVolver,onToggleFavorito,favoritos}) => {
  const [datos,setDatos] = useState(null);
  const [bloques,setBloques] = useState([]);
  const [cargando,setCargando] = useState(true);
  const [periodo,setPeriodo] = useState("3mo");
  const [moneda,setMoneda] = useState("ARS");
  const [mensajes,setMensajes] = useState([]);
  const [nuevoMensaje,setNuevoMensaje] = useState("");
  const [enviandoMsg,setEnviandoMsg] = useState(false);
  const [errMsg,setErrMsg] = useState("");

  const cargar = async (p) => {
    setCargando(true);
    const [respDatos, respBloques] = await Promise.all([
      api.activoDetalle(ticker, p||periodo),
      api.bloquesListar()
    ]);
    if (respDatos.ok) setDatos(respDatos);
    if (respBloques.ok) setBloques(respBloques.bloques.filter(b=>b.activo));
    setCargando(false);
  };

  const cambiarPeriodo = (p) => { setPeriodo(p); cargar(p); };

  const cargarMensajes = async () => {
    const resp = await api.mensajesListar(ticker);
    if (resp.ok) setMensajes(resp.mensajes);
  };

  const publicarMensaje = async () => {
    if (!nuevoMensaje.trim()) return;
    setEnviandoMsg(true); setErrMsg("");
    const resp = await api.mensajesPublicar(ticker, nuevoMensaje);
    setEnviandoMsg(false);
    if (resp.ok) { setMensajes(p=>[resp.mensaje,...p]); setNuevoMensaje(""); }
    else setErrMsg(resp.error||"No se pudo publicar");
  };

  const eliminarMensaje = async (id) => {
    const resp = await api.mensajesEliminar(id);
    if (resp.ok) setMensajes(p=>p.filter(m=>m.id!==id));
  };

  // Carga inicial
  useState(()=>{ cargar(); cargarMensajes(); },[]);

  const pos = calcPosicion(operaciones,user.id,ticker);
  const esFav = favoritos&&favoritos.includes(ticker);
  const esAdmin = user.rol==="admin";

  const tieneBloque = (clave) => bloques.some(b=>b.clave===clave&&b.tieneAcceso);
  const bloqueVisible = (clave) => bloques.some(b=>b.clave===clave);

  const gananciaActual = datos&&pos.cantidad>0&&datos.precio?.actualARS
    ? (datos.precio.actualARS - pos.promedio) * pos.cantidad : null;
  const ganPct = pos.promedio>0&&datos?.precio?.actualARS
    ? ((datos.precio.actualARS-pos.promedio)/pos.promedio)*100 : null;

  // Convierte un valor de max/min/historico a la moneda pedida (ARS o USD),
  // sabiendo en que moneda vino nativamente ese valor (datos.precio.monedaNativa:
  // "ARS" para Accion AR -Yahoo ya lo da en pesos-, "USD" para el resto).
  // Antes esto siempre asumia que todo venia en USD, lo que duplicaba la
  // conversion para Accion AR.
  const convertirMoneda = (valor, aMoneda) => {
    if (valor==null||!datos?.precio) return null;
    const nativa = datos.precio.monedaNativa||"USD";
    if (nativa===aMoneda) return valor;
    const ratio = activo?.tipo==="Cedear" ? (activo?.ratioCedear||1) : 1;
    const ccl = datos.precio.dolarCCL;
    if (!ccl) return null;
    if (nativa==="USD"&&aMoneda==="ARS") return (valor/ratio)*ccl;
    if (nativa==="ARS"&&aMoneda==="USD") return valor/ccl;
    return null;
  };

  // Mini grafico SVG de linea, con eje Y (precios) y eje X (fechas)
  const GraficoLinea = ({puntos,color,moneda}) => {
    const vals = (puntos||[]).map(p=>p.cierre).filter(v=>v!=null);
    if (!puntos||puntos.length<2||vals.length<2) return <p style={{fontSize:"12px",color:"var(--text3)",textAlign:"center",padding:"20px"}}>Sin datos historicos</p>;
    const min = Math.min(...vals); const max = Math.max(...vals);
    const rango = max-min||1;
    const W=300,H=120;
    const padL=50,padR=6,padT=6,padB=18;
    const plotW=W-padL-padR, plotH=H-padT-padB;
    const pts = vals.map((v,i)=>`${padL+(i/(vals.length-1))*plotW},${padT+plotH-((v-min)/rango)*plotH}`).join(" ");

    const fmtEje = (v) => {
      const dec = v<10?2:0;
      return (moneda==="USD"?"US$ ":"$ ")+v.toLocaleString("es-AR",{minimumFractionDigits:dec,maximumFractionDigits:dec});
    };
    const nY = 4;
    const yTicks = Array.from({length:nY+1},(_,i)=>min+(rango*i/nY));

    const nX = Math.min(4,puntos.length-1);
    const xTickIdx = Array.from({length:nX+1},(_,i)=>Math.round(i*(puntos.length-1)/nX));

    return (
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:"100%",height:"120px"}}>
        {yTicks.map((v,i)=>{
          const y = padT+plotH-((v-min)/rango)*plotH;
          return (
            <g key={"y"+i}>
              <line x1={padL} y1={y} x2={W-padR} y2={y} stroke="var(--border)" strokeWidth="0.5" strokeDasharray="2,2"/>
              <text x={padL-4} y={y+2.5} textAnchor="end" fontSize="7" fontWeight="400" fill="var(--text3)">{fmtEje(v)}</text>
            </g>
          );
        })}
        <polyline points={pts} fill="none" stroke={color||"var(--accent)"} strokeWidth="2"/>
        {xTickIdx.map((idx,i)=>{
          const x = padL+(idx/(vals.length-1))*plotW;
          return <text key={"x"+i} x={x} y={H-4} textAnchor="middle" fontSize="7" fontWeight="400" fill="var(--text3)">{puntos[idx]?.fecha}</text>;
        })}
      </svg>
    );
  };

  return (
    <div className="scroll-area" style={{height:"100%",overflowY:"auto",paddingBottom:"90px"}}>
      <div style={{background:"var(--surface)",borderBottom:"1px solid var(--border)",padding:"12px 14px",position:"sticky",top:0,zIndex:10}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"8px"}}>
          <button onClick={onVolver} style={{width:"32px",height:"32px",borderRadius:"50%",background:"var(--surface2)",border:"1px solid var(--accent)",color:"var(--accent)",fontSize:"16px",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0}}>{"<"}</button>
          <div style={{flex:1,minWidth:0}}>
            <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
              <span style={{fontWeight:600,fontSize:"17px",fontFamily:"var(--font-input)",letterSpacing:"0"}}>{ticker}</span>
              {activo&&<Badge variant="default" size="sm">{activo.tipo}</Badge>}
            </div>
            {activo&&<div style={{fontSize:"12px",color:"var(--text3)",fontFamily:"var(--font-input)",fontWeight:400,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{activo.nombre}</div>}
          </div>
          <button onClick={()=>onToggleFavorito(ticker)} style={{background:"none",border:"none",cursor:"pointer",fontSize:"20px",color:esFav?"var(--yellow)":"var(--text2)"}}>{esFav?"\u2605":"\u2606"}</button>
        </div>
        <div style={{display:"flex",gap:"6px"}}>
          {["ARS","USD"].map(m=>(
            <button key={m} onClick={()=>setMoneda(m)} style={{flex:1,padding:"6px",borderRadius:"var(--rs)",border:"1px solid "+(moneda===m?"var(--accent)":"var(--border)"),background:moneda===m?"rgba(0,212,255,.1)":"transparent",color:moneda===m?"var(--accent)":"var(--text3)",fontFamily:"var(--font-input)",fontWeight:moneda===m?600:400,fontSize:"13px",cursor:"pointer"}}>{m==="ARS"?"Pesos (ARS)":"Dolares (USD)"}</button>
          ))}
        </div>
      </div>

      <div style={{padding:"14px"}}>
        {cargando&&<p style={{textAlign:"center",color:"var(--text3)",padding:"30px"}}>Cargando...</p>}

        {!cargando&&datos&&(
          <>
            {bloqueVisible("precio_actual")&&(
              <Card style={{marginBottom:"12px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"10px"}}>
                  <div>
                    <div style={{fontFamily:"var(--mono)",fontWeight:600,fontSize:"22px",color:"var(--text)"}}>
                      {moneda==="ARS"?(datos.precio.actualARS?formatMoney(datos.precio.actualARS,"ARS"):"--"):(datos.precio.actualUSD?formatMoney(datos.precio.actualUSD,"USD"):"--")}
                    </div>
                    <div style={{fontFamily:"var(--font-input)",fontSize:"12px",color:"var(--text3)",marginTop:"2px"}}>
                      {moneda==="ARS"?(datos.precio.actualUSD?formatMoney(datos.precio.actualUSD,"USD"):""):(datos.precio.actualARS?formatMoney(datos.precio.actualARS,"ARS"):"")}
                    </div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    {(() => {
                      const varPct = moneda==="ARS" ? datos.precio.variacionPctARS : datos.precio.variacionPctUSD;
                      if (varPct===null||varPct===undefined) return <div style={{fontSize:"13px",color:"var(--text3)"}}>--</div>;
                      const precioActualMoneda = moneda==="ARS" ? datos.precio.actualARS : datos.precio.actualUSD;
                      const cierreAntMoneda = convertirMoneda(datos.precio.cierreAnterior, moneda);
                      const deltaAbs = (precioActualMoneda!=null && cierreAntMoneda!=null) ? precioActualMoneda-cierreAntMoneda : null;
                      const subiendo = varPct>0, bajando = varPct<0;
                      const color = subiendo?"var(--green)":bajando?"var(--red)":"var(--text3)";
                      return (
                        <>
                          <div style={{fontWeight:800,fontFamily:"var(--font-input)",fontSize:"15px",color}}>{subiendo?"\u25B2":bajando?"\u25BC":"\u25CF"} {varPct>0?"+":""}{varPct.toFixed(2)}%</div>
                          {deltaAbs!==null&&<div style={{fontSize:"11px",fontWeight:600,color,marginTop:"1px"}}>{deltaAbs>=0?"+":""}{formatMoney(deltaAbs,moneda)}</div>}
                        </>
                      );
                    })()}
                    <div style={{fontSize:"10px",fontFamily:"var(--font-input)",color:"var(--text3)",marginTop:"3px",display:"flex",alignItems:"center",gap:"4px",justifyContent:"flex-end"}}>
                      <span style={{width:"6px",height:"6px",borderRadius:"50%",background:datos.precio.marketState==="REGULAR"?"var(--green)":"var(--text2)",display:"inline-block",flexShrink:0}}/>
                      {datos.precio.marketState==="REGULAR"?"En vivo":datos.precio.marketState==="PRE"?"Pre-mercado":(datos.precio.marketState==="POST"||datos.precio.marketState==="POSTPOST")?"Post-mercado":datos.precio.marketState==="CLOSED"?"Mercado cerrado":"Hoy"}
                    </div>
                  </div>
                </div>
                <div style={{display:"flex",gap:"4px",flexWrap:"wrap",marginBottom:"12px"}}>
                  {[["24h","1D"],["1mo","1S"],["3mo","1M"],["1y","1A"],["5y","5A"]].map(([p,lbl])=>(
                    <button key={p} onClick={()=>cambiarPeriodo(p)} style={{padding:"4px 10px",borderRadius:"100px",border:"1px solid "+(periodo===p?"var(--accent)":"var(--border)"),background:periodo===p?"rgba(0,212,255,.1)":"transparent",color:periodo===p?"var(--accent)":"var(--text3)",fontSize:"11px",fontWeight:600,cursor:"pointer"}}>{lbl}</button>
                  ))}
                </div>
                <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginBottom:"8px"}}>ESTADISTICAS CLAVE</p>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"6px"}}>
                  {[
                    ["Rango dia", (datos.precio.minDia!=null&&datos.precio.maxDia!=null)?formatMoney(convertirMoneda(datos.precio.minDia,moneda),moneda)+" - "+formatMoney(convertirMoneda(datos.precio.maxDia,moneda),moneda):null],
                    ["Rango 52 sem", (datos.precio.min52w!=null&&datos.precio.max52w!=null)?formatMoney(convertirMoneda(datos.precio.min52w,moneda),moneda)+" - "+formatMoney(convertirMoneda(datos.precio.max52w,moneda),moneda):null],
                    ["Cierre anterior", datos.precio.cierreAnterior!=null?formatMoney(convertirMoneda(datos.precio.cierreAnterior,moneda),moneda):null],
                    ["Volumen", datos.precio.volumen!=null?Number(datos.precio.volumen).toLocaleString("es-AR"):null],
                    ["Cap. mercado", datos.precio.marketCap!=null?(activo?.tipo==="Accion AR"?"$ ":"US$ ")+(datos.precio.marketCap/1e9).toFixed(1)+"B":null],
                    ["PER", datos.precio.pe!=null?datos.precio.pe:null]
                  ].filter(([,val])=>val!=null).map(([lbl,val])=>(
                    <div key={lbl} style={{background:"var(--surface2)",borderRadius:"6px",padding:"7px 8px"}}>
                      <div style={{fontSize:"9px",fontFamily:"var(--font-input)",color:"var(--text3)"}}>{lbl}</div>
                      <div style={{fontSize:"12px",fontWeight:600,fontFamily:"var(--mono)",color:"var(--text)"}}>{val}</div>
                    </div>
                  ))}
                </div>
              </Card>
            )}

            {/* BLOQUE: Tu posicion */}
            {bloqueVisible("tu_posicion")&&pos.cantidad>0&&(
              <Card style={{marginBottom:"12px",border:"1px solid rgba(0,212,255,.2)"}}>
                <p style={{fontSize:"11px",fontFamily:"var(--font-input)",color:"var(--accent)",fontWeight:600,letterSpacing:".04em",marginBottom:"8px"}}>TU POSICION</p>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:"8px"}}>
                  <div style={{textAlign:"center"}}><div style={{fontWeight:800,fontFamily:"var(--mono)",fontSize:"16px",color:"var(--green)"}}>{pos.cantidad}</div><div style={{fontSize:"9px",color:"var(--text3)"}}>Titulos</div></div>
                  <div style={{textAlign:"center"}}><div style={{fontWeight:700,fontFamily:"var(--mono)",fontSize:"13px",color:"var(--yellow)"}}>{formatMoney(pos.promedio,"ARS")}</div><div style={{fontSize:"9px",color:"var(--text3)"}}>P. promedio</div></div>
                  <div style={{textAlign:"center"}}><div style={{fontWeight:700,fontFamily:"var(--mono)",fontSize:"13px",color:gananciaActual>=0?"var(--green)":"var(--red)"}}>{gananciaActual!==null?(gananciaActual>=0?"+":"")+formatMoney(gananciaActual,"ARS"):"--"}</div><div style={{fontSize:"9px",color:"var(--text3)"}}>{gananciaActual!=null&&gananciaActual<0?"Perdida":"Ganancia"}</div></div>
                </div>
                {ganPct!==null&&<div style={{textAlign:"center",marginTop:"6px",fontSize:"12px",fontWeight:700,color:ganPct>=0?"var(--green)":"var(--red)"}}>{ganPct>=0?"+":""}{ganPct.toFixed(2)}% total</div>}
              </Card>
            )}

            {/* BLOQUE: Grafico */}
            {bloqueVisible("grafico")&&datos.historico&&datos.historico.length>0&&(
              <Card style={{marginBottom:"12px"}}>
                <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginBottom:"8px"}}>GRAFICO</p>
                <GraficoLinea puntos={datos.historico.map(p=>({...p,cierre:convertirMoneda(p.cierre,moneda)}))} color={(moneda==="ARS"?datos.precio?.variacionPctARS:datos.precio?.variacionPctUSD)>=0?"var(--green)":"var(--red)"} moneda={moneda}/>
              </Card>
            )}

            {/* BLOQUE: Info empresa */}
            {bloqueVisible("info_empresa")&&datos.empresa&&(
              <Card style={{marginBottom:"12px"}}>
                <p style={{fontSize:"11px",fontFamily:"var(--font-input)",color:"var(--text3)",fontWeight:600,letterSpacing:".04em",marginBottom:"8px"}}>INFO</p>
                {datos.empresa.sector&&<div style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid var(--border)"}}><span style={{fontSize:"12px",color:"var(--text3)"}}>Sector</span><span style={{fontSize:"12px",fontWeight:600}}>{datos.empresa.sector}</span></div>}
                {datos.empresa.industria&&<div style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid var(--border)"}}><span style={{fontSize:"12px",color:"var(--text3)"}}>Industria</span><span style={{fontSize:"12px",fontWeight:600}}>{datos.empresa.industria}</span></div>}
                {datos.empresa.pais&&<div style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid var(--border)"}}><span style={{fontSize:"12px",color:"var(--text3)"}}>Pais</span><span style={{fontSize:"12px",fontWeight:600}}>{datos.empresa.pais}</span></div>}
                {datos.precio?.marketCap&&<div style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid var(--border)"}}><span style={{fontSize:"12px",color:"var(--text3)"}}>Market Cap</span><span style={{fontSize:"12px",fontWeight:600,fontFamily:"var(--mono)"}}>{(datos.precio.marketCap/1e9).toFixed(1)}B</span></div>}
                {datos.precio?.pe&&<div style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid var(--border)"}}><span style={{fontSize:"12px",color:"var(--text3)"}}>P/E</span><span style={{fontSize:"12px",fontWeight:600,fontFamily:"var(--mono)"}}>{datos.precio.pe}</span></div>}
                {datos.empresa.descripcion&&<p style={{fontSize:"12px",color:"var(--text3)",marginTop:"8px",lineHeight:1.5}}>{datos.empresa.descripcion.slice(0,300)}{datos.empresa.descripcion.length>300?"...":""}</p>}
              </Card>
            )}

            {/* BLOQUE: Dividendos - Pro Standard */}
            {bloqueVisible("dividendos")&&(
              tieneBloque("dividendos") ? (
                <Card style={{marginBottom:"12px",border:"1px solid rgba(251,191,36,.2)"}}>
                  <p style={{fontSize:"11px",color:"var(--yellow)",fontWeight:700,letterSpacing:".06em",marginBottom:"8px"}}>DIVIDENDOS</p>
                  {datos.dividendos?.exDividendo&&<div style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid var(--border)"}}><span style={{fontSize:"12px",color:"var(--text3)"}}>Ex-dividendo</span><span style={{fontSize:"12px",fontWeight:700,color:"var(--yellow)"}}>{datos.dividendos.exDividendo}</span></div>}
                  {datos.dividendos?.anual&&<div style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid var(--border)"}}><span style={{fontSize:"12px",color:"var(--text3)"}}>Dividendo anual</span><span style={{fontSize:"12px",fontWeight:600,fontFamily:"var(--mono)"}}>USD {datos.dividendos.anual}</span></div>}
                  {datos.dividendos?.yield&&<div style={{display:"flex",justifyContent:"space-between",padding:"4px 0"}}><span style={{fontSize:"12px",color:"var(--text3)"}}>Yield</span><span style={{fontSize:"12px",fontWeight:700,color:"var(--green)"}}>{datos.dividendos.yield}%</span></div>}
                  {!datos.dividendos?.anual&&<p style={{fontSize:"12px",color:"var(--text3)"}}>Este activo no paga dividendos.</p>}
                </Card>
              ):(
                <Card style={{marginBottom:"12px",background:"rgba(251,191,36,.04)",border:"1px solid rgba(251,191,36,.2)"}}>
                  <p style={{fontSize:"12px",color:"var(--yellow)"}}>Dividendos disponibles en Pro Standard</p>
                </Card>
              )
            )}

            {/* BLOQUE: Noticias - Pro Standard */}
            {bloqueVisible("noticias")&&(
              tieneBloque("noticias") ? (
                <Card style={{marginBottom:"12px"}}>
                  <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginBottom:"8px"}}>NOTICIAS RECIENTES</p>
                  {datos.noticias&&datos.noticias.length>0 ? datos.noticias.map((n,i)=>(
                    <div key={i} style={{padding:"8px 0",borderBottom:"1px solid var(--border)"}}>
                      <p style={{fontSize:"12px",fontWeight:600,marginBottom:"2px"}}>{n.titulo}</p>
                      <div style={{display:"flex",gap:"8px"}}><span style={{fontSize:"10px",color:"var(--text3)"}}>{n.fuente}</span><span style={{fontSize:"10px",color:"var(--text2)"}}>{n.fecha}</span></div>
                    </div>
                  )) : <p style={{fontSize:"12px",color:"var(--text3)"}}>Sin noticias recientes.</p>}
                </Card>
              ):(
                <Card style={{marginBottom:"12px",background:"rgba(251,191,36,.04)",border:"1px solid rgba(251,191,36,.2)"}}>
                  <p style={{fontSize:"12px",color:"var(--yellow)"}}>Noticias disponibles en Pro Standard</p>
                </Card>
              )
            )}

            {/* BLOQUE: Senales tecnicas - Pro Gold */}
            {bloqueVisible("senales")&&(
              tieneBloque("senales") ? (
                datos.senales ? (
                  <Card style={{marginBottom:"12px",border:"1px solid rgba(0,229,160,.2)"}}>
                    <p style={{fontSize:"11px",color:"var(--green)",fontWeight:700,letterSpacing:".06em",marginBottom:"8px"}}>SENALES TECNICAS</p>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"8px",marginBottom:"8px"}}>
                      <div style={{textAlign:"center",background:"var(--surface2)",borderRadius:"8px",padding:"10px"}}><div style={{fontFamily:"var(--mono)",fontWeight:800,fontSize:"20px",color:datos.senales.rsi<30?"var(--green)":datos.senales.rsi>70?"var(--red)":"var(--yellow)"}}>{datos.senales.rsi}</div><div style={{fontSize:"10px",color:"var(--text3)"}}>RSI 14</div><div style={{fontSize:"10px",color:"var(--text2)"}}>{datos.senales.rsiSenal}</div></div>
                      <div style={{textAlign:"center",background:"var(--surface2)",borderRadius:"8px",padding:"10px"}}><div style={{fontFamily:"var(--mono)",fontWeight:800,fontSize:"13px",color:datos.senales.tendencia==="alcista"?"var(--green)":"var(--red)"}}>{datos.senales.tendencia==="alcista"?"\u2191 Alcista":"\u2193 Bajista"}</div><div style={{fontSize:"10px",color:"var(--text3)"}}>Tendencia</div><div style={{fontSize:"10px",color:"var(--text2)"}}>MM20: {formatMoney(datos.senales.mm20,"USD")}</div></div>
                    </div>
                    <div style={{textAlign:"center",padding:"10px",background:datos.senales.senalGeneral==="Comprar"?"rgba(0,229,160,.1)":datos.senales.senalGeneral==="Vender"?"rgba(255,77,109,.1)":"var(--surface2)",borderRadius:"8px"}}>
                      <div style={{fontWeight:800,fontSize:"16px",color:datos.senales.senalGeneral==="Comprar"?"var(--green)":datos.senales.senalGeneral==="Vender"?"var(--red)":"var(--yellow)"}}>{datos.senales.senalGeneral}</div>
                      <div style={{fontSize:"10px",color:"var(--text3)"}}>Senal general</div>
                    </div>
                    <p style={{fontSize:"10px",color:"var(--text2)",marginTop:"8px",textAlign:"center"}}>Solo informativo. No es asesoramiento financiero.</p>
                  </Card>
                ) : <p style={{fontSize:"12px",color:"var(--text3)",textAlign:"center",padding:"10px"}}>Historial insuficiente para calcular senales.</p>
              ):(
                <Card style={{marginBottom:"12px",background:"rgba(124,58,237,.06)",border:"1px solid rgba(124,58,237,.3)"}}>
                  <p style={{fontSize:"12px",color:"var(--accent2)"}}>Senales tecnicas disponibles en Pro Gold</p>
                </Card>
              )
            )}

            {/* BLOQUE: Mensajes de usuarios - Pro Gold */}
            {bloqueVisible("mensajes")&&(
              tieneBloque("mensajes") ? (
                <Card style={{marginBottom:"12px"}}>
                  <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginBottom:"8px"}}>MENSAJES DE LA COMUNIDAD</p>
                  <div style={{marginBottom:"10px"}}>
                    <input value={nuevoMensaje} onChange={e=>setNuevoMensaje(e.target.value)} placeholder="Escribi tu opinion sobre este activo..." maxLength={500}/>
                    {errMsg&&<p style={{fontSize:"11px",color:"var(--red)",marginTop:"4px"}}>{errMsg}</p>}
                    <Btn onClick={publicarMensaje} disabled={enviandoMsg||!nuevoMensaje.trim()} size="sm" style={{width:"100%",marginTop:"6px"}}>{enviandoMsg?"Publicando...":"Publicar"}</Btn>
                  </div>
                  {mensajes.length===0&&<p style={{fontSize:"12px",color:"var(--text3)",textAlign:"center"}}>Se el primero en comentar.</p>}
                  {mensajes.map(m=>(
                    <div key={m.id} style={{padding:"8px 0",borderBottom:"1px solid var(--border)"}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                        <div style={{flex:1}}>
                          <div style={{display:"flex",gap:"6px",marginBottom:"2px"}}><span style={{fontSize:"11px",fontWeight:700,color:"var(--accent)"}}>{m.autorNombre}</span><span style={{fontSize:"10px",color:"var(--text3)"}}>{m.fecha}</span></div>
                          <p style={{fontSize:"12px",color:"var(--text)",lineHeight:1.4}}>{m.mensaje}</p>
                        </div>
                        {esAdmin&&<button onClick={()=>eliminarMensaje(m.id)} style={{background:"none",border:"none",color:"var(--red)",cursor:"pointer",fontSize:"12px",flexShrink:0,marginLeft:"8px"}}>X</button>}
                      </div>
                    </div>
                  ))}
                </Card>
              ):(
                <Card style={{marginBottom:"12px",background:"rgba(124,58,237,.06)",border:"1px solid rgba(124,58,237,.3)"}}>
                  <p style={{fontSize:"12px",color:"var(--accent2)"}}>Mensajes de la comunidad disponibles en Pro Gold</p>
                </Card>
              )
            )}
          </>
        )}
      </div>
    </div>
  );
};

const ActivosTab = ({activos,operaciones,user,onAddActivo,onAddSolicitud,solicitudes,onUpgrade,favoritos,onToggleFavorito,precios}) => {
  const [showNew,setShowNew] = useState(false);
  const [form,setForm] = useState({ticker:"",nombre:"",tipo:"Cedear"});
  const [detalleActivo,setDetalleActivo] = useState(null);
  const [enviada,setEnviada] = useState(false);
  const [busqueda,setBusqueda] = useState("");
  const [filtroTipo,setFiltroTipo] = useState("Todos");
  const [verFavoritos,setVerFavoritos] = useState(false);
  const [avisoLimite,setAvisoLimite] = useState(false);
  const [vistaActivos,setVistaActivos] = useState("todos");
  const [rankingPeriodo,setRankingPeriodo] = useState("hoy");
  const [rankingMoneda,setRankingMoneda] = useState("ARS");
  const [rankingTipo,setRankingTipo] = useState("Todos");
  const [rankingGanadores,setRankingGanadores] = useState([]);
  const [rankingPerdedores,setRankingPerdedores] = useState([]);
  const [cargandoRanking,setCargandoRanking] = useState(false);
  const cargarRanking = async (periodo,moneda,tipo) => {
    if (periodo==="hoy") {
      const lista = activos
        .filter(a=>tipo==="Todos"||a.tipo===tipo)
        .map(a=>{
          const dato = precios?precios[a.ticker]:null;
          const variacionPct = dato ? (moneda==="ARS"?dato.variacionPctARS:dato.variacionPctUSD) : null;
          const precioActual = dato ? (moneda==="ARS"?dato.precioARS:dato.precioUSD) : null;
          return {ticker:a.ticker,nombre:a.nombre,tipo:a.tipo,precioActual,variacionPct};
        })
        .filter(x=>x.variacionPct!==null&&x.variacionPct!==undefined);
      const ordenados = [...lista].sort((a,b)=>b.variacionPct-a.variacionPct);
      setRankingGanadores(ordenados.slice(0,10));
      setRankingPerdedores([...ordenados].reverse().slice(0,10));
      return;
    }
    setCargandoRanking(true);
    const resp = await api.rankingVariaciones(periodo,moneda,tipo==="Todos"?null:tipo,10);
    setCargandoRanking(false);
    if (resp.ok) { setRankingGanadores(resp.ganadores); setRankingPerdedores(resp.perdedores); }
    else { setRankingGanadores([]); setRankingPerdedores([]); }
  };
  const misOps = operaciones.filter(op=>user.rol==="admin"||op.userId===user.id);
  const misFavoritos = favoritos||[];
  const tiposDisponibles = ["Todos",...new Set(activos.map(a=>a.tipo))].filter((v,i,a)=>a.indexOf(v)===i);
  const activosFiltrados = filtroTipo==="Todos" ? activos : activos.filter(a=>a.tipo===filtroTipo);
  const usados = activosFiltrados.filter(a=>misOps.some(op=>op.ticker===a.ticker));
  const noUsados = activosFiltrados.filter(a=>!misOps.some(op=>op.ticker===a.ticker));
  const activosFavoritos = activos.filter(a=>misFavoritos.includes(a.ticker));
  const misSolicitudes = (solicitudes||[]).filter(s=>s.userId===user.id);
  const esAdmin = user.rol==="admin";
  const sugerencias = busqueda.trim().length>0
    ? activos.filter(a=>a.ticker.toLowerCase().includes(busqueda.toLowerCase())||a.nombre.toLowerCase().includes(busqueda.toLowerCase())).slice(0,8)
    : [];
  const [guardandoActivo,setGuardandoActivo] = useState(false);
  const save = async () => {
    if (!form.ticker||!form.nombre) return;
    setGuardandoActivo(true);
    let ok;
    if (esAdmin) {
      ok = await onAddActivo({id:Date.now().toString(),ticker:form.ticker.toUpperCase(),nombre:form.nombre,tipo:form.tipo});
    } else {
      ok = await onAddSolicitud({id:Date.now().toString(),userId:user.id,ticker:form.ticker.toUpperCase(),nombre:form.nombre,tipo:form.tipo,fecha:new Date().toLocaleDateString("es-AR"),estado:"pendiente"});
      if (ok) { setEnviada(true); setTimeout(()=>setEnviada(false),3000); }
    }
    setGuardandoActivo(false);
    if (ok) { setForm({ticker:"",nombre:"",tipo:"Cedear"}); setShowNew(false); }
  };
  const irAlDetalle = (ticker) => { setDetalleActivo(ticker); setBusqueda(""); };
  const toggleFav = (ticker) => {
    const esFav = misFavoritos.includes(ticker);
    if (!esFav&&misFavoritos.length>=15) { setAvisoLimite(true); setTimeout(()=>setAvisoLimite(false),3500); return; }
    onToggleFavorito(ticker);
  };

  if (detalleActivo) {
    const a = activos.find(x=>x.ticker===detalleActivo);
    if (!a) { setDetalleActivo(null); return null; }
    return (
      <DetalleActivoEnriquecido
        ticker={detalleActivo}
        activo={a}
        user={user}
        operaciones={operaciones}
        precios={precios}
        favoritos={misFavoritos}
        onToggleFavorito={toggleFav}
        onVolver={()=>setDetalleActivo(null)}
      />
    );
  }

  if (vistaActivos==="ranking") {
    const colorVar = (v) => v>0?"var(--green)":v<0?"var(--red)":"var(--text3)";
    return (
      <div className="scroll-area" style={{padding:"14px 14px 90px",overflowY:"auto",height:"100%"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"14px",gap:"8px"}}>
          <h1 style={{fontSize:"20px",fontWeight:800}}>Activos</h1>
          <div style={{display:"flex",gap:"6px"}}>
            <button onClick={()=>setVistaActivos("todos")} style={{padding:"6px 12px",borderRadius:"var(--rs)",fontSize:"12px",fontWeight:700,cursor:"pointer",border:"1px solid var(--border)",background:"var(--surface2)",color:"var(--text3)"}}>Todos</button>
            <button style={{padding:"6px 12px",borderRadius:"var(--rs)",fontSize:"12px",fontWeight:700,cursor:"pointer",border:"1px solid var(--accent)",background:"rgba(0,212,255,.1)",color:"var(--accent)"}}>Ranking</button>
          </div>
        </div>

        <div style={{display:"flex",gap:"5px",marginBottom:"8px",flexWrap:"wrap"}}>
          {[["hoy","Hoy"],["1mo","30D"],["3mo","3M"],["6mo","6M"],["1y","1A"]].map(([v,l])=>(
            <FilterBtn key={v} label={l} active={rankingPeriodo===v} onClick={()=>{setRankingPeriodo(v);cargarRanking(v,rankingMoneda,rankingTipo);}}/>
          ))}
        </div>
        <div style={{display:"flex",gap:"5px",marginBottom:"8px"}}>
          {["ARS","USD"].map(m=>(
            <button key={m} onClick={()=>{setRankingMoneda(m);cargarRanking(rankingPeriodo,m,rankingTipo);}} style={{flex:1,padding:"6px",borderRadius:"var(--rs)",fontSize:"12px",fontWeight:700,cursor:"pointer",border:"1px solid "+(rankingMoneda===m?"var(--accent)":"var(--border)"),background:rankingMoneda===m?"rgba(0,212,255,.1)":"var(--surface2)",color:rankingMoneda===m?"var(--accent)":"var(--text3)"}}>{m}</button>
          ))}
        </div>
        <div style={{display:"flex",gap:"5px",marginBottom:"14px",flexWrap:"wrap"}}>
          {tiposDisponibles.map(t=>(
            <FilterBtn key={t} label={t} active={rankingTipo===t} onClick={()=>{setRankingTipo(t);cargarRanking(rankingPeriodo,rankingMoneda,t);}}/>
          ))}
        </div>

        {cargandoRanking&&<p style={{fontSize:"12px",color:"var(--text3)",textAlign:"center",padding:"20px 0"}}>Cargando ranking...</p>}

        {!cargandoRanking&&rankingGanadores.length===0&&rankingPerdedores.length===0&&(
          <p style={{fontSize:"12px",color:"var(--text2)",textAlign:"center",padding:"30px 0"}}>Sin datos suficientes para este periodo todavia. Elegi "Hoy" o un periodo mas corto.</p>
        )}

        {!cargandoRanking&&(rankingGanadores.length>0||rankingPerdedores.length>0)&&(
          <div style={{display:"flex",flexDirection:"column",gap:"18px"}}>
            <div>
              <p style={{fontSize:"11px",color:"var(--green)",fontWeight:700,letterSpacing:".06em",marginBottom:"8px"}}>MAS SUBIERON</p>
              <div style={{display:"flex",flexDirection:"column",gap:"6px"}}>
                {rankingGanadores.map(r=>(
                  <Card key={r.ticker} onClick={()=>irAlDetalle(r.ticker)} style={{cursor:"pointer"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div><div style={{fontWeight:700,fontSize:"13px"}}>{r.ticker}</div><div style={{fontSize:"11px",color:"var(--text3)"}}>{r.nombre}</div></div>
                      <div style={{textAlign:"right"}}>
                        <div style={{fontFamily:"var(--font-input)",fontWeight:700,fontSize:"14px",color:colorVar(r.variacionPct)}}>{r.variacionPct>0?"+":""}{r.variacionPct}%</div>
                        {r.precioActual&&<div style={{fontFamily:"var(--mono)",fontSize:"11px",color:"var(--text3)"}}>{formatMoney(r.precioActual,rankingMoneda)}</div>}
                      </div>
                    </div>
                  </Card>
                ))}
              </div>
            </div>
            <div>
              <p style={{fontSize:"11px",color:"var(--red)",fontWeight:700,letterSpacing:".06em",marginBottom:"8px"}}>MAS CAYERON</p>
              <div style={{display:"flex",flexDirection:"column",gap:"6px"}}>
                {rankingPerdedores.map(r=>(
                  <Card key={r.ticker} onClick={()=>irAlDetalle(r.ticker)} style={{cursor:"pointer"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div><div style={{fontWeight:700,fontSize:"13px"}}>{r.ticker}</div><div style={{fontSize:"11px",color:"var(--text3)"}}>{r.nombre}</div></div>
                      <div style={{textAlign:"right"}}>
                        <div style={{fontFamily:"var(--font-input)",fontWeight:700,fontSize:"14px",color:colorVar(r.variacionPct)}}>{r.variacionPct>0?"+":""}{r.variacionPct}%</div>
                        {r.precioActual&&<div style={{fontFamily:"var(--mono)",fontSize:"11px",color:"var(--text3)"}}>{formatMoney(r.precioActual,rankingMoneda)}</div>}
                      </div>
                    </div>
                  </Card>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="scroll-area" style={{padding:"14px 14px 90px",overflowY:"auto",height:"100%"}}>
      {avisoLimite&&(
        <div style={{position:"fixed",bottom:"78px",left:"14px",right:"14px",zIndex:200,background:"var(--red)",color:"#fff",borderRadius:"var(--rs)",padding:"10px 14px",fontSize:"13px",fontWeight:600,textAlign:"center",boxShadow:"0 8px 24px rgba(0,0,0,.4)"}}>
          Llegaste al maximo de 15 favoritos. Sacá alguno para agregar otro.
        </div>
      )}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"12px",gap:"8px"}}>
        <h1 style={{fontSize:"20px",fontWeight:800}}>Activos</h1>
        <div style={{display:"flex",gap:"6px"}}>
          <Btn onClick={()=>{setVistaActivos("ranking");cargarRanking(rankingPeriodo,rankingMoneda,rankingTipo);}} size="sm" variant="ghost">Ranking</Btn>
          <Btn onClick={()=>setVerFavoritos(s=>!s)} size="sm" variant={verFavoritos?"primary":"ghost"}>{"\u2605"} Mis favoritos{misFavoritos.length>0?" ("+misFavoritos.length+")":""}</Btn>
          <Btn onClick={()=>setShowNew(s=>!s)} size="sm">{showNew?"Cancelar":esAdmin?"+ Nuevo":"Solicitar activo"}</Btn>
        </div>
      </div>

      <div style={{position:"relative",marginBottom:"16px"}}>
        <input value={busqueda} onChange={e=>setBusqueda(e.target.value)} placeholder="Buscar por ticker o nombre..." />
        {sugerencias.length>0&&(
          <div style={{position:"absolute",top:"calc(100% + 4px)",left:0,right:0,background:"var(--surface)",border:"1px solid var(--accent)",borderRadius:"var(--rs)",zIndex:50,maxHeight:"260px",overflowY:"auto",boxShadow:"0 8px 24px rgba(0,0,0,.4)"}}>
            {sugerencias.map(a=>(
              <div key={a.id} onClick={()=>irAlDetalle(a.ticker)} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 12px",cursor:"pointer",borderBottom:"1px solid var(--border)"}}
                onMouseEnter={e=>e.currentTarget.style.background="var(--surface2)"}
                onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                <div><span style={{fontWeight:700,fontSize:"13px"}}>{a.ticker}</span><span style={{fontSize:"12px",color:"var(--text3)",marginLeft:"8px"}}>{a.nombre}</span></div>
                <Badge variant="default" size="sm">{a.tipo}</Badge>
              </div>
            ))}
          </div>
        )}
      </div>

      <div style={{display:"flex",gap:"5px",flexWrap:"wrap",marginBottom:"14px"}}>
        {tiposDisponibles.map(t=>(
          <FilterBtn key={t} label={t} active={filtroTipo===t} onClick={()=>setFiltroTipo(t)}/>
        ))}
      </div>
      {enviada&&(
        <Card style={{marginBottom:"14px",border:"1px solid rgba(0,229,160,.4)",background:"rgba(0,229,160,.06)"}}>
          <p style={{fontSize:"13px",color:"var(--green)",fontWeight:700}}>Solicitud enviada. El administrador la va a revisar y agregar el activo si corresponde.</p>
        </Card>
      )}
      {!esAdmin&&!showNew&&misSolicitudes.length>0&&(
        <Card style={{marginBottom:"14px"}}>
          <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginBottom:"8px"}}>MIS SOLICITUDES</p>
          {misSolicitudes.map(s=>(
            <div key={s.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 0",borderBottom:"1px solid var(--border)"}}>
              <div><span style={{fontWeight:700}}>{s.ticker}</span><span style={{fontSize:"12px",color:"var(--text3)",marginLeft:"6px"}}>{s.nombre}</span></div>
              <Badge variant={s.estado==="aprobada"?"compra":s.estado==="rechazada"?"venta":"default"} size="sm">{s.estado}</Badge>
            </div>
          ))}
        </Card>
      )}
      {showNew&&(
        <Card style={{marginBottom:"14px",border:"1px solid var(--accent)"}}>
          <p style={{fontWeight:700,color:"var(--accent)",fontSize:"12px",marginBottom:"10px"}}>{esAdmin?"NUEVO ACTIVO":"SOLICITAR ACTIVO NUEVO"}</p>
          {!esAdmin&&<p style={{fontSize:"12px",color:"var(--text3)",marginBottom:"10px"}}>Si el activo que necesitas no esta en la lista, solicitalo aca. El administrador lo va a revisar y agregar con el ticker correcto.</p>}
          <Field label="Ticker que creo correcto"><input value={form.ticker} onChange={e=>setForm(f=>({...f,ticker:e.target.value.toUpperCase()}))} placeholder="MELI, BTC..."/></Field>
          <Field label="Nombre"><input value={form.nombre} onChange={e=>setForm(f=>({...f,nombre:e.target.value}))} placeholder="MercadoLibre..."/></Field>
          <Field label="Tipo"><select value={form.tipo} onChange={e=>setForm(f=>({...f,tipo:e.target.value}))}>{["Cedear","Accion AR","Accion USA","ETF","Cripto","Bono","FCI","Plazo Fijo","Otro"].map(t=><option key={t}>{t}</option>)}</select></Field>
          <Btn onClick={save} disabled={!form.ticker||!form.nombre||guardandoActivo} style={{width:"100%",marginTop:"4px"}}>{guardandoActivo?"Guardando...":esAdmin?"Guardar":"Enviar solicitud"}</Btn>
        </Card>
      )}
      {verFavoritos&&(
        <>
          <p style={{fontSize:"11px",color:"var(--yellow)",fontWeight:700,letterSpacing:".06em",textTransform:"uppercase",marginBottom:"7px"}}>Mis favoritos ({activosFavoritos.length}/15)</p>
          {activosFavoritos.length===0&&(
            <div style={{textAlign:"center",padding:"30px 0",color:"var(--text2)"}}>
              <p>Todavia no tenes activos favoritos.</p>
              <p style={{fontSize:"12px",marginTop:"4px"}}>Entra al detalle de un activo y toca la estrella para agregarlo.</p>
            </div>
          )}
          <div style={{display:"flex",flexDirection:"column",gap:"9px",marginBottom:"18px"}}>
            {activosFavoritos.map(a=>(
              <Card key={a.id} onClick={()=>setDetalleActivo(a.ticker)}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"9px"}}>
                  <div style={{display:"flex",alignItems:"center",gap:"9px"}}>
                    <div style={{width:"38px",height:"38px",borderRadius:"9px",background:"rgba(0,212,255,.08)",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:"11px",color:"var(--accent)",fontFamily:"var(--mono)"}}>{a.ticker.slice(0,4)}</div>
                    <div><div style={{fontWeight:600,fontSize:"14px",fontFamily:"var(--font-input)",color:"var(--text)"}}>{a.ticker}</div><div style={{fontSize:"12px",color:"var(--text3)"}}>{a.nombre}</div></div>
                  </div>
                  <Badge variant="default" size="sm">{a.tipo}</Badge>
                </div>
                <div style={{display:"flex",gap:"8px",paddingTop:"8px",borderTop:"1px solid var(--border)"}}>
                  <PrecioLock moneda="ARS" ticker={a.ticker} precios={precios}/>
                  <PrecioLock moneda="USD" ticker={a.ticker} precios={precios}/>
                </div>
              </Card>
            ))}
          </div>
        </>
      )}

      {!verFavoritos&&usados.length>0&&(
        <>
          <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",textTransform:"uppercase",marginBottom:"7px"}}>Con operaciones</p>
          <div style={{display:"flex",flexDirection:"column",gap:"9px",marginBottom:"18px"}}>
            {usados.map(a=>{
              const pos=calcPosicion(misOps,user.id,a.ticker);
              const ops=misOps.filter(op=>op.ticker===a.ticker);
              return (
                <Card key={a.id} onClick={()=>setDetalleActivo(a.ticker)}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"9px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:"9px"}}>
                      <div style={{width:"38px",height:"38px",borderRadius:"9px",background:"rgba(0,212,255,.08)",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:"11px",color:"var(--accent)",fontFamily:"var(--mono)"}}>{a.ticker.slice(0,4)}</div>
                      <div><div style={{fontWeight:600,fontSize:"14px",fontFamily:"var(--font-input)",color:"var(--text)"}}>{a.ticker}</div><div style={{fontSize:"12px",color:"var(--text3)"}}>{a.nombre}</div></div>
                    </div>
                    <Badge variant="default" size="sm">{a.tipo}</Badge>
                  </div>
                  <div style={{display:"flex",gap:"8px",paddingTop:"8px",borderTop:"1px solid var(--border)"}}>
                    <div style={{flex:1,textAlign:"center"}}><div style={{fontWeight:700,fontFamily:"var(--mono)",fontSize:"15px"}}>{ops.length}</div><div style={{fontSize:"9px",color:"var(--text3)"}}>Ops</div></div>
                    <div style={{flex:1,textAlign:"center"}}><div style={{fontWeight:700,fontFamily:"var(--mono)",fontSize:"15px",color:pos.cantidad>0?"var(--green)":"var(--text3)"}}>{pos.cantidad}</div><div style={{fontSize:"9px",color:"var(--text3)"}}>En cartera</div></div>
                    <PrecioLock moneda="ARS" ticker={a.ticker} precios={precios}/>
                    <PrecioLock moneda="USD" ticker={a.ticker} precios={precios}/>
                  </div>
                </Card>
              );
            })}
          </div>
        </>
      )}
      {!verFavoritos&&noUsados.length>0&&(
        <>
          <p style={{fontSize:"11px",color:"var(--text2)",fontWeight:700,letterSpacing:".06em",textTransform:"uppercase",marginBottom:"7px"}}>Sin operaciones</p>
          <div style={{display:"flex",flexDirection:"column",gap:"7px"}}>
            {noUsados.map(a=>(
              <Card key={a.id} style={{opacity:.85}} onClick={()=>setDetalleActivo(a.ticker)}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"8px"}}>
                  <div><span style={{fontWeight:600,fontSize:"14px",fontFamily:"var(--font-input)",color:"var(--text)"}}>{a.ticker}</span><span style={{color:"var(--text3)",marginLeft:"7px",fontSize:"12px"}}>{a.nombre}</span></div>
                  <Badge variant="default" size="sm">{a.tipo}</Badge>
                </div>
                <div style={{display:"flex",gap:"8px"}}>
                  <PrecioLock moneda="ARS" ticker={a.ticker} precios={precios}/>
                  <PrecioLock moneda="USD" ticker={a.ticker} precios={precios}/>
                </div>
              </Card>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

const ResumenTab = ({operaciones,user,precios}) => {
  const [periodo,setPeriodo] = useState("TODOS");
  const [desde,setDesde] = useState("");
  const [hasta,setHasta] = useState("");
  const [filtroBroker,setFiltroBroker] = useState("TODOS");
  const misOps = operaciones.filter(op=>user.rol==="admin"||op.userId===user.id);
  const brokers = [...new Set(misOps.map(o=>o.broker).filter(Boolean))];
  const opsPeriodo = useMemo(()=>filtrarPorPeriodo(misOps,periodo,desde,hasta),[misOps,periodo,desde,hasta]);
  const ops = useMemo(()=>filtroBroker==="TODOS"?opsPeriodo:opsPeriodo.filter(o=>o.broker===filtroBroker),[opsPeriodo,filtroBroker]);
  const cs=ops.filter(o=>o.tipo==="COMPRA"), vs=ops.filter(o=>o.tipo==="VENTA");
  const tARS_c=cs.filter(o=>o.moneda==="ARS").reduce((s,o)=>s+parseFloat(o.precio)*parseFloat(o.cantidad),0);
  const tUSD_c=cs.filter(o=>o.moneda==="USD").reduce((s,o)=>s+parseFloat(o.precio)*parseFloat(o.cantidad),0);
  const tARS_v=vs.filter(o=>o.moneda==="ARS").reduce((s,o)=>s+parseFloat(o.precio)*parseFloat(o.cantidad),0);
  const tUSD_v=vs.filter(o=>o.moneda==="USD").reduce((s,o)=>s+parseFloat(o.precio)*parseFloat(o.cantidad),0);
  const porActivo=[...new Set(ops.map(o=>o.ticker))].map(ticker=>{
    const t=ops.filter(o=>o.ticker===ticker);
    const c=t.filter(o=>o.tipo==="COMPRA"),v=t.filter(o=>o.tipo==="VENTA");
    const moneda=t[0]?.moneda||"ARS";
    const inv=c.reduce((s,o)=>s+parseFloat(o.precio)*parseFloat(o.cantidad),0);
    const vnd=v.reduce((s,o)=>s+parseFloat(o.precio)*parseFloat(o.cantidad),0);
    const cantC=c.reduce((s,o)=>s+parseFloat(o.cantidad),0);
    // La posicion actual (cantidad real en cartera y precio promedio) se
    // calcula siempre sobre TODO el historial del ticker, sin importar el
    // filtro de broker o periodo activo -- porque la posicion no se
    // trackea por broker en esta app, es una sola por ticker. El filtro
    // de broker/periodo solo afecta que operaciones se listan y se suman
    // en Comprado/Vendido de arriba.
    const posActual = calcPosicion(misOps,user.id,ticker);
    const dato = precios ? precios[ticker] : null;
    const precioActual = dato ? (moneda==="ARS"?dato.precioARS:dato.precioUSD) : null;
    const gananciaActual = (posActual.cantidad>0&&precioActual)?(precioActual-posActual.promedio)*posActual.cantidad:null;
    const rendActualPct = (posActual.promedio>0&&precioActual)?((precioActual-posActual.promedio)/posActual.promedio)*100:null;
    return {ticker,total:t.length,inv,vnd,cantC,moneda,posActual,precioActual,gananciaActual,rendActualPct,ops:t.sort((a,b)=>parseFecha(b.fecha)-parseFecha(a.fecha))};
  });
  return (
    <div className="scroll-area" style={{padding:"14px 14px 90px",overflowY:"auto",height:"100%"}}>
      <h1 style={{fontSize:"20px",fontWeight:800,marginBottom:"12px"}}>Resumen</h1>
      <div style={{display:"flex",gap:"7px",marginBottom:"12px"}}>
        <Btn variant="excel" size="sm" onClick={()=>exportarExcel(ops,"Resumen")}>Excel</Btn>
        <Btn variant="pdf" size="sm" onClick={()=>exportarPDF(ops,"Resumen")}>PDF</Btn>
      </div>
      <div style={{marginBottom:"14px"}}><FiltroPeriodo valor={periodo} setValor={setPeriodo} desde={desde} setDesde={setDesde} hasta={hasta} setHasta={setHasta}/></div>
      {brokers.length>1&&(
        <div style={{marginBottom:"14px"}}>
          <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",textTransform:"uppercase",marginBottom:"7px"}}>Broker</p>
          <div style={{display:"flex",gap:"5px",flexWrap:"wrap"}}>
            <FilterBtn label="Todos" active={filtroBroker==="TODOS"} onClick={()=>setFiltroBroker("TODOS")}/>
            {brokers.map(b=><FilterBtn key={b} label={b} active={filtroBroker===b} onClick={()=>setFiltroBroker(b)}/>)}
          </div>
        </div>
      )}
      <div style={{display:"flex",gap:"7px",flexWrap:"wrap",marginBottom:"18px"}}>
        {tARS_c>0&&<Card style={{flex:1,minWidth:"120px"}}><div style={{fontSize:"11px",color:"var(--text3)",marginBottom:"3px"}}>Invertido ARS</div><div style={{fontFamily:"var(--mono)",fontWeight:700,fontSize:"13px",color:"var(--yellow)"}}>{formatMoney(tARS_c,"ARS")}</div></Card>}
        {tUSD_c>0&&<Card style={{flex:1,minWidth:"120px"}}><div style={{fontSize:"11px",color:"var(--text3)",marginBottom:"3px"}}>Invertido USD</div><div style={{fontFamily:"var(--mono)",fontWeight:700,fontSize:"13px",color:"var(--accent)"}}>{formatMoney(tUSD_c,"USD")}</div></Card>}
        {tARS_v>0&&<Card style={{flex:1,minWidth:"120px"}}><div style={{fontSize:"11px",color:"var(--text3)",marginBottom:"3px"}}>Vendido ARS</div><div style={{fontFamily:"var(--mono)",fontWeight:700,fontSize:"13px",color:"var(--green)"}}>{formatMoney(tARS_v,"ARS")}</div></Card>}
        {tUSD_v>0&&<Card style={{flex:1,minWidth:"120px"}}><div style={{fontSize:"11px",color:"var(--text3)",marginBottom:"3px"}}>Vendido USD</div><div style={{fontFamily:"var(--mono)",fontWeight:700,fontSize:"13px",color:"var(--green)"}}>{formatMoney(tUSD_v,"USD")}</div></Card>}
      </div>
      <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",textTransform:"uppercase",marginBottom:"7px"}}>Detalle por activo</p>
      <div style={{display:"flex",flexDirection:"column",gap:"10px"}}>
        {porActivo.map(a=>(
          <Card key={a.ticker}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"10px"}}>
              <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
                <div style={{width:"34px",height:"34px",borderRadius:"8px",background:"rgba(0,212,255,.08)",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:"11px",color:"var(--accent)",fontFamily:"var(--mono)"}}>{a.ticker.slice(0,4)}</div>
                <span style={{fontWeight:800,fontSize:"15px"}}>{a.ticker}</span>
              </div>
              <Badge variant="default" size="sm">{a.total} ops</Badge>
            </div>
            {a.cantC>0&&<div style={{marginBottom:"10px"}}><span style={{fontWeight:800,fontSize:"18px"}}>{a.cantC}</span> <span style={{fontSize:"12px",color:"var(--text3)"}}>titulos comprados en total</span></div>}
            {a.posActual.cantidad>0&&(
              <div style={{background:"var(--surface2)",border:"1px solid rgba(0,212,255,.2)",borderRadius:"var(--rs)",padding:"9px",marginBottom:"10px"}}>
                <p style={{fontSize:"10px",color:"var(--accent)",fontWeight:700,letterSpacing:".05em",marginBottom:"6px"}}>POSICION ACTUAL</p>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:"6px"}}>
                  <div style={{textAlign:"center"}}><div style={{fontWeight:800,fontFamily:"var(--mono)",fontSize:"14px"}}>{a.posActual.cantidad}</div><div style={{fontSize:"9px",color:"var(--text3)"}}>Titulos</div></div>
                  <div style={{textAlign:"center"}}><div style={{fontWeight:700,fontFamily:"var(--mono)",fontSize:"12px",color:"var(--yellow)"}}>{formatMoney(a.posActual.promedio,a.moneda)}</div><div style={{fontSize:"9px",color:"var(--text3)"}}>P. promedio</div></div>
                  <div style={{textAlign:"center"}}><div style={{fontWeight:700,fontFamily:"var(--mono)",fontSize:"12px"}}>{a.precioActual?formatMoney(a.precioActual,a.moneda):"--"}</div><div style={{fontSize:"9px",color:"var(--text3)"}}>Precio actual</div></div>
                  <div style={{textAlign:"center"}}><div style={{fontWeight:700,fontFamily:"var(--mono)",fontSize:"12px",color:a.gananciaActual!=null?(a.gananciaActual>=0?"var(--green)":"var(--red)"):"var(--text3)"}}>{a.gananciaActual!=null?(a.gananciaActual>=0?"+":"")+formatMoney(a.gananciaActual,a.moneda):"--"}</div><div style={{fontSize:"9px",color:"var(--text3)"}}>{a.gananciaActual!=null&&a.gananciaActual<0?"Perdida":"Ganancia"}</div></div>
                </div>
                {a.rendActualPct!=null&&<div style={{textAlign:"center",marginTop:"6px",fontSize:"11px",fontWeight:700,color:a.rendActualPct>=0?"var(--green)":"var(--red)"}}>{a.rendActualPct>=0?"+":""}{a.rendActualPct.toFixed(2)}%</div>}
              </div>
            )}
            <div style={{display:"flex",gap:"8px",marginBottom:"10px"}}>
              {a.inv>0&&<div style={{flex:1,background:"var(--surface2)",borderRadius:"var(--rs)",padding:"7px 9px"}}><div style={{fontSize:"10px",color:"var(--text3)"}}>Comprado</div><div style={{fontFamily:"var(--mono)",fontSize:"12px",fontWeight:700,color:"var(--yellow)"}}>{formatMoney(a.inv,a.moneda)}</div></div>}
              {a.vnd>0&&<div style={{flex:1,background:"var(--surface2)",borderRadius:"var(--rs)",padding:"7px 9px"}}><div style={{fontSize:"10px",color:"var(--text3)"}}>Vendido</div><div style={{fontFamily:"var(--mono)",fontSize:"12px",fontWeight:700,color:"var(--green)"}}>{formatMoney(a.vnd,a.moneda)}</div></div>}
              {a.inv>0&&a.vnd>0&&<div style={{flex:1,background:"var(--surface2)",borderRadius:"var(--rs)",padding:"7px 9px"}}><div style={{fontSize:"10px",color:"var(--text3)"}}>Balance</div><div style={{fontFamily:"var(--mono)",fontSize:"12px",fontWeight:700,color:a.vnd-a.inv>=0?"var(--green)":"var(--red)"}}>{a.vnd-a.inv>=0?"+":""}{formatMoney(a.vnd-a.inv,a.moneda)}</div></div>}
            </div>
            <Divider label="operaciones"/>
            {a.ops.map(op=>{
              const total=parseFloat(op.precio)*parseFloat(op.cantidad);
              return (
                <div key={op.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 0",borderBottom:"1px solid var(--border)"}}>
                  <div>
                    <div style={{display:"flex",alignItems:"center",gap:"4px"}}><Badge variant={op.tipo==="COMPRA"?"compra":"venta"} size="sm">{op.tipo}</Badge><span style={{fontSize:"11px",color:"var(--text3)"}}>{op.fecha}</span></div>
                    <div style={{fontSize:"11px",color:"var(--text3)",marginTop:"1px"}}>{op.cantidad} tit - {formatMoney(op.precio,op.moneda)} - {op.comision}%</div>
                  </div>
                  <div style={{textAlign:"right",flexShrink:0}}><div style={{fontFamily:"var(--mono)",fontSize:"12px",fontWeight:700}}>{formatMoney(total,op.moneda)}</div><div style={{fontSize:"10px",color:"var(--text3)"}}>{op.broker}</div></div>
                </div>
              );
            })}
          </Card>
        ))}
        {porActivo.length===0&&<div style={{textAlign:"center",padding:"40px 0",color:"var(--text2)"}}><p>Sin operaciones en este periodo</p></div>}
      </div>
    </div>
  );
};

const SimuladorTab = ({user,operaciones,activos,configData,ipc,simulaciones,precios,onAddSim,onDeleteSim,onUpdatePrecioSim,onGuardarPrecioSim,onUpgrade}) => {
  const [seccion,setSeccion] = useState("salida");
  const [ticker,setTicker] = useState("");
  const [preciosElegidos,setPreciosElegidos] = useState({});
  const [fechaVenta,setFechaVenta] = useState(new Date().toLocaleDateString("es-AR"));
  const [lotes,setLotes] = useState([]);
  const [cargandoLotes,setCargandoLotes] = useState(false);
  const [cantidadesElegidas,setCantidadesElegidas] = useState({});
  const [simForm,setSimForm] = useState({ticker:"",tipoActivo:"Cedear",monto:"",moneda:"ARS",fechaEntrada:new Date().toLocaleDateString("es-AR"),precioEntrada:"",notas:""});
  const misOps = operaciones.filter(o=>user.rol==="admin"||o.userId===user.id);
  const misTickersOperados = [...new Set(misOps.map(o=>o.ticker))];
  const posiciones = misTickersOperados.map(ticker=>{
    const a = activos.find(x=>x.ticker===ticker);
    return {ticker,nombre:a?.nombre||ticker,tipo:a?.tipo||"",pos:calcPosicion(misOps,user.id,ticker)};
  }).filter(a=>a.pos.cantidad>0);
  const comPct = parseFloat(configData.comision)/100;
  const elegirTickerSalida = async (t) => {
    setTicker(t); setCantidadesElegidas({}); setPreciosElegidos({});
    if (!t) { setLotes([]); return; }
    setCargandoLotes(true);
    const resp = await api.lotesDisponibles(t);
    setCargandoLotes(false);
    // El backend devuelve la fecha de compra como "fecha"; la
    // guardamos tambien como "fechaCompra" para los calculos.
    if (resp.ok) setLotes(resp.lotes.map(l=>({...l,fechaCompra:l.fecha}))); else setLotes([]);
  };
  const setCantidadLoteSalida = (loteId, valor, maxDisp) => {
    let v = valor===""?"":Math.min(parseFloat(valor)||0, maxDisp);
    setCantidadesElegidas(p=>({...p,[loteId]:v}));
  };
  const setPrecioLoteSalida = (loteId, valor) => {
    setPreciosElegidos(p=>({...p,[loteId]:valor}));
  };
  const monedaLotes = lotes[0]?.moneda||"ARS";
  const lotesElegidos = lotes.filter(l=>parseFloat(cantidadesElegidas[l.id])>0);
  // Cada lote tiene su propio precio hipotetico de venta editable,
  // asi podes jugar con distintos precios para distintas compras.
  const precioLoteSalida = (l) => parseFloat(preciosElegidos[l.id]||0);
  const posicionActualSalida = ticker ? calcPosicion(misOps,user.id,ticker) : null;
  const totalElegidoSalida = Object.values(cantidadesElegidas).reduce((s,v)=>s+(parseFloat(v)||0),0);
  const costoTotalPosicionSalida = posicionActualSalida ? posicionActualSalida.cantidad*posicionActualSalida.promedio : 0;
  const costoElegidoSalida = lotes.reduce((s,l)=>s+((parseFloat(cantidadesElegidas[l.id])||0)*parseFloat(l.precio)),0);
  const cantidadRestanteSalida = posicionActualSalida ? posicionActualSalida.cantidad-totalElegidoSalida : 0;
  const promedioRestanteSalida = cantidadRestanteSalida>0 ? (costoTotalPosicionSalida-costoElegidoSalida)/cantidadRestanteSalida : 0;
  const todosConPrecioSim = lotesElegidos.length>0 && lotesElegidos.every(l=>precioLoteSalida(l)>0);
  const calcInflacion = (desde,hasta) => {
    if (!desde||!hasta||ipc.length===0) return null;
    const d=parseFecha(desde),h=parseFecha(hasta);
    if (!d||!h||h<=d) return null;
    let acum=1,n=0;
    for (const item of ipc) {
      const [mm,yy]=item.mes.split("/");
      const fm=new Date(yy+"-"+mm+"-01");
      if (fm>=d&&fm<=h) { acum*=(1+parseFloat(item.valor)/100); n++; }
    }
    return n>0?(acum-1)*100:null;
  };
  const simularLote = (l) => {
    const cant = parseFloat(cantidadesElegidas[l.id])||0;
    const precioVentaLote = precioLoteSalida(l);
    const costo = parseFloat(l.precio)*cant;
    const ventaBruta = precioVentaLote*cant;
    const comisionMonto = ventaBruta*comPct;
    const ingreso = ventaBruta-comisionMonto;
    const ganancia = ingreso-costo;
    const rendPctLote = costo>0?(ganancia/costo)*100:0;
    const infl = calcInflacion(l.fechaCompra, fechaVenta);
    const leGanaLote = infl!==null?rendPctLote>infl:null;
    return {cant,precioVentaLote,costo,ventaBruta,comisionMonto,ingreso,ganancia,rendPctLote,infl,leGanaLote};
  };
  const gananciaTotalSim = lotesElegidos.reduce((s,l)=>s+simularLote(l).ganancia,0);
  const costoTotalSim = lotesElegidos.reduce((s,l)=>s+simularLote(l).costo,0);
  const ventaBrutaTotalSim = lotesElegidos.reduce((s,l)=>s+simularLote(l).ventaBruta,0);
  const comisionTotalSim = lotesElegidos.reduce((s,l)=>s+simularLote(l).comisionMonto,0);
  const ventaNetaTotalSim = ventaBrutaTotalSim-comisionTotalSim;
  const cantidadTotalSim = lotesElegidos.reduce((s,l)=>s+simularLote(l).cant,0);
  const rendPctTotalSim = costoTotalSim>0?(gananciaTotalSim/costoTotalSim)*100:0;
  const resColorSim = gananciaTotalSim>=0?"var(--green)":"var(--red)";
  const tiposDisponiblesSim = [...new Set(activos.map(a=>a.tipo))].sort();
  const activosDelTipoSim = activos.filter(a=>a.tipo===simForm.tipoActivo);
  const misSims = simulaciones.filter(s=>s.userId===user.id||user.rol==="admin");
  const saveSim = async () => {
    if (!simForm.ticker||!simForm.monto||!simForm.precioEntrada) return;
    const ok = await onAddSim(simForm);
    if (ok) setSimForm({ticker:"",tipoActivo:"Cedear",monto:"",moneda:"ARS",fechaEntrada:new Date().toLocaleDateString("es-AR"),precioEntrada:"",notas:""});
  };
  // Precio de mercado cacheado (el mismo que usa el resto de la app) para
  // autocompletar el "precio actual" de una simulacion sin tener que ir a
  // buscarlo a mano. Si el usuario ya escribio un valor propio, ese manda.
  const precioSugerido = (s) => {
    const dato = precios?precios[s.ticker]:null;
    if (!dato) return null;
    const v = s.moneda==="ARS"?dato.precioARS:dato.precioUSD;
    return v||null;
  };
  const calcSim = (s) => {
    const activoTipo=activos.find(a=>a.ticker===s.ticker)?.tipo;
    const esCripto=activoTipo==="Cripto";
    const precioE=parseFloat(s.precioEntrada),montoTotal=parseFloat(s.monto);
    const cantTitulos=esCripto?montoTotal/precioE:Math.floor(montoTotal/precioE);
    const montoReal=cantTitulos*precioE,sobrante=montoTotal-montoReal;
    const tieneManual = s.precioActual!==""&&s.precioActual!=null;
    const pa=tieneManual?parseFloat(s.precioActual):(precioSugerido(s)||0);
    if (pa<=0) return {cantTitulos,montoReal,sobrante,pa:0};
    const costoInicial=montoReal*(1+comPct),valorActual=cantTitulos*pa*(1-comPct);
    const ganancia=valorActual-costoInicial,rend=costoInicial>0?(ganancia/costoInicial)*100:0;
    const infl=calcInflacion(s.fechaEntrada,new Date().toLocaleDateString("es-AR"));
    return {cantTitulos,montoReal,sobrante,costoInicial,valorActual,ganancia,rend,infl,leGana:infl!==null?rend>infl:null,pa,esSugerido:!tieneManual};
  };
  return (
    <div className="scroll-area" style={{padding:"14px 14px 90px",overflowY:"auto",height:"100%"}}>
      <h1 style={{fontSize:"20px",fontWeight:800,marginBottom:"12px"}}>Simulador</h1>
      <div style={{display:"flex",gap:"6px",marginBottom:"16px"}}>
        <FilterBtn label="Simular ventas" active={seccion==="salida"} onClick={()=>setSeccion("salida")}/>
        <FilterBtn label="Simular compras" active={seccion==="hipotetica"} onClick={()=>setSeccion("hipotetica")}/>
      </div>
      {seccion==="hipotetica"&&(
        <>
          <Card style={{marginBottom:"16px",border:"1px solid rgba(124,58,237,.4)"}}>
            <p style={{fontWeight:700,color:"#a78bfa",marginBottom:"10px",fontSize:"12px"}}>NUEVA SIMULACION</p>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px"}}>
              <Field label="Tipo de activo"><select value={simForm.tipoActivo} onChange={e=>setSimForm(f=>({...f,tipoActivo:e.target.value,ticker:""}))}>{tiposDisponiblesSim.map(t=><option key={t}>{t}</option>)}</select></Field>
              <Field label="Moneda"><select value={simForm.moneda} onChange={e=>setSimForm(f=>({...f,moneda:e.target.value}))}><option value="ARS">Pesos</option><option value="USD">Dolares</option></select></Field>
            </div>
            <Field label={"Activo ("+simForm.tipoActivo+")"}><BuscadorActivo activos={activosDelTipoSim} value={simForm.ticker} onChange={v=>setSimForm(f=>({...f,ticker:v}))} placeholder="Buscar ticker o nombre..."/></Field>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px"}}>
              <Field label="Monto a invertir"><input type="number" value={simForm.monto} onChange={e=>setSimForm(f=>({...f,monto:e.target.value}))} placeholder="500000"/></Field>
              <Field label="Precio de entrada"><input type="number" value={simForm.precioEntrada} onChange={e=>setSimForm(f=>({...f,precioEntrada:e.target.value}))} placeholder="0.00"/></Field>
            </div>
            <Field label="Fecha de entrada"><InputFecha value={simForm.fechaEntrada} onChange={v=>setSimForm(f=>({...f,fechaEntrada:v}))} placeholder="DD/MM/AAAA"/></Field>
            <Field label="Notas"><input value={simForm.notas} onChange={e=>setSimForm(f=>({...f,notas:e.target.value}))} placeholder="Que hubiera pasado si..."/></Field>
            <Btn onClick={saveSim} disabled={!simForm.ticker||!simForm.monto||!simForm.precioEntrada} style={{width:"100%",marginTop:"4px"}}>Guardar simulacion</Btn>
          </Card>
          {misSims.length===0&&<div style={{textAlign:"center",padding:"32px 0",color:"var(--text2)"}}><p>No hay simulaciones guardadas</p></div>}
          <div style={{display:"flex",flexDirection:"column",gap:"10px"}}>
            {misSims.map(s=>{
              const res=calcSim(s);
              return (
                <Card key={s.id} style={{border:"1px solid rgba(124,58,237,.25)"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"10px"}}>
                    <div>
                      <div style={{display:"flex",alignItems:"center",gap:"7px",marginBottom:"3px"}}><span style={{fontWeight:800,fontSize:"16px"}}>{s.ticker}</span><Badge variant={s.moneda==="USD"?"usd":"ars"} size="sm">{s.moneda}</Badge></div>
                      <div style={{fontSize:"12px",color:"var(--text3)"}}>Entrada: {s.fechaEntrada} - {formatMoney(s.precioEntrada,s.moneda)}</div>
                      <div style={{fontSize:"12px",color:"var(--accent)"}}>Presupuesto: {formatMoney(s.monto,s.moneda)}{res&&<span> - {res.cantTitulos%1===0?res.cantTitulos:res.cantTitulos.toFixed(6)} tit.</span>}</div>
                      {res&&res.sobrante>0.001&&<div style={{fontSize:"11px",color:"var(--yellow)",marginTop:"2px"}}>{formatMoney(res.sobrante,s.moneda)} sin invertir</div>}
                    </div>
                    <button onClick={()=>{if(window.confirm("Borrar esta simulacion?")) onDeleteSim(s.id);}} style={{background:"rgba(255,77,109,.1)",border:"1px solid rgba(255,77,109,.3)",color:"var(--red)",borderRadius:"50%",width:"26px",height:"26px",cursor:"pointer",fontSize:"12px"}}>X</button>
                  </div>
                  <div style={{marginBottom:"10px"}}>
                    <label style={{display:"block",fontSize:"11px",fontWeight:700,color:"#a78bfa",marginBottom:"4px"}}>Precio actual</label>
                    <input type="number" value={s.precioActual!==""&&s.precioActual!=null?s.precioActual:(precioSugerido(s)??"")} onChange={e=>onUpdatePrecioSim(s.id,e.target.value)} onBlur={e=>onGuardarPrecioSim(s.id,e.target.value)} placeholder="Ingresa precio actual..."/>
                    {res&&res.esSugerido&&res.pa>0&&<p style={{fontSize:"10px",color:"var(--text3)",marginTop:"3px"}}>Precio de mercado actual - podes cambiarlo</p>}
                  </div>
                  {res&&res.pa>0?(
                    <div style={{background:res.ganancia>=0?"rgba(0,229,160,.06)":"rgba(255,77,109,.06)",borderRadius:"var(--rs)",padding:"10px 12px"}}>
                      {[["VALOR HOY",formatMoney(res.valorActual,s.moneda)],["GANANCIA/PERDIDA",(res.ganancia>=0?"+":"")+formatMoney(res.ganancia,s.moneda)],["RENDIMIENTO",(res.rend>=0?"+":"")+res.rend.toFixed(2)+"%"]].map(([k,v])=>(
                        <div key={k} style={{display:"flex",justifyContent:"space-between",marginBottom:"6px"}}><span style={{fontSize:"12px",color:"var(--text3)",fontWeight:700}}>{k}</span><span style={{fontFamily:"var(--mono)",fontWeight:800,fontSize:"14px",color:res.ganancia>=0?"var(--green)":"var(--red)"}}>{v}</span></div>
                      ))}
                    </div>
                  ):<p style={{fontSize:"12px",color:"var(--text2)",textAlign:"center"}}>Ingresa el precio actual para ver el resultado</p>}
                </Card>
              );
            })}
          </div>
        </>
      )}
      {seccion==="salida"&&(
        <>
          <Card style={{marginBottom:"16px",border:"1px solid rgba(124,58,237,.4)"}}>
            <p style={{fontWeight:700,color:"#a78bfa",marginBottom:"10px",fontSize:"12px"}}>SIMULAR VENTA - POSICION ABIERTA</p>
            <p style={{fontSize:"12px",color:"var(--text3)",marginBottom:"10px"}}>Elegi un activo que ya tenes, pone el precio que quieras y mira cuanto ganarias o perderias. No se guarda ni se registra nada.</p>
            <Field label="Activo con posicion abierta">
              <BuscadorActivo activos={posiciones} value={ticker} onChange={v=>elegirTickerSalida(v)} placeholder="Buscar ticker o nombre..."/>
            </Field>
            {!ticker&&posiciones.length>0&&(
              <div style={{display:"flex",flexDirection:"column",gap:"8px",marginTop:"6px"}}>
                {posiciones.map(p=>(
                  <Card key={p.ticker} onClick={()=>elegirTickerSalida(p.ticker)} style={{cursor:"pointer"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div>
                        <div style={{fontWeight:700,fontSize:"14px"}}>{p.ticker}</div>
                        <div style={{fontSize:"11px",color:"var(--text3)"}}>{p.nombre}</div>
                      </div>
                      <div style={{textAlign:"right"}}>
                        <div style={{fontFamily:"var(--mono)",fontWeight:700,fontSize:"14px"}}>{p.pos.cantidad}</div>
                        <div style={{fontSize:"10px",color:"var(--text3)"}}>titulos</div>
                      </div>
                    </div>
                  </Card>
                ))}
              </div>
            )}
            {posiciones.length===0&&<p style={{fontSize:"12px",color:"var(--text2)",textAlign:"center",padding:"14px 0"}}>No tenes posiciones abiertas para simular una venta</p>}
          </Card>

          {cargandoLotes&&<p style={{fontSize:"12px",color:"var(--text3)",padding:"10px 0"}}>Cargando lotes...</p>}

          {!cargandoLotes&&ticker&&lotes.length>0&&(
            <>
              <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginTop:"6px",marginBottom:"8px"}}>ELEGI DE QUE COMPRA SIMULAR LA VENTA</p>
              <p style={{fontSize:"12px",color:"var(--text3)",marginBottom:"10px"}}>Cada compra tuya es un lote independiente. Elegi cuanto simular de cada uno (o de varios a la vez) y a que precio, para ver la ganancia o perdida exacta de cada porcion.</p>
              <div style={{display:"flex",flexDirection:"column",gap:"10px",marginBottom:"14px"}}>
                {lotes.map(l=>{
                  const cantLote = parseFloat(cantidadesElegidas[l.id])||0;
                  const precioLoteVal = parseFloat(preciosElegidos[l.id])||0;
                  const resultadoLote = cantLote>0&&precioLoteVal>0 ? simularLote(l) : null;
                  return (
                  <Card key={l.id} style={{border:cantLote>0?"1px solid rgba(124,58,237,.4)":"1px solid var(--border)"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"9px"}}>
                      <div>
                        <div style={{fontSize:"11px",color:"var(--text3)"}}>Compraste el {l.fechaCompra}</div>
                        <div style={{fontFamily:"var(--mono)",fontWeight:700,fontSize:"14px",color:"var(--yellow)"}}>a {formatMoney(l.precio,l.moneda)} cada uno</div>
                      </div>
                      <Badge variant="default" size="sm">{l.cantidadDisponible} disponibles</Badge>
                    </div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px"}}>
                      <Field label="Cantidad a simular">
                        <input type="number" step="any" min="0" max={l.cantidadDisponible}
                          value={cantidadesElegidas[l.id]??""}
                          onChange={e=>setCantidadLoteSalida(l.id,e.target.value,parseFloat(l.cantidadDisponible))}
                          placeholder="0"/>
                      </Field>
                      <Field label={"Precio hipotetico ("+l.moneda+")"}>
                        <input type="number" step="any" min="0"
                          value={preciosElegidos[l.id]??""}
                          onChange={e=>setPrecioLoteSalida(l.id,e.target.value)}
                          placeholder="0.00"/>
                      </Field>
                    </div>
                    {resultadoLote&&(
                      <div style={{marginTop:"9px",paddingTop:"9px",borderTop:"1px solid var(--border)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        <span style={{fontSize:"12px",color:"var(--text3)"}}>{resultadoLote.ganancia>=0?"Ganarias":"Perderias"} en esta porcion</span>
                        <span style={{fontWeight:800,fontFamily:"var(--mono)",fontSize:"15px",color:resultadoLote.ganancia>=0?"var(--green)":"var(--red)"}}>{resultadoLote.ganancia>=0?"+":""}{formatMoney(resultadoLote.ganancia,l.moneda)} ({resultadoLote.rendPctLote>=0?"+":""}{resultadoLote.rendPctLote.toFixed(2)}%)</span>
                      </div>
                    )}
                  </Card>
                  );
                })}
              </div>

              <Field label="Fecha hipotetica de venta"><InputFecha value={fechaVenta} onChange={setFechaVenta}/></Field>

              {totalElegidoSalida>0&&(
                <Card style={{marginTop:"12px",border:"1px solid rgba(251,191,36,.3)"}}>
                  <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,marginBottom:"8px"}}>ASI TE QUEDARIA DESPUES DE ESTA VENTA</p>
                  <div style={{display:"flex",gap:"8px"}}>
                    <div style={{flex:1,textAlign:"center"}}>
                      <div style={{fontSize:"10px",color:"var(--text3)"}}>Titulos que te quedarian</div>
                      <div style={{fontFamily:"var(--mono)",fontWeight:700,fontSize:"15px"}}>{Math.max(0,cantidadRestanteSalida)}</div>
                    </div>
                    <div style={{flex:1,textAlign:"center"}}>
                      <div style={{fontSize:"10px",color:"var(--text3)"}}>Nuevo precio promedio</div>
                      <div style={{fontFamily:"var(--mono)",fontWeight:700,fontSize:"15px",color:"var(--yellow)"}}>{cantidadRestanteSalida>0?formatMoney(promedioRestanteSalida,monedaLotes):"--"}</div>
                    </div>
                  </div>
                </Card>
              )}

              {todosConPrecioSim&&lotesElegidos.length>0&&(
                <div style={{display:"flex",flexDirection:"column",gap:"10px",marginTop:"14px"}}>
                  <Card style={{border:"1px solid "+(gananciaTotalSim>=0?"rgba(0,229,160,.4)":"rgba(255,77,109,.4)")}}>
                    <div style={{textAlign:"center",padding:"8px 0"}}>
                      <div style={{fontSize:"12px",color:"var(--text3)",marginBottom:"4px",fontWeight:700}}>{gananciaTotalSim>=0?"Ganancia total estimada":"Perdida total estimada"}</div>
                      <div style={{fontFamily:"var(--mono)",fontWeight:800,fontSize:"26px",color:resColorSim}}>{gananciaTotalSim>=0?"+":""}{formatMoney(gananciaTotalSim,monedaLotes)}</div>
                      <div style={{fontFamily:"var(--mono)",fontSize:"17px",fontWeight:700,color:resColorSim,marginTop:"2px"}}>{rendPctTotalSim>=0?"+":""}{rendPctTotalSim.toFixed(2)}% de rendimiento</div>
                    </div>
                  </Card>
                  <Card>
                    <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,marginBottom:"8px",letterSpacing:".05em"}}>RESUMEN COMPLETO DE LA SIMULACION</p>
                    {[
                      ["Cantidad total de titulos", cantidadTotalSim+" titulos"],
                      ["Total de la venta (antes de comision)", formatMoney(ventaBrutaTotalSim,monedaLotes)],
                      ["Comision de la venta", "- "+formatMoney(comisionTotalSim,monedaLotes)],
                      ["Total que recibirias", formatMoney(ventaNetaTotalSim,monedaLotes)],
                      ["Costo de lo que compraste (esos lotes)", "- "+formatMoney(costoTotalSim,monedaLotes)]
                    ].map(([k,v])=>(
                      <div key={k} style={{display:"flex",justifyContent:"space-between",gap:"10px",padding:"6px 0",borderBottom:"1px solid var(--border)"}}><span style={{fontSize:"12px",color:"var(--text3)"}}>{k}</span><span style={{fontFamily:"var(--mono)",fontSize:"12px",fontWeight:600,whiteSpace:"nowrap"}}>{v}</span></div>
                    ))}
                    <div style={{display:"flex",justifyContent:"space-between",padding:"8px 0"}}><span style={{fontWeight:700}}>{gananciaTotalSim>=0?"Ganancia neta":"Perdida neta"}</span><span style={{fontFamily:"var(--mono)",fontWeight:800,color:resColorSim}}>{gananciaTotalSim>=0?"+":""}{formatMoney(gananciaTotalSim,monedaLotes)}</span></div>
                  </Card>
                  <Card>
                    <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,marginBottom:"8px",letterSpacing:".05em"}}>DETALLE, LOTE POR LOTE</p>
                    {lotesElegidos.map(l=>{
                      const s = simularLote(l);
                      return (
                        <div key={l.id} style={{padding:"9px 0",borderBottom:"1px solid var(--border)"}}>
                          <div style={{display:"flex",justifyContent:"space-between",marginBottom:"4px"}}>
                            <span style={{fontSize:"12px",color:"var(--text3)"}}>Comprado el {l.fechaCompra}: {s.cant} titulos a {formatMoney(l.precio,monedaLotes)} c/u</span>
                          </div>
                          <div style={{display:"flex",justifyContent:"space-between",marginBottom:"4px"}}>
                            <span style={{fontSize:"12px",color:"var(--text3)"}}>Venderias a {formatMoney(s.precioVentaLote,monedaLotes)} c/u</span>
                            <span style={{fontWeight:700,fontFamily:"var(--mono)",fontSize:"13px",color:s.ganancia>=0?"var(--green)":"var(--red)"}}>{s.ganancia>=0?"+":""}{formatMoney(s.ganancia,monedaLotes)}</span>
                          </div>
                          <div style={{display:"flex",justifyContent:"space-between",marginBottom:"4px"}}>
                            <span style={{fontSize:"10px",color:"var(--text3)"}}>Recibirias {formatMoney(s.ingreso,monedaLotes)} despues de comision ({formatMoney(s.comisionMonto,monedaLotes)}) - Te costo {formatMoney(s.costo,monedaLotes)}</span>
                          </div>
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                            <span style={{fontSize:"12px",fontWeight:700,color:s.ganancia>=0?"var(--green)":"var(--red)"}}>{s.ganancia>=0?"Ganarias":"Perderias"} {s.rendPctLote>=0?"+":""}{s.rendPctLote.toFixed(2)}%</span>
                            {monedaLotes==="ARS"&&s.infl!==null&&(
                              <Badge variant={s.leGanaLote?"compra":"venta"} size="sm">{s.leGanaLote?"Le gana a la inflacion":"No le gana a la inflacion"} ({s.infl.toFixed(1)}%)</Badge>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </Card>
                </div>
              )}
              {lotesElegidos.length>0&&!todosConPrecioSim&&(
                <p style={{fontSize:"12px",color:"var(--yellow)",textAlign:"center",padding:"14px 0"}}>Falta el precio hipotetico en alguno de los lotes elegidos.</p>
              )}
            </>
          )}
          {!cargandoLotes&&ticker&&lotes.length===0&&(
            <p style={{fontSize:"12px",color:"var(--text2)",textAlign:"center",padding:"20px 0"}}>No hay lotes disponibles para este activo.</p>
          )}
        </>
      )}
    </div>
  );
};

const AlertasTab = ({user,activos,alertas,onAdd,onDelete,onToggleActiva}) => {
  const [showNew,setShowNew] = useState(false);
  const [form,setForm] = useState({ticker:"",tipo:"COMPRA",precio:"",moneda:"ARS",notas:""});
  const misAlertas = alertas.filter(a=>a.userId===user.id||user.rol==="admin");
  const alertasCompra = misAlertas.filter(a=>a.tipo==="COMPRA");
  const alertasVenta = misAlertas.filter(a=>a.tipo==="VENTA");
  const save = () => {
    if (!form.ticker||!form.precio) return;
    onAdd({id:Date.now().toString(),userId:user.id,...form,activa:true,notificada:false,canalNotificacion:"push"});
    setForm({ticker:"",tipo:"COMPRA",precio:"",moneda:"ARS",notas:""}); setShowNew(false);
  };
  const AlertaCard = ({al}) => (
    <Card style={{opacity:al.activa===false?0.55:1}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px"}}>
          <div style={{width:"38px",height:"38px",borderRadius:"9px",background:al.tipo==="COMPRA"?"rgba(0,229,160,.1)":"rgba(255,77,109,.1)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"11px",fontWeight:800,color:al.tipo==="COMPRA"?"var(--green)":"var(--red)",flexShrink:0}}>{al.tipo==="COMPRA"?"COM":"VEN"}</div>
          <div>
            <div style={{display:"flex",alignItems:"center",gap:"6px",marginBottom:"2px",flexWrap:"wrap"}}>
              <span style={{fontWeight:800,fontSize:"15px"}}>{al.ticker}</span>
              <Badge variant={al.tipo==="COMPRA"?"compra":"venta"} size="sm">{al.tipo==="COMPRA"?"COMPRAR SI BAJA A":"VENDER SI SUBE A"}</Badge>
              {al.activa===false&&<Badge variant="default" size="sm">Pausada</Badge>}
            </div>
            <div style={{fontFamily:"var(--mono)",fontSize:"17px",fontWeight:800,color:al.tipo==="COMPRA"?"var(--green)":"var(--red)"}}>{formatMoney(al.precio,al.moneda)}</div>
            {al.notas&&<div style={{fontSize:"12px",color:"var(--text3)",marginTop:"3px",fontStyle:"italic"}}>"{al.notas}"</div>}
          </div>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:"6px",alignItems:"center",flexShrink:0}}>
          <button onClick={()=>onToggleActiva(al.id)} title={al.activa===false?"Activar alerta":"Pausar alerta"} style={{background:al.activa===false?"var(--surface2)":"rgba(0,229,160,.12)",border:"1px solid "+(al.activa===false?"var(--border)":"rgba(0,229,160,.3)"),color:al.activa===false?"var(--text3)":"var(--green)",borderRadius:"50%",width:"28px",height:"28px",cursor:"pointer",fontSize:"13px",display:"flex",alignItems:"center",justifyContent:"center"}}>{al.activa===false?"\u25B6":"\u23F8"}</button>
          <button onClick={()=>onDelete(al.id)} style={{background:"rgba(255,77,109,.1)",border:"1px solid rgba(255,77,109,.3)",color:"var(--red)",borderRadius:"50%",width:"28px",height:"28px",cursor:"pointer",fontSize:"13px"}}>X</button>
        </div>
      </div>
    </Card>
  );
  return (
    <div className="scroll-area" style={{padding:"14px 14px 90px",overflowY:"auto",height:"100%"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"6px"}}>
        <h1 style={{fontSize:"20px",fontWeight:800}}>Alertas de precio</h1>
        <Btn onClick={()=>setShowNew(s=>!s)} size="sm">{showNew?"Cancelar":"+ Nueva"}</Btn>
      </div>
      <p style={{fontSize:"12px",color:"var(--text3)",marginBottom:"12px"}}>Recordatorios de precios para entrar o salir</p>
      <Card style={{marginBottom:"14px",border:"1px solid rgba(0,212,255,.2)",background:"rgba(0,212,255,.04)"}}>
        <p style={{fontSize:"12px",color:"var(--text3)"}}><b style={{color:"var(--accent)"}}>Pro:</b> cuando el precio real toque tu alerta, vas a recibir una notificacion automatica en el celular, aunque tengas la app cerrada.</p>
      </Card>
      {showNew&&(
        <Card style={{marginBottom:"14px",border:"1px solid var(--accent)"}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px"}}>
            <Field label="Tipo"><select value={form.tipo} onChange={e=>setForm(f=>({...f,tipo:e.target.value}))}><option value="COMPRA">Entrada</option><option value="VENTA">Salida</option></select></Field>
            <Field label="Moneda"><select value={form.moneda} onChange={e=>setForm(f=>({...f,moneda:e.target.value}))}><option value="ARS">Pesos</option><option value="USD">Dolares</option></select></Field>
          </div>
          <Field label="Activo"><BuscadorActivo activos={activos} value={form.ticker} onChange={v=>setForm(f=>({...f,ticker:v}))} placeholder="Buscar ticker o nombre..."/></Field>
          <Field label="Precio"><input type="number" value={form.precio} onChange={e=>setForm(f=>({...f,precio:e.target.value}))} placeholder="0.00"/></Field>
          <Field label="Notas"><input value={form.notas} onChange={e=>setForm(f=>({...f,notas:e.target.value}))} placeholder="Ej: esperar confirmacion de tendencia"/></Field>
          <Btn onClick={save} disabled={!form.ticker||!form.precio} style={{width:"100%",marginTop:"4px"}}>Guardar alerta</Btn>
        </Card>
      )}
      {misAlertas.length===0&&!showNew&&<div style={{textAlign:"center",padding:"44px 0",color:"var(--text2)"}}><p>No tenes alertas registradas</p></div>}
      {alertasCompra.length>0&&(<><p style={{fontSize:"11px",color:"var(--green)",fontWeight:700,marginBottom:"7px"}}>ENTRADA (COMPRA)</p><div style={{display:"flex",flexDirection:"column",gap:"8px",marginBottom:"16px"}}>{alertasCompra.map(al=><AlertaCard key={al.id} al={al}/>)}</div></>)}
      {alertasVenta.length>0&&(<><p style={{fontSize:"11px",color:"var(--red)",fontWeight:700,marginBottom:"7px"}}>SALIDA (VENTA)</p><div style={{display:"flex",flexDirection:"column",gap:"8px"}}>{alertasVenta.map(al=><AlertaCard key={al.id} al={al}/>)}</div></>)}
    </div>
  );
};

const AsesorTab = ({user,operaciones,activos,onUpgrade}) => {
  const [pregunta,setPregunta] = useState("");
  const [chat,setChat] = useState([{rol:"asesor",texto:"Hola! Soy tu asesor financiero. En que te ayudo?"}]);
  const [loading,setLoading] = useState(false);
  const enviar = async () => {
    if (!pregunta.trim()||loading) return;
    setChat(c=>[...c,{rol:"usuario",texto:pregunta}]); setPregunta(""); setLoading(true);
    await new Promise(r=>setTimeout(r,1200));
    const resp=["Te recomiendo diversificar entre sectores para reducir el riesgo.","Mantener una porcion en Cedears te protege de la inflacion.","Compara tu rendimiento con la inflacion del periodo."];
    setChat(c=>[...c,{rol:"asesor",texto:resp[Math.floor(Math.random()*resp.length)]}]); setLoading(false);
  };
  if (!esPro(user)) return (
    <div className="scroll-area" style={{padding:"14px 14px 90px",overflowY:"auto",height:"100%"}}>
      <h1 style={{fontSize:"20px",fontWeight:800,marginBottom:"4px"}}>Asesor IA</h1>
      <ProLock user={user} onUpgrade={onUpgrade}><Card><div style={{height:"200px"}}/></Card></ProLock>
    </div>
  );
  return (
    <div style={{display:"flex",flexDirection:"column",height:"100%"}}>
      <div style={{padding:"12px 14px",borderBottom:"1px solid var(--border)",background:"var(--surface)"}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px"}}>
          <div style={{width:"36px",height:"36px",borderRadius:"50%",background:"linear-gradient(135deg,var(--accent),var(--accent2))",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,color:"#0a0e1a"}}>IA</div>
          <div><div style={{fontWeight:700,fontSize:"15px"}}>Asesor InversorApp</div></div>
          <Badge variant="admin" size="sm" style={{marginLeft:"auto"}}>PRO</Badge>
        </div>
      </div>
      <div style={{flex:1,overflowY:"auto",padding:"14px",display:"flex",flexDirection:"column",gap:"10px"}}>
        {chat.map((msg,i)=>(<div key={i} style={{display:"flex",justifyContent:msg.rol==="usuario"?"flex-end":"flex-start"}}><div style={{maxWidth:"85%",padding:"10px 14px",borderRadius:"14px",background:msg.rol==="usuario"?"var(--accent)":"var(--surface2)",color:msg.rol==="usuario"?"#0a0e1a":"var(--text)",fontSize:"13px"}}>{msg.texto}</div></div>))}
        {loading&&<div style={{color:"var(--text3)"}}>...</div>}
      </div>
      <div style={{padding:"12px 14px 16px",borderTop:"1px solid var(--border)",display:"flex",gap:"8px"}}>
        <input value={pregunta} onChange={e=>setPregunta(e.target.value)} onKeyDown={e=>e.key==="Enter"&&enviar()} placeholder="Preguntale a tu asesor..." style={{flex:1}} disabled={loading}/>
        <Btn onClick={enviar} disabled={!pregunta.trim()||loading}>{">"}</Btn>
      </div>
    </div>
  );
};

const AdminTab = ({configData,onUpdateConfig,operaciones,onUpdateOperaciones,usuarios,onUpdateUsuarios,activos,onUpdateActivos,ipc,onUpdateIpc,solicitudes,onUpdateSolicitudes,usuarioActualId,planes}) => {
  const [seccion,setSeccion] = useState("stats");
  const [comision,setComision] = useState(configData.comision);
  const [savedCom,setSavedCom] = useState(false);
  const [ipcLocal,setIpcLocal] = useState(ipc);
  const [newMes,setNewMes] = useState("");
  const [newValor,setNewValor] = useState("");
  const [editUsuario,setEditUsuario] = useState(null);
  const [formUsuario,setFormUsuario] = useState({});
  const [cambioRolPendiente,setCambioRolPendiente] = useState(null);
  const [codigoRol,setCodigoRol] = useState("");
  const [errRol,setErrRol] = useState("");
  const [eliminarPendiente,setEliminarPendiente] = useState(null);
  const [codigoEliminar,setCodigoEliminar] = useState("");
  const [errEliminar,setErrEliminar] = useState("");
  const [tiposActivo,setTiposActivo] = useState([]);
  const [busquedaVisibilidad,setBusquedaVisibilidad] = useState("");
  const [filtroOpsUsuario,setFiltroOpsUsuario] = useState("");
  const [activosUsuarioFiltro,setActivosUsuarioFiltro] = useState([]);
  const elegirUsuarioOps = async (userId) => {
    setFiltroOpsUsuario(userId);
    setFiltroOpsTicker("");
    if (!userId) { setActivosUsuarioFiltro([]); return; }
    const resp = await api.usuariosActivos(userId);
    if (resp.ok) setActivosUsuarioFiltro(resp.activos.map(a=>({id:a.ticker,ticker:a.ticker,nombre:a.nombre,tipo:""})));
    else setActivosUsuarioFiltro([]);
  };
  const [filtroOpsTicker,setFiltroOpsTicker] = useState("");
  const [filtroOpsDesde,setFiltroOpsDesde] = useState("");
  const [filtroOpsHasta,setFiltroOpsHasta] = useState("");
  const [opsAdmin,setOpsAdmin] = useState([]);
  const [totalOpsAdmin,setTotalOpsAdmin] = useState(0);
  const [cargandoOpsAdmin,setCargandoOpsAdmin] = useState(false);
  const aISO = (f) => { if(!f) return ""; const [d,m,y]=f.split("/"); return y+"-"+m+"-"+d; };
  const cargarOpsAdmin = async (reset) => {
    setCargandoOpsAdmin(true);
    const offset = reset?0:opsAdmin.length;
    const resp = await api.operacionesListarAdmin({userId:filtroOpsUsuario,ticker:filtroOpsTicker,desde:aISO(filtroOpsDesde),hasta:aISO(filtroOpsHasta),limit:50,offset});
    setCargandoOpsAdmin(false);
    if (resp.ok) {
      setOpsAdmin(reset?resp.operaciones:[...opsAdmin,...resp.operaciones]);
      setTotalOpsAdmin(resp.total);
    }
  };
  const [busquedaUsuarios,setBusquedaUsuarios] = useState("");
  const [vistaUsuarios,setVistaUsuarios] = useState("lista");
  const [filtroActividadId,setFiltroActividadId] = useState("");
  const [eventosActividad,setEventosActividad] = useState([]);
  const [totalActividad,setTotalActividad] = useState(0);
  const [cargandoActividad,setCargandoActividad] = useState(false);
  const cargarActividad = async (userId,reset) => {
    setCargandoActividad(true);
    const offset = reset?0:eventosActividad.length;
    const resp = await api.auditoriaListar(userId||undefined,50,offset);
    setCargandoActividad(false);
    if (resp.ok) {
      setEventosActividad(reset?resp.eventos:[...eventosActividad,...resp.eventos]);
      setTotalActividad(resp.total);
    }
  };
  const abrirActividadDeUsuario = (userId) => {
    setFiltroActividadId(String(userId));
    setEventosActividad([]);
    cargarActividad(userId,true);
    setSeccion("actividad");
  };
  const [bloquesAdmin,setBloquesAdmin] = useState([]);
  const [showNuevoUsuario,setShowNuevoUsuario] = useState(false);
  const [nuevoUsuario,setNuevoUsuario] = useState({nombre:"",email:"",password:"",celular:"",pais:"Argentina",rol:"usuario"});
  const [showPwNuevoUsuario,setShowPwNuevoUsuario] = useState(false);
  const [editActivo,setEditActivo] = useState(null);
  const [formActivo,setFormActivo] = useState({});
  const [showNuevoActivo,setShowNuevoActivo] = useState(false);
  const [nuevoActivo,setNuevoActivo] = useState({ticker:"",nombre:"",tipo:"Cedear"});
  const [excelActivos,setExcelActivos] = useState(null);
  const [excelError,setExcelError] = useState("");

  const saveCom = () => { onUpdateConfig({...configData,comision}); setSavedCom(true); setTimeout(()=>setSavedCom(false),2000); };
  const addIpc = () => {
    if (!newMes||!newValor) return;
    const nuevo=[...ipcLocal.filter(i=>i.mes!==newMes),{id:Date.now().toString(),mes:newMes,valor:newValor}].sort((a,b)=>{const[ma,ya]=a.mes.split("/");const[mb,yb]=b.mes.split("/");return new Date(ya+"-"+ma+"-01")-new Date(yb+"-"+mb+"-01");});
    setIpcLocal(nuevo); onUpdateIpc(nuevo); setNewMes(""); setNewValor("");
  };
  const deleteIpc = (id) => { const n=ipcLocal.filter(i=>i.id!==id); setIpcLocal(n); onUpdateIpc(n); };
  const guardarUsuario = async () => {
    const resp = await api.usuariosEditar({ userId: editUsuario, ...formUsuario });
    if (resp.ok) {
      onUpdateUsuarios(usuarios.map(u=>u.id===editUsuario?{...u,...formUsuario}:u));
      setEditUsuario(null);
    } else {
      alert(resp.error||"No se pudo guardar el usuario");
    }
  };
  const guardarPlanUsuario = async (userId) => {
    const payload = { userId };
    if (formUsuario.planId!==undefined && formUsuario.planId!=="") payload.planId = parseInt(formUsuario.planId,10);
    if (formUsuario.limitePersonalizado!==undefined) payload.limitePersonalizado = formUsuario.limitePersonalizado===""?null:parseInt(formUsuario.limitePersonalizado,10);
    if (formUsuario.planVence) payload.planVence = formUsuario.planVence;
    if (!("planId" in payload) && !("limitePersonalizado" in payload) && !("planVence" in payload)) return;
    const resp = await api.usuariosPlan(payload);
    if (resp.ok) {
      const planElegido = "planId" in payload ? planes.find(p=>String(p.id)===String(payload.planId)) : null;
      onUpdateUsuarios(usuarios.map(u=>u.id===userId?{
        ...u,
        planId: "planId" in payload ? payload.planId : u.planId,
        plan: planElegido ? planElegido.nombreInterno : u.plan,
        planVence: payload.planVence || u.planVence,
        limitePersonalizado: "limitePersonalizado" in payload ? payload.limitePersonalizado : u.limitePersonalizado
      }:u));
    } else {
      alert(resp.error||"No se pudo actualizar el plan");
    }
  };
  const solicitarCambioRol = async (userId, nuevoRol) => {
    const resp = await api.usuariosRolSolicitar(userId, nuevoRol);
    if (resp.ok) { setCambioRolPendiente({userId,nuevoRol}); setErrRol(""); setCodigoRol(""); }
    else alert(resp.error||"No se pudo solicitar el cambio de rol");
  };
  const confirmarCambioRol = async () => {
    const resp = await api.usuariosRolConfirmar(codigoRol);
    if (resp.ok) {
      onUpdateUsuarios(usuarios.map(u=>u.id===cambioRolPendiente.userId?{...u,rol:cambioRolPendiente.nuevoRol}:u));
      setCambioRolPendiente(null); setCodigoRol(""); setErrRol("");
    } else { setErrRol(resp.error||"Codigo incorrecto"); }
  };
  const solicitarEliminar = async (userId) => {
    const resp = await api.usuariosEliminarSolicitar(userId);
    if (resp.ok) { setEliminarPendiente(userId); setErrEliminar(""); setCodigoEliminar(""); }
    else alert(resp.error||"No se pudo solicitar la eliminacion");
  };
  const confirmarEliminar = async () => {
    const resp = await api.usuariosEliminarConfirmar(codigoEliminar);
    if (resp.ok) {
      onUpdateUsuarios(usuarios.filter(u=>u.id!==eliminarPendiente));
      setEliminarPendiente(null); setCodigoEliminar(""); setErrEliminar("");
    } else { setErrEliminar(resp.error||"Codigo incorrecto"); }
  };
  const bloquearUsuario = async (id) => {
    const objetivo = usuarios.find(u=>u.id===id);
    if (!objetivo) return;
    const nuevoValor = !objetivo.bloqueado;
    const resp = await api.usuariosEditar({ userId: id, bloqueado: nuevoValor });
    if (resp.ok) {
      onUpdateUsuarios(usuarios.map(u=>u.id===id?{...u,bloqueado:nuevoValor}:u));
    } else {
      alert(resp.error||"No se pudo actualizar el bloqueo");
    }
  };
  const marcarEmailVerificado = async (id) => {
    const resp = await api.usuariosEditar({ userId: id, emailVerificado: true });
    if (resp.ok) {
      onUpdateUsuarios(usuarios.map(u=>u.id===id?{...u,emailVerificado:true}:u));
    } else {
      alert(resp.error||"No se pudo marcar el email como verificado");
    }
  };
  const resetearPasswordUsuario = async (id, email) => {
    if (!window.confirm("Restablecer la contrasena de "+email+"? Se genera una temporal nueva.")) return;
    const resp = await api.usuariosResetearPassword(id);
    if (resp.ok) {
      window.prompt("Contrasena temporal para "+email+" (copiala y pasasela al usuario, no se vuelve a mostrar):", resp.passwordTemporal);
    } else {
      alert(resp.error||"No se pudo resetear la contrasena");
    }
  };
  const [errNuevoUsuario,setErrNuevoUsuario] = useState("");
  const [creandoUsuario,setCreandoUsuario] = useState(false);
  const agregarUsuario = async () => {
    if (!nuevoUsuario.nombre||!nuevoUsuario.email||!nuevoUsuario.password) return;
    setErrNuevoUsuario(""); setCreandoUsuario(true);
    const resp = await api.usuariosCrear(nuevoUsuario);
    setCreandoUsuario(false);
    if (resp.ok) {
      onUpdateUsuarios([...usuarios,resp.usuario]);
      setNuevoUsuario({nombre:"",email:"",password:"",celular:"",pais:"Argentina",rol:"usuario"});
      setShowNuevoUsuario(false);
    } else {
      setErrNuevoUsuario(resp.error||"No se pudo crear el usuario");
    }
  };
  const guardarActivo = () => { onUpdateActivos(activos.map(a=>a.id===editActivo?{...a,...formActivo}:a)); setEditActivo(null); };
  const eliminarActivo = (id) => { if (!window.confirm("Eliminar este activo?")) return; onUpdateActivos(activos.filter(a=>a.id!==id)); };
  const agregarActivo = () => { if (!nuevoActivo.ticker||!nuevoActivo.nombre) return; onUpdateActivos([...activos,{...nuevoActivo,id:Date.now().toString(),ticker:nuevoActivo.ticker.toUpperCase()}]); setNuevoActivo({ticker:"",nombre:"",tipo:"Cedear"}); setShowNuevoActivo(false); };
  const handleExcelActivos = (e) => { const file=e.target.files[0]; if (!file) return; setExcelError(""); setExcelActivos(null); importarActivosExcel(file,activos,(n,d)=>setExcelActivos({nuevos:n,duplicados:d}),(err)=>setExcelError(err)); };
  const confirmarExcelActivos = () => { if (!excelActivos) return; onUpdateActivos([...activos,...excelActivos.nuevos]); alert("Se agregaron "+excelActivos.nuevos.length+" activos"); setExcelActivos(null); };
  const exportarBackup = () => { const b={fecha:new Date().toISOString(),usuarios,activos,operaciones,configData,ipc}; const blob=new Blob([JSON.stringify(b,null,2)],{type:"application/json"}); const url=URL.createObjectURL(blob); const a=document.createElement("a"); a.href=url; a.download="InversorApp_backup.json"; document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url); };
  const aprobarSolicitud = (sol) => {
    onUpdateActivos([...activos,{id:Date.now().toString(),ticker:sol.ticker,nombre:sol.nombre,tipo:sol.tipo}]);
    onUpdateSolicitudes(solicitudes.map(s=>s.id===sol.id?{...s,estado:"aprobada"}:s));
  };
  const rechazarSolicitud = (id) => { onUpdateSolicitudes(solicitudes.map(s=>s.id===id?{...s,estado:"rechazada"}:s)); };
  const solicitudesPendientes = (solicitudes||[]).filter(s=>s.estado==="pendiente");
  const secciones=[{id:"stats",label:"Stats"},{id:"usuarios",label:"Usuarios"},{id:"actividad",label:"Actividad"},{id:"activos",label:"Activos"},{id:"visibilidad",label:"Visibilidad"},{id:"bloques",label:"Bloques"},{id:"solicitudes",label:"Solicitudes"+(solicitudesPendientes.length>0?" ("+solicitudesPendientes.length+")":"")},{id:"operaciones",label:"Ops"},{id:"config",label:"Config"},{id:"datos",label:"Datos"}];

  return (
    <div className="scroll-area" style={{padding:"14px 14px 90px",overflowY:"auto",height:"100%"}}>
      <div style={{display:"flex",alignItems:"center",gap:"8px",marginBottom:"14px"}}>
        <h1 style={{fontSize:"20px",fontWeight:800}}>Administracion</h1>
        <Badge variant="admin">ADMIN</Badge>
      </div>
      <div style={{overflowX:"auto",paddingBottom:"4px",marginBottom:"16px"}}>
        <div style={{display:"flex",gap:"6px",width:"max-content"}}>{secciones.map(s=><FilterBtn key={s.id} label={s.label} active={seccion===s.id} onClick={()=>setSeccion(s.id)}/>)}</div>
      </div>

      {seccion==="stats"&&(
        <>
          <div style={{display:"flex",gap:"7px",flexWrap:"wrap",marginBottom:"10px"}}>
            {[{l:"Usuarios",v:usuarios.length},{l:"Ops",v:operaciones.length},{l:"Activos",v:activos.length}].map(s=>(
              <Card key={s.l} style={{flex:1,minWidth:"80px",textAlign:"center"}}><div style={{fontSize:"10px",color:"var(--text3)"}}>{s.l}</div><div style={{fontFamily:"var(--mono)",fontWeight:700,fontSize:"18px"}}>{s.v}</div></Card>
            ))}
          </div>
          <Divider label="usuarios"/>
          {usuarios.map(u=>{
            const ops=operaciones.filter(o=>o.userId===u.id);
            return (
              <Card key={u.id} style={{marginBottom:"8px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div><div style={{fontWeight:700}}>{u.nombre}{u.bloqueado&&" [BLOQUEADO]"}</div><div style={{fontSize:"11px",color:"var(--text3)"}}>{u.email}</div></div>
                  <div style={{display:"flex",gap:"6px",alignItems:"center"}}>
                    <Badge variant={u.rol==="admin"?"admin":"default"} size="sm">{u.rol}</Badge>
                    {u.plan==="pro"&&<Badge variant="compra" size="sm">PRO</Badge>}
                    <span style={{fontFamily:"var(--mono)",fontWeight:700,color:"var(--accent)"}}>{ops.length}</span>
                  </div>
                </div>
              </Card>
            );
          })}
        </>
      )}

      {seccion==="usuarios"&&(
        <>
          <div style={{display:"flex",justifyContent:"flex-end",marginBottom:"12px"}}>
            <Btn size="sm" onClick={()=>setShowNuevoUsuario(s=>!s)}>{showNuevoUsuario?"Cancelar":"+ Nuevo usuario"}</Btn>
          </div>
          {showNuevoUsuario&&(
            <Card style={{marginBottom:"14px",border:"1px solid var(--accent)"}}>
              <Field label="Nombre"><input value={nuevoUsuario.nombre} onChange={e=>setNuevoUsuario(f=>({...f,nombre:e.target.value}))}/></Field>
              <Field label="Email"><input type="email" value={nuevoUsuario.email} onChange={e=>setNuevoUsuario(f=>({...f,email:e.target.value}))}/></Field>
              <div style={{position:"relative"}}>
                <Field label="Contrasena"><input type={showPwNuevoUsuario?"text":"password"} value={nuevoUsuario.password} onChange={e=>setNuevoUsuario(f=>({...f,password:e.target.value}))} style={{paddingRight:"42px"}}/></Field>
                <button onClick={()=>setShowPwNuevoUsuario(s=>!s)} style={{position:"absolute",right:"10px",bottom:"9px",background:"none",border:"none",color:"var(--text3)",cursor:"pointer",fontSize:"14px"}}>{showPwNuevoUsuario?"O":"o"}</button>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px"}}>
                <Field label="Celular"><input value={nuevoUsuario.celular} onChange={e=>setNuevoUsuario(f=>({...f,celular:e.target.value}))}/></Field>
                <Field label="Rol"><select value={nuevoUsuario.rol} onChange={e=>setNuevoUsuario(f=>({...f,rol:e.target.value}))}><option value="usuario">Usuario</option><option value="admin">Admin</option></select></Field>
              </div>
              <Btn onClick={agregarUsuario} disabled={!nuevoUsuario.nombre||!nuevoUsuario.email||!nuevoUsuario.password||creandoUsuario} style={{width:"100%"}}>{creandoUsuario?"Creando...":"Crear usuario"}</Btn>
              {errNuevoUsuario&&<div style={{background:"rgba(255,77,109,.1)",border:"1px solid rgba(255,77,109,.3)",borderRadius:"var(--rs)",padding:"8px 12px",marginTop:"8px",color:"var(--red)",fontSize:"12px"}}>{errNuevoUsuario}</div>}
            </Card>
          )}

          {cambioRolPendiente&&(
            <Card style={{marginBottom:"14px",border:"1px solid rgba(251,191,36,.5)",background:"rgba(251,191,36,.06)"}}>
              <p style={{fontSize:"13px",fontWeight:700,color:"var(--yellow)",marginBottom:"8px"}}>Confirmar cambio de rol</p>
              <p style={{fontSize:"12px",color:"var(--text3)",marginBottom:"10px"}}>Te enviamos un codigo de 6 numeros a tu email. Ingresalo para confirmar este cambio.</p>
              <Field label="Codigo de confirmacion"><input value={codigoRol} onChange={e=>setCodigoRol(e.target.value)} placeholder="123456" maxLength={6}/></Field>
              {errRol&&<p style={{fontSize:"12px",color:"var(--red)",marginBottom:"8px"}}>{errRol}</p>}
              <div style={{display:"flex",gap:"8px"}}>
                <Btn variant="ghost" onClick={()=>{setCambioRolPendiente(null);setCodigoRol("");setErrRol("");}} style={{flex:1}}>Cancelar</Btn>
                <Btn onClick={confirmarCambioRol} disabled={codigoRol.length!==6} style={{flex:2}}>Confirmar cambio</Btn>
              </div>
            </Card>
          )}

          {eliminarPendiente&&(
            <Card style={{marginBottom:"14px",border:"1px solid rgba(255,77,109,.5)",background:"rgba(255,77,109,.06)"}}>
              <p style={{fontSize:"13px",fontWeight:700,color:"var(--red)",marginBottom:"8px"}}>Confirmar eliminacion de usuario</p>
              <p style={{fontSize:"12px",color:"var(--text3)",marginBottom:"10px"}}>Te enviamos un codigo de 6 numeros a tu email. Esta accion no se puede deshacer facilmente.</p>
              <Field label="Codigo de confirmacion"><input value={codigoEliminar} onChange={e=>setCodigoEliminar(e.target.value)} placeholder="123456" maxLength={6}/></Field>
              {errEliminar&&<p style={{fontSize:"12px",color:"var(--red)",marginBottom:"8px"}}>{errEliminar}</p>}
              <div style={{display:"flex",gap:"8px"}}>
                <Btn variant="ghost" onClick={()=>{setEliminarPendiente(null);setCodigoEliminar("");setErrEliminar("");}} style={{flex:1}}>Cancelar</Btn>
                <Btn variant="danger" onClick={confirmarEliminar} disabled={codigoEliminar.length!==6} style={{flex:2}}>Eliminar definitivamente</Btn>
              </div>
            </Card>
          )}

          <div style={{display:"flex",gap:"6px",marginBottom:"10px"}}>
            <button onClick={()=>setVistaUsuarios("lista")} style={{flex:1,padding:"7px",borderRadius:"var(--rs)",fontSize:"12px",fontWeight:700,cursor:"pointer",border:"1px solid "+(vistaUsuarios==="lista"?"var(--accent)":"var(--border)"),background:vistaUsuarios==="lista"?"rgba(0,212,255,.1)":"var(--surface2)",color:vistaUsuarios==="lista"?"var(--accent)":"var(--text3)",fontFamily:"var(--font-input)"}}>Lista</button>
            <button onClick={()=>setVistaUsuarios("planilla")} style={{flex:1,padding:"7px",borderRadius:"var(--rs)",fontSize:"12px",fontWeight:700,cursor:"pointer",border:"1px solid "+(vistaUsuarios==="planilla"?"var(--accent)":"var(--border)"),background:vistaUsuarios==="planilla"?"rgba(0,212,255,.1)":"var(--surface2)",color:vistaUsuarios==="planilla"?"var(--accent)":"var(--text3)",fontFamily:"var(--font-input)"}}>Planilla</button>
          </div>

          {vistaUsuarios==="lista"&&(
          <>
          <input value={busquedaUsuarios} onChange={e=>setBusquedaUsuarios(e.target.value)} placeholder="Buscar por nombre o email..." style={{marginBottom:"10px"}}/>
          <div style={{display:"flex",flexDirection:"column",gap:"10px"}}>
            {usuarios.filter(u=>!busquedaUsuarios||u.nombre.toLowerCase().includes(busquedaUsuarios.toLowerCase())||u.email.toLowerCase().includes(busquedaUsuarios.toLowerCase())).map(u=>{
              const esUnoMismo = u.id===usuarioActualId;
              return (
              <Card key={u.id}>
                {editUsuario===u.id?(
                  <>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"8px"}}>
                      <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em"}}>DATOS PERSONALES</p>
                      <button onClick={()=>{setEditUsuario(null);setFormUsuario({});}} style={{width:"26px",height:"26px",borderRadius:"50%",background:"var(--surface2)",border:"1px solid var(--border)",color:"var(--text3)",fontSize:"13px",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0}}>{"\u2715"}</button>
                    </div>
                    <Field label="Nombre"><input value={formUsuario.nombre??u.nombre} onChange={e=>setFormUsuario(f=>({...f,nombre:e.target.value}))}/></Field>
                    <Field label="Celular"><input value={formUsuario.celular??u.celular??""} onChange={e=>setFormUsuario(f=>({...f,celular:e.target.value}))}/></Field>
                    <Field label="Pais"><select value={formUsuario.pais??u.pais??"Argentina"} onChange={e=>setFormUsuario(f=>({...f,pais:e.target.value}))}>{PAISES.map(p=><option key={p}>{p}</option>)}</select></Field>
                    <Field label="Fecha de nacimiento"><InputFecha value={formUsuario.fechaNacimiento??u.fechaNacimiento??""} onChange={v=>setFormUsuario(f=>({...f,fechaNacimiento:v}))}/></Field>
                    <Field label="Direccion"><input value={formUsuario.direccion??u.direccion??""} onChange={e=>setFormUsuario(f=>({...f,direccion:e.target.value}))}/></Field>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px"}}>
                      <Field label="Localidad"><input value={formUsuario.localidad??u.localidad??""} onChange={e=>setFormUsuario(f=>({...f,localidad:e.target.value}))}/></Field>
                      <Field label="Provincia"><input value={formUsuario.provincia??u.provincia??""} onChange={e=>setFormUsuario(f=>({...f,provincia:e.target.value}))}/></Field>
                    </div>
                    <Field label="Comision (%)"><input type="number" step="0.1" value={formUsuario.comision??u.comision??"1"} onChange={e=>setFormUsuario(f=>({...f,comision:e.target.value}))}/></Field>
                    <Field label="Observaciones" hint="Notas internas, solo las ve el admin"><input value={formUsuario.observaciones??u.observaciones??""} onChange={e=>setFormUsuario(f=>({...f,observaciones:e.target.value}))}/></Field>
                    <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginTop:"14px",marginBottom:"8px"}}>PLAN</p>
                    <Field label="Plan">
                      <select value={formUsuario.planId??u.planId??""} onChange={e=>setFormUsuario(f=>({...f,planId:e.target.value}))}>
                        <option value="">Seleccionar...</option>
                        {(planes||[]).map(p=><option key={p.id} value={p.id}>{p.nombre}</option>)}
                      </select>
                    </Field>
                    <Field label="Vence (opcional)"><InputFecha value={formUsuario.planVence??u.planVence??""} onChange={v=>setFormUsuario(f=>({...f,planVence:v}))}/></Field>
                    <Field label="Limite personalizado" hint="Pisa el limite del plan para este usuario puntual. Vacio = usa el limite del plan."><input type="number" min="0" value={formUsuario.limitePersonalizado??u.limitePersonalizado??""} onChange={e=>setFormUsuario(f=>({...f,limitePersonalizado:e.target.value}))}/></Field>
                    <Btn variant="success" onClick={()=>guardarPlanUsuario(u.id)} disabled={formUsuario.planId===undefined&&formUsuario.limitePersonalizado===undefined&&!formUsuario.planVence} style={{width:"100%",marginBottom:"10px"}}>Actualizar plan</Btn>
                    <div style={{display:"flex",gap:"8px",marginTop:"4px"}}>
                      <Btn variant="ghost" onClick={()=>{setEditUsuario(null);setFormUsuario({});}} style={{flex:1}}>Cancelar</Btn>
                      <Btn onClick={guardarUsuario} style={{flex:2}}>Guardar</Btn>
                    </div>
                  </>
                ):(
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                    <div>
                      <div style={{display:"flex",gap:"6px",marginBottom:"2px",flexWrap:"wrap"}}>
                        <span style={{fontWeight:700}}>{u.nombre}</span>
                        {u.plan==="pro"&&<Badge variant="compra" size="sm">PRO</Badge>}
                        {esUnoMismo&&<Badge variant="default" size="sm">Vos</Badge>}
                      </div>
                      <div style={{fontSize:"11px",color:"var(--text3)"}}>{u.email}</div>
                      <div style={{display:"flex",gap:"5px",marginTop:"4px",flexWrap:"wrap"}}>
                        <Badge variant={u.rol==="admin"?"admin":"default"} size="sm">{u.rol}</Badge>
                        <Badge variant={u.emailVerificado?"compra":"venta"} size="sm">{u.emailVerificado?"Email verificado":"Email sin verificar"}</Badge>
                        <span style={{fontSize:"10px",color:"var(--text2)"}}>com: {u.comision||"1"}%</span>
                      </div>
                    </div>
                    <div style={{display:"flex",flexDirection:"column",gap:"5px"}}>
                      <Btn size="sm" variant="ghost" onClick={()=>{setEditUsuario(u.id);setFormUsuario({});}}>Editar</Btn>
                      <Btn size="sm" variant={u.bloqueado?"success":"ghost"} onClick={()=>bloquearUsuario(u.id)}>{u.bloqueado?"Desbloquear":"Bloquear"}</Btn>
                      {!u.emailVerificado&&<Btn size="sm" variant="ghost" onClick={()=>marcarEmailVerificado(u.id)}>Marcar verificado</Btn>}
                      <Btn size="sm" variant="ghost" onClick={()=>resetearPasswordUsuario(u.id,u.email)}>Restablecer contrasena</Btn>
                      <Btn size="sm" variant="ghost" onClick={()=>abrirActividadDeUsuario(u.id)}>Ver actividad</Btn>
                      {!esUnoMismo&&(
                        <Btn size="sm" variant="ghost" onClick={()=>solicitarCambioRol(u.id, u.rol==="admin"?"usuario":"admin")}>{u.rol==="admin"?"Quitar Admin":"Hacer Admin"}</Btn>
                      )}
                      {!esUnoMismo&&(
                        <Btn size="sm" variant="danger" onClick={()=>solicitarEliminar(u.id)}>Eliminar</Btn>
                      )}
                    </div>
                  </div>
                )}
              </Card>
            );})}
          </div>
          </>
          )}

          {vistaUsuarios==="planilla"&&(
            <div style={{overflowX:"auto",border:"1px solid var(--border)",borderRadius:"var(--r)"}}>
              <table style={{borderCollapse:"collapse",width:"100%",minWidth:"760px",fontSize:"12px"}}>
                <thead>
                  <tr style={{background:"var(--surface2)"}}>
                    {["Nombre","Email","Rol","Plan","Verificado","Bloqueado","Ultimo login","Registrado"].map(h=>(
                      <th key={h} style={{textAlign:"left",padding:"9px 10px",fontSize:"10px",fontWeight:700,color:"var(--text3)",letterSpacing:".04em",whiteSpace:"nowrap",borderBottom:"1px solid var(--border)"}}>{h}</th>
                    ))}
                    <th style={{padding:"9px 10px",borderBottom:"1px solid var(--border)"}}></th>
                  </tr>
                </thead>
                <tbody>
                  {usuarios.map(u=>(
                    <tr key={u.id} style={{borderBottom:"1px solid var(--border)"}}>
                      <td style={{padding:"8px 10px",whiteSpace:"nowrap",fontWeight:600}}>{u.nombre}</td>
                      <td style={{padding:"8px 10px",whiteSpace:"nowrap",color:"var(--text3)"}}>{u.email}</td>
                      <td style={{padding:"8px 10px",whiteSpace:"nowrap"}}><Badge variant={u.rol==="admin"?"admin":"default"} size="sm">{u.rol}</Badge></td>
                      <td style={{padding:"8px 10px",whiteSpace:"nowrap"}}>{u.plan||"free"}</td>
                      <td style={{padding:"8px 10px",whiteSpace:"nowrap"}}><Badge variant={u.emailVerificado?"compra":"venta"} size="sm">{u.emailVerificado?"Si":"No"}</Badge></td>
                      <td style={{padding:"8px 10px",whiteSpace:"nowrap"}}><Badge variant={u.bloqueado?"venta":"default"} size="sm">{u.bloqueado?"Si":"No"}</Badge></td>
                      <td style={{padding:"8px 10px",whiteSpace:"nowrap",color:"var(--text3)"}}>{u.ultimoLogin||"Nunca"}</td>
                      <td style={{padding:"8px 10px",whiteSpace:"nowrap",color:"var(--text3)"}}>{u.creadoEn||"-"}</td>
                      <td style={{padding:"8px 10px",whiteSpace:"nowrap"}}>
                        <Btn size="sm" variant="ghost" onClick={()=>{setVistaUsuarios("lista");setEditUsuario(u.id);setFormUsuario({});}}>Editar</Btn>
                        <Btn size="sm" variant="ghost" onClick={()=>abrirActividadDeUsuario(u.id)} style={{marginLeft:"6px"}}>Actividad</Btn>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {seccion==="actividad"&&(
        <>
          <div style={{display:"flex",gap:"8px",marginBottom:"12px",alignItems:"flex-end"}}>
            <Field label="Filtrar por usuario">
              <BuscadorUsuario usuarios={usuarios} value={filtroActividadId} onChange={v=>{setFiltroActividadId(v);setEventosActividad([]);cargarActividad(v||undefined,true);}} placeholder="Todos los usuarios (o busca uno)"/>
            </Field>
            <Btn size="sm" variant="ghost" onClick={()=>{setEventosActividad([]);cargarActividad(filtroActividadId||undefined,true);}}>Actualizar</Btn>
          </div>

          {eventosActividad.length===0&&!cargandoActividad&&(
            <p style={{fontSize:"12px",color:"var(--text2)",textAlign:"center",padding:"30px 0"}}>Sin actividad registrada todavia. Toca "Actualizar" para cargar.</p>
          )}

          {eventosActividad.length>0&&(
            <div style={{overflowX:"auto",border:"1px solid var(--border)",borderRadius:"var(--r)",marginBottom:"12px"}}>
              <table style={{borderCollapse:"collapse",width:"100%",minWidth:"680px",fontSize:"12px"}}>
                <thead>
                  <tr style={{background:"var(--surface2)"}}>
                    {["Fecha","Usuario","Accion","Detalle","IP"].map(h=>(
                      <th key={h} style={{textAlign:"left",padding:"9px 10px",fontSize:"10px",fontWeight:700,color:"var(--text3)",letterSpacing:".04em",whiteSpace:"nowrap",borderBottom:"1px solid var(--border)"}}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {eventosActividad.map(ev=>(
                    <tr key={ev.id} style={{borderBottom:"1px solid var(--border)"}}>
                      <td style={{padding:"8px 10px",whiteSpace:"nowrap",fontFamily:"var(--mono)",fontSize:"11px",color:"var(--text3)"}}>{ev.fecha}</td>
                      <td style={{padding:"8px 10px",whiteSpace:"nowrap"}}>{ev.usuario?ev.usuario.nombre:"(usuario eliminado)"}</td>
                      <td style={{padding:"8px 10px",whiteSpace:"nowrap"}}><Badge variant="default" size="sm">{ev.accion}</Badge></td>
                      <td style={{padding:"8px 10px",color:"var(--text3)",maxWidth:"280px"}}>{ev.detalle||"-"}</td>
                      <td style={{padding:"8px 10px",whiteSpace:"nowrap",color:"var(--text3)",fontFamily:"var(--mono)",fontSize:"11px"}}>{ev.ip}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {cargandoActividad&&<p style={{fontSize:"12px",color:"var(--text3)",textAlign:"center",padding:"10px 0"}}>Cargando...</p>}

          {!cargandoActividad&&eventosActividad.length>0&&eventosActividad.length<totalActividad&&(
            <Btn variant="ghost" onClick={()=>cargarActividad(filtroActividadId||undefined,false)} style={{width:"100%"}}>Cargar mas ({eventosActividad.length} de {totalActividad})</Btn>
          )}
        </>
      )}

      {seccion==="activos"&&(
        <>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:"12px",gap:"8px"}}>
            <Btn size="sm" onClick={()=>setShowNuevoActivo(s=>!s)}>{showNuevoActivo?"Cancelar":"+ Nuevo"}</Btn>
            <label style={{cursor:"pointer"}}><input type="file" accept=".xlsx,.xls" onChange={handleExcelActivos} style={{display:"none"}}/><span style={{padding:"5px 12px",borderRadius:"var(--rs)",fontSize:"12px",fontWeight:700,background:"rgba(0,229,160,.12)",color:"var(--green)",border:"1px solid rgba(0,229,160,.3)",cursor:"pointer"}}>Importar Excel</span></label>
          </div>
          {excelError&&<p style={{color:"var(--red)",fontSize:"12px"}}>{excelError}</p>}
          {excelActivos&&(
            <Card style={{marginBottom:"12px"}}>
              <p style={{fontSize:"12px",color:"var(--green)",fontWeight:700,marginBottom:"8px"}}>{excelActivos.nuevos.length} activos nuevos</p>
              <div style={{display:"flex",gap:"8px"}}><Btn variant="ghost" onClick={()=>setExcelActivos(null)} style={{flex:1}}>Cancelar</Btn><Btn onClick={confirmarExcelActivos} style={{flex:2}}>Agregar</Btn></div>
            </Card>
          )}
          {showNuevoActivo&&(
            <Card style={{marginBottom:"14px",border:"1px solid var(--accent)"}}>
              <Field label="Ticker"><input value={nuevoActivo.ticker} onChange={e=>setNuevoActivo(f=>({...f,ticker:e.target.value.toUpperCase()}))}/></Field>
              <Field label="Nombre"><input value={nuevoActivo.nombre} onChange={e=>setNuevoActivo(f=>({...f,nombre:e.target.value}))}/></Field>
              <Field label="Tipo"><select value={nuevoActivo.tipo} onChange={e=>setNuevoActivo(f=>({...f,tipo:e.target.value}))}>{["Cedear","Accion AR","Accion USA","ETF","Cripto","Bono","FCI","Plazo Fijo","Otro"].map(t=><option key={t}>{t}</option>)}</select></Field>
              <Btn onClick={agregarActivo} disabled={!nuevoActivo.ticker||!nuevoActivo.nombre} style={{width:"100%"}}>Agregar</Btn>
            </Card>
          )}
          <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
            {activos.map(a=>(
              <Card key={a.id}>
                {editActivo===a.id?(
                  <>
                    <Field label="Ticker"><input value={formActivo.ticker||a.ticker} onChange={e=>setFormActivo(f=>({...f,ticker:e.target.value.toUpperCase()}))}/></Field>
                    <Field label="Nombre"><input value={formActivo.nombre||a.nombre} onChange={e=>setFormActivo(f=>({...f,nombre:e.target.value}))}/></Field>
                    <div style={{display:"flex",gap:"8px"}}><Btn variant="ghost" onClick={()=>setEditActivo(null)} style={{flex:1}}>Cancelar</Btn><Btn onClick={guardarActivo} style={{flex:2}}>Guardar</Btn></div>
                  </>
                ):(
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div><div style={{display:"flex",gap:"6px"}}><span style={{fontWeight:700}}>{a.ticker}</span><Badge variant="default" size="sm">{a.tipo}</Badge></div><div style={{fontSize:"12px",color:"var(--text3)"}}>{a.nombre}</div></div>
                    <div style={{display:"flex",gap:"5px"}}><Btn size="sm" variant="ghost" onClick={()=>{setEditActivo(a.id);setFormActivo({});}}>Ed.</Btn><Btn size="sm" variant="danger" onClick={()=>eliminarActivo(a.id)}>X</Btn></div>
                  </div>
                )}
              </Card>
            ))}
          </div>
        </>
      )}

      {seccion==="operaciones"&&(
        <>
          <div style={{display:"flex",gap:"7px",marginBottom:"12px"}}>
            <Btn variant="excel" size="sm" onClick={()=>exportarExcel(opsAdmin,"Admin_Todas")}>Excel</Btn>
            <Btn variant="pdf" size="sm" onClick={()=>exportarPDF(opsAdmin,"Todas")}>PDF</Btn>
          </div>

          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px",marginBottom:"6px"}}>
            <Field label="Usuario"><BuscadorUsuario usuarios={usuarios} value={filtroOpsUsuario} onChange={elegirUsuarioOps}/></Field>
            <Field label="Ticker"><BuscadorActivo activos={activosUsuarioFiltro} value={filtroOpsTicker} onChange={setFiltroOpsTicker} placeholder={filtroOpsUsuario?"Buscar ticker...":"Elegi un usuario primero"}/></Field>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px",marginBottom:"10px"}}>
            <Field label="Desde"><InputFecha value={filtroOpsDesde} onChange={setFiltroOpsDesde}/></Field>
            <Field label="Hasta"><InputFecha value={filtroOpsHasta} onChange={setFiltroOpsHasta}/></Field>
          </div>
          <Btn size="sm" onClick={()=>cargarOpsAdmin(true)} style={{width:"100%",marginBottom:"14px"}}>{cargandoOpsAdmin?"Buscando...":"Buscar"}</Btn>

          {opsAdmin.length===0&&!cargandoOpsAdmin&&(
            <p style={{fontSize:"12px",color:"var(--text2)",textAlign:"center",padding:"30px 0"}}>Sin resultados todavia. Toca "Buscar" para cargar operaciones.</p>
          )}

          {opsAdmin.length>0&&(
            <div style={{overflowX:"auto",border:"1px solid var(--border)",borderRadius:"var(--r)",marginBottom:"12px"}}>
              <table style={{borderCollapse:"collapse",width:"100%",minWidth:"760px",fontSize:"12px"}}>
                <thead>
                  <tr style={{background:"var(--surface2)"}}>
                    {["Usuario","Fecha","Ticker","Tipo","Cantidad","Precio","Broker","Comision"].map(h=>(
                      <th key={h} style={{textAlign:"left",padding:"9px 10px",fontSize:"10px",fontWeight:700,color:"var(--text3)",letterSpacing:".04em",whiteSpace:"nowrap",borderBottom:"1px solid var(--border)"}}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {opsAdmin.map(op=>{
                    const u=usuarios.find(u=>u.id===op.userId);
                    return (
                      <tr key={op.id} style={{borderBottom:"1px solid var(--border)"}}>
                        <td style={{padding:"8px 10px",whiteSpace:"nowrap"}}>{u?.nombre||"?"}</td>
                        <td style={{padding:"8px 10px",whiteSpace:"nowrap",fontFamily:"var(--mono)",fontSize:"11px",color:"var(--text3)"}}>{op.fecha}</td>
                        <td style={{padding:"8px 10px",whiteSpace:"nowrap",fontWeight:700}}>{op.ticker}</td>
                        <td style={{padding:"8px 10px",whiteSpace:"nowrap"}}><Badge variant={op.tipo==="COMPRA"?"compra":"venta"} size="sm">{op.tipo}</Badge></td>
                        <td style={{padding:"8px 10px",whiteSpace:"nowrap",fontFamily:"var(--mono)"}}>{op.cantidad}</td>
                        <td style={{padding:"8px 10px",whiteSpace:"nowrap",fontFamily:"var(--mono)"}}>{formatMoney(op.precio,op.moneda)}</td>
                        <td style={{padding:"8px 10px",whiteSpace:"nowrap",color:"var(--text3)"}}>{op.broker}</td>
                        <td style={{padding:"8px 10px",whiteSpace:"nowrap",color:"var(--text3)"}}>{op.comision}%</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {cargandoOpsAdmin&&<p style={{fontSize:"12px",color:"var(--text3)",textAlign:"center",padding:"10px 0"}}>Cargando...</p>}

          {!cargandoOpsAdmin&&opsAdmin.length>0&&opsAdmin.length<totalOpsAdmin&&(
            <Btn variant="ghost" onClick={()=>cargarOpsAdmin(false)} style={{width:"100%"}}>Cargar mas ({opsAdmin.length} de {totalOpsAdmin})</Btn>
          )}
        </>
      )}

      {seccion==="config"&&(
        <>
          <Card style={{marginBottom:"14px",border:"1px solid rgba(0,212,255,.2)"}}>
            <p style={{fontSize:"11px",color:"var(--accent)",fontWeight:700,letterSpacing:".06em",marginBottom:"8px"}}>PRECIOS EN TIEMPO REAL</p>
            <p style={{fontSize:"12px",color:"var(--text3)",marginBottom:"10px"}}>El Cron Job de Hostinger actualiza los precios automaticamente cada 15 minutos. Si necesitas forzar una actualizacion ahora, usa el boton de abajo.</p>
            <Card style={{background:"var(--surface2)",marginBottom:"10px"}}>
              <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,marginBottom:"4px"}}>Configuracion del Cron Job en Hostinger:</p>
              <p style={{fontSize:"11px",color:"var(--text2)",fontFamily:"var(--mono)"}}>*/15 * * * *</p>
              <p style={{fontSize:"11px",color:"var(--text2)",fontFamily:"var(--mono)",wordBreak:"break-all"}}>{"https://inversorapp.com.ar/api/actualizar_precios.php"}</p>
            </Card>
            <Btn onClick={async()=>{
              const r=await api.actualizarPrecios();
              if(r.ok) alert("Precios actualizados: "+r.actualizados+" activos. Dolar CCL: $"+r.dolarCCL);
              else alert("Error al actualizar precios");
            }} style={{width:"100%"}}>Actualizar precios ahora</Btn>
          </Card>
          <Card style={{marginBottom:"18px"}}>
            <Field label="Comision global (%)" hint="Valor por defecto. Cada usuario puede personalizar la suya."><input type="number" step="0.1" min="0" max="10" value={comision} onChange={e=>setComision(e.target.value)}/></Field>
            <Btn onClick={saveCom} variant={savedCom?"success":"primary"} style={{width:"100%"}}>{savedCom?"Guardado":"Actualizar"}</Btn>
          </Card>
          <Card>
            <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,marginBottom:"8px"}}>IPC MENSUAL</p>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"8px",marginBottom:"8px"}}>
              <Field label="Mes"><input value={newMes} onChange={e=>setNewMes(e.target.value)} placeholder="05/2026"/></Field>
              <Field label="IPC %"><input type="number" step="0.1" value={newValor} onChange={e=>setNewValor(e.target.value)} placeholder="3.5"/></Field>
            </div>
            <Btn onClick={addIpc} disabled={!newMes||!newValor} style={{width:"100%",marginBottom:"12px"}}>Agregar mes</Btn>
            {[...ipcLocal].reverse().map(item=>(
              <div key={item.id} style={{display:"flex",justifyContent:"space-between",padding:"6px 8px",background:"var(--surface2)",borderRadius:"var(--rs)",marginBottom:"5px"}}>
                <span style={{fontFamily:"var(--mono)",color:"var(--text3)"}}>{item.mes}</span>
                <div style={{display:"flex",gap:"8px"}}><span style={{fontFamily:"var(--mono)",fontWeight:700,color:"var(--yellow)"}}>{item.valor}%</span><button onClick={()=>deleteIpc(item.id)} style={{background:"none",border:"none",color:"var(--red)",cursor:"pointer"}}>X</button></div>
              </div>
            ))}
          </Card>
        </>
      )}

      {seccion==="visibilidad"&&(
        <>
          <p style={{fontSize:"12px",color:"var(--text3)",marginBottom:"12px"}}>Oculta tipos de activo completos (ej: Bonos, Cripto) o activos puntuales mientras no tengas precios confiables. No afecta el historial de operaciones ya cargadas, solo evita cargar operaciones nuevas.</p>

          {tiposActivo.length===0&&(
            <Btn onClick={async()=>{const r=await api.tiposActivoListar(); if(r.ok) setTiposActivo(r.tipos);}} style={{width:"100%",marginBottom:"14px"}}>Cargar tipos de activo</Btn>
          )}

          {tiposActivo.length>0&&(
            <>
              <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginBottom:"8px"}}>TIPOS DE ACTIVO</p>
              <Card style={{marginBottom:"18px"}}>
                {tiposActivo.map(t=>(
                  <div key={t.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:"1px solid var(--border)"}}>
                    <span style={{fontSize:"13px",fontWeight:600}}>{t.nombre}</span>
                    <Btn size="sm" variant={t.visible?"success":"ghost"} onClick={async()=>{
                      const r=await api.tipoActivoCambiarVisibilidad(t.nombre,!t.visible);
                      if(r.ok) setTiposActivo(p=>p.map(x=>x.nombre===t.nombre?{...x,visible:!t.visible}:x));
                      else alert(r.error||"No se pudo actualizar");
                    }}>{t.visible?"Visible":"Oculto"}</Btn>
                  </div>
                ))}
              </Card>
            </>
          )}

          <p style={{fontSize:"11px",color:"var(--text3)",fontWeight:700,letterSpacing:".06em",marginBottom:"8px"}}>ACTIVOS INDIVIDUALES</p>
          <input value={busquedaVisibilidad} onChange={e=>setBusquedaVisibilidad(e.target.value)} placeholder="Buscar por ticker o nombre..." style={{marginBottom:"10px"}}/>
          <div style={{display:"flex",flexDirection:"column",gap:"6px"}}>
            {activos.filter(a=>!busquedaVisibilidad||a.ticker.toLowerCase().includes(busquedaVisibilidad.toLowerCase())||a.nombre.toLowerCase().includes(busquedaVisibilidad.toLowerCase())).slice(0,40).map(a=>(
              <Card key={a.id} style={{padding:"9px 13px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div><span style={{fontWeight:700,fontSize:"13px"}}>{a.ticker}</span><span style={{fontSize:"11px",color:"var(--text3)",marginLeft:"6px"}}>{a.nombre}</span></div>
                  <Btn size="sm" variant="ghost" onClick={async()=>{
                    const r=await api.activoCambiarVisibilidad(a.id,false);
                    if(r.ok) { onUpdateActivos(activos.filter(x=>x.id!==a.id)); }
                    else alert(r.error||"No se pudo ocultar");
                  }}>Ocultar</Btn>
                </div>
              </Card>
            ))}
            {busquedaVisibilidad===""&&<p style={{fontSize:"11px",color:"var(--text2)",textAlign:"center",padding:"8px"}}>Mostrando los primeros 40. Busca por ticker o nombre para encontrar otros.</p>}
          </div>
        </>
      )}

      {seccion==="bloques"&&(
        <>
          <p style={{fontSize:"12px",color:"var(--text3)",marginBottom:"12px"}}>Configura que bloques de informacion se muestran en el detalle de cada activo, a que plan pertenece cada uno, y si estan activos. Los cambios se aplican inmediatamente sin recompilar la app.</p>
          {bloquesAdmin.length===0&&(
            <Btn onClick={async()=>{const r=await api.bloquesListar(true); if(r.ok) setBloquesAdmin(r.bloques);}} style={{width:"100%",marginBottom:"14px"}}>Cargar bloques</Btn>
          )}
          {bloquesAdmin.length>0&&(
            <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
              {bloquesAdmin.map(b=>(
                <Card key={b.id}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"6px"}}>
                    <div style={{flex:1}}>
                      <div style={{display:"flex",alignItems:"center",gap:"6px",marginBottom:"2px"}}>
                        <span style={{fontWeight:700,fontSize:"13px"}}>{b.nombre}</span>
                        <Badge variant={b.activo?"compra":"default"} size="sm">{b.activo?"Activo":"Oculto"}</Badge>
                      </div>
                      <p style={{fontSize:"11px",color:"var(--text3)"}}>{b.descripcion}</p>
                    </div>
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"6px"}}>
                    <Field label="Plan minimo">
                      <select value={b.planMinimo} onChange={async e=>{
                        const r=await api.bloqueEditar({bloqueId:b.id,planMinimo:e.target.value});
                        if(r.ok) setBloquesAdmin(p=>p.map(x=>x.id===b.id?{...x,planMinimo:e.target.value}:x));
                      }}>
                        <option value="free">Free</option>
                        <option value="pro_standard">Pro Standard</option>
                        <option value="pro_gold">Pro Gold</option>
                      </select>
                    </Field>
                    <Field label="Visible">
                      <select value={b.activo?"1":"0"} onChange={async e=>{
                        const activo = e.target.value==="1";
                        const r=await api.bloqueEditar({bloqueId:b.id,activo:activo?1:0});
                        if(r.ok) setBloquesAdmin(p=>p.map(x=>x.id===b.id?{...x,activo}:x));
                      }}>
                        <option value="1">Visible</option>
                        <option value="0">Oculto</option>
                      </select>
                    </Field>
                  </div>
                </Card>
              ))}
            </div>
          )}
        </>
      )}

      {seccion==="solicitudes"&&(
        <>
          <p style={{fontSize:"12px",color:"var(--text3)",marginBottom:"14px"}}>Activos que los usuarios solicitaron agregar. Revisa el ticker antes de aprobar para mantener compatibilidad con las APIs de precios.</p>
          {(solicitudes||[]).length===0&&<div style={{textAlign:"center",padding:"40px 0",color:"var(--text2)"}}><p>No hay solicitudes</p></div>}
          <div style={{display:"flex",flexDirection:"column",gap:"10px"}}>
            {[...(solicitudes||[])].sort((a,b)=>(a.estado==="pendiente"?0:1)-(b.estado==="pendiente"?0:1)).map(s=>{
              const u=usuarios.find(u=>u.id===s.userId);
              return (
                <Card key={s.id} style={{border:s.estado==="pendiente"?"1px solid rgba(251,191,36,.4)":"1px solid var(--border)"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"8px"}}>
                    <div>
                      <div style={{display:"flex",gap:"6px",alignItems:"center",marginBottom:"3px"}}>
                        <span style={{fontWeight:800,fontSize:"15px"}}>{s.ticker}</span>
                        <Badge variant="default" size="sm">{s.tipo}</Badge>
                        <Badge variant={s.estado==="aprobada"?"compra":s.estado==="rechazada"?"venta":"alerta"} size="sm">{s.estado}</Badge>
                      </div>
                      <div style={{fontSize:"13px",color:"var(--text3)"}}>{s.nombre}</div>
                      <div style={{fontSize:"11px",color:"var(--text2)",marginTop:"2px"}}>Solicitado por {u?.nombre||"?"} el {s.fecha}</div>
                    </div>
                  </div>
                  {s.estado==="pendiente"&&(
                    <div style={{display:"flex",gap:"8px"}}>
                      <Btn variant="ghost" size="sm" onClick={()=>rechazarSolicitud(s.id)} style={{flex:1}}>Rechazar</Btn>
                      <Btn variant="success" size="sm" onClick={()=>aprobarSolicitud(s)} style={{flex:2}}>Aprobar y agregar a la lista</Btn>
                    </div>
                  )}
                </Card>
              );
            })}
          </div>
        </>
      )}

      {seccion==="datos"&&(
        <Card>
          <p style={{fontSize:"12px",color:"var(--text3)",marginBottom:"12px"}}>Descarga todos los datos en formato JSON</p>
          <Btn onClick={exportarBackup} variant="success" style={{width:"100%"}}>Descargar backup</Btn>
        </Card>
      )}
    </div>
  );
};

export default function App() {
  const [user,setUser] = useState(null);
  const [pantalla,setPantalla] = useState("login");
  const [tokenRecuperar] = useState(()=>new URLSearchParams(window.location.search).get("token"));
  const [tab,setTab] = useState("operaciones");
  const [operaciones,setOperaciones] = useState([]);
  const [activos,setActivos] = useState([]);
  const [alertas,setAlertas] = useState(DEMO_ALERTAS);
  const [simulaciones,setSimulaciones] = useState([]);
  const [configData,setConfigData] = useState(DEMO_CONFIG);
  const [ipc,setIpc] = useState(DEMO_IPC);
  const [usuarios,setUsuarios] = useState(DEMO_USUARIOS);
  const [solicitudes,setSolicitudes] = useState([]);
  const [favoritos,setFavoritos] = useState([]);
  const [cargandoDatos,setCargandoDatos] = useState(false);
  const [precios,setPrecios] = useState({});
  const [planes,setPlanes] = useState([]);

  const calcularPlanInfo = (u, ops, acts, planesList) => {
    if (!u) return null;
    const plan = planesList.find(p=>p.nombreInterno===(u.plan||"free")) || planesList.find(p=>p.nombreInterno==="free");
    const limite = u.limitePersonalizado != null ? u.limitePersonalizado : (plan ? plan.limiteActivos : 5);
    const misOps = ops.filter(o=>o.userId===u.id||u.rol==="admin");
    const tickersUnicos = [...new Set(misOps.filter(o=>o.tipo==="COMPRA").map(o=>o.ticker))];
    let activosAbiertos = 0;
    tickersUnicos.forEach(t=>{
      let cant=0, costo=0;
      misOps.filter(o=>o.ticker===t).sort((a,b)=>parseFecha(a.fecha)-parseFecha(b.fecha)).forEach(op=>{
        const c=parseFloat(op.cantidad||0), p=parseFloat(op.precio||0), com=p*c*(parseFloat(op.comision||1)/100);
        if(op.tipo==="COMPRA"){costo+=p*c+com;cant+=c;}
        else if(cant>0){const pct=c/cant;costo-=costo*pct;cant-=c;}
      });
      if(Math.max(0,cant)>0) activosAbiertos++;
    });
    return { activos: activosAbiertos, limite, planNombre: plan ? plan.nombre : "Free" };
  };
  const toggleFavorito = async (ticker) => {
    const resp = await api.favoritosToggle(ticker);
    if (resp.ok) {
      setFavoritos(p=>resp.accion==="agregado"?[...p,ticker]:p.filter(t=>t!==ticker));
    }
  };
  const [showUpgrade,setShowUpgrade] = useState(false);
  const [showPerfil,setShowPerfil] = useState(false);

  const cargarDatosUsuario = async (usuarioLogueado) => {
    setCargandoDatos(true);
    const promesas = [
      api.operacionesListar(),
      api.activosListar(),
      api.favoritosListar(),
      api.simulacionesListar()
    ];
    const esAdmin = usuarioLogueado && (usuarioLogueado.rol==="admin"||usuarioLogueado.rol==="admin_soporte");
    if (esAdmin) promesas.push(api.usuariosListar());

    const resultados = await Promise.all(promesas);
    const [respOps, respActivos, respFavs, respSims, respUsuarios] = resultados;
    if (respOps.ok) setOperaciones(respOps.operaciones);
    if (respActivos.ok) setActivos(respActivos.activos);
    if (respFavs.ok) setFavoritos(respFavs.favoritos);
    if (respSims.ok) setSimulaciones(respSims.simulaciones);
    if (esAdmin && respUsuarios && respUsuarios.ok) setUsuarios(respUsuarios.usuarios);

    // Cargar precios despues de tener los activos
    const respPrecios = await api.preciosListar();
    if (respPrecios.ok) setPrecios(respPrecios.precios);
    const respPlanes = await api.planesListar();
    if (respPlanes.ok) setPlanes(respPlanes.planes);
    setCargandoDatos(false);
  };

  const cerrarSesion = async () => {
    try { await api.logout(); } catch(e) {}
    localStorage.removeItem("inversorapp_token");
    setUser(null);
    setOperaciones([]);
    setActivos([]);
    setFavoritos([]);
    setSimulaciones([]);
  };

  const updatePrecioSim = (id,precio) => setSimulaciones(p=>p.map(s=>s.id===id?{...s,precioActual:precio}:s));
  const guardarPrecioSim = async (id,precio) => {
    const resp = await api.simulacionesActualizarPrecio(id,precio);
    if (!resp.ok) alert(resp.error||"No se pudo guardar el precio actual");
  };

  if (!user&&tokenRecuperar) return (
    <><GlobalStyles/><NuevaPasswordScreen token={tokenRecuperar} onListo={()=>{window.history.replaceState({},"","/app");setPantalla("login");}}/></>
  );
  if (!user&&pantalla==="registro") return (
    <><GlobalStyles/><RegistroScreen onVolver={()=>setPantalla("login")} onRegistroExitoso={nuevoUser=>{setUsuarios(p=>[...p,nuevoUser]);setUser(nuevoUser);setTab("operaciones");setPantalla("login");}} usuarios={usuarios}/></>
  );
  if (!user) return (
    <><GlobalStyles/><LoginScreen onLogin={u=>{setUser(u);setTab("operaciones");cargarDatosUsuario(u);}} onRegistro={()=>setPantalla("registro")} usuarios={usuarios}/></>
  );
  if (user.debeCambiarPassword) return (
    <><GlobalStyles/><CambioObligatorioScreen user={user} onCambiado={()=>setUser(u=>({...u,debeCambiarPassword:false}))}/></>
  );
  return (
    <>
      <GlobalStyles/>
      <div style={{maxWidth:"480px",margin:"0 auto",height:"100vh",display:"flex",flexDirection:"column",background:"var(--bg)"}}>
        <div style={{flexShrink:0,background:"rgba(10,14,26,.97)",backdropFilter:"blur(12px)",borderBottom:"1px solid var(--border)",padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <LogoFull/>
          <div style={{display:"flex",alignItems:"center",gap:"7px"}}>
            {user.rol==="admin"&&<Badge variant="admin" size="sm">ADMIN</Badge>}
            {PRO_HABILITADO&&(esPro(user)?<Badge variant="compra" size="sm">PRO</Badge>:<span onClick={()=>setShowUpgrade(true)} style={{fontSize:"11px",color:"var(--accent)",cursor:"pointer",textDecoration:"underline"}}>Ser Pro</span>)}
            <span onClick={()=>setShowPerfil(true)} style={{fontSize:"12px",color:"var(--text3)",cursor:"pointer",textDecoration:"underline"}}>{user.nombre}</span>
            <Btn onClick={cerrarSesion} variant="ghost" size="sm">Salir</Btn>
          </div>
        </div>
        <div className="fi" key={tab} style={{flex:1,overflow:"hidden",position:"relative"}}>
          {cargandoDatos&&(
            <div style={{position:"absolute",inset:0,zIndex:300,background:"rgba(10,14,26,.85)",backdropFilter:"blur(3px)",display:"flex",alignItems:"center",justifyContent:"center"}}>
              <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:"10px"}}>
                <div style={{width:"28px",height:"28px",border:"3px solid var(--border)",borderTopColor:"var(--accent)",borderRadius:"50%",animation:"spin .8s linear infinite"}}/>
                <span style={{fontSize:"12px",color:"var(--text3)"}}>Cargando tus datos...</span>
              </div>
            </div>
          )}
          {showPerfil
            ? <PerfilScreen user={user} onClose={()=>setShowPerfil(false)} onSave={u=>{setUser(u);setUsuarios(p=>p.map(x=>x.id===u.id?u:x));setShowPerfil(false);}}/>
            : <>
              {tab==="operaciones"&&<OperacionesTab user={user} operaciones={operaciones} activos={activos} configData={configData} ipc={ipc} planInfo={calcularPlanInfo(user,operaciones,activos,planes)} onAdd={async op=>{const resp=await api.operacionesCrear(op); if(resp.ok){ setOperaciones(p=>[...p,resp.operacion]); return resp.operacion; } alert(resp.error||"No se pudo guardar la operacion"); return null;}} onAgregarLocal={op=>setOperaciones(p=>[...p,op])}/>}
              {tab==="activos"&&<ActivosTab activos={activos} operaciones={operaciones} user={user} precios={precios} onAddActivo={async a=>{const resp=await api.activosCrear(a); if(resp.ok) setActivos(p=>[...p,resp.activo]); else alert(resp.error||"No se pudo crear el activo"); return resp.ok;}} onAddSolicitud={async s=>{const resp=await api.solicitudesCrear(s); if(resp.ok) setSolicitudes(p=>[...p,resp.solicitud]); else alert(resp.error||"No se pudo enviar la solicitud"); return resp.ok;}} solicitudes={solicitudes} favoritos={favoritos} onToggleFavorito={toggleFavorito}/>}
              {tab==="resumen"&&<ResumenTab operaciones={operaciones} user={user} precios={precios}/>}
              {tab==="simulador"&&<SimuladorTab user={user} operaciones={operaciones} activos={activos} configData={configData} ipc={ipc} simulaciones={simulaciones} precios={precios} onAddSim={async s=>{const resp=await api.simulacionesCrear(s); if(resp.ok){setSimulaciones(p=>[...p,resp.simulacion]);return true;} alert(resp.error||"No se pudo guardar la simulacion"); return false;}} onDeleteSim={async id=>{const resp=await api.simulacionesEliminar(id); if(resp.ok) setSimulaciones(p=>p.filter(s=>s.id!==id)); else alert(resp.error||"No se pudo borrar la simulacion");}} onUpdatePrecioSim={updatePrecioSim} onGuardarPrecioSim={guardarPrecioSim} onUpgrade={()=>setShowUpgrade(true)}/>}
              {tab==="asesor"&&<AsesorTab user={user} operaciones={operaciones} activos={activos} onUpgrade={()=>setShowUpgrade(true)}/>}
              {tab==="alertas"&&<AlertasTab user={user} activos={activos} alertas={alertas} onAdd={a=>setAlertas(p=>[...p,a])} onDelete={id=>setAlertas(p=>p.filter(a=>a.id!==id))}/>}
              {tab==="admin"&&user.rol==="admin"&&<AdminTab configData={configData} onUpdateConfig={setConfigData} operaciones={operaciones} onUpdateOperaciones={setOperaciones} usuarios={usuarios} onUpdateUsuarios={setUsuarios} activos={activos} onUpdateActivos={setActivos} ipc={ipc} onUpdateIpc={setIpc} solicitudes={solicitudes} onUpdateSolicitudes={setSolicitudes} usuarioActualId={user.id} planes={planes}/>}
            </>
          }
        </div>
        <div style={{flexShrink:0}}><NavBar tab={tab} setTab={setTab} user={user}/></div>
        {PRO_HABILITADO&&showUpgrade&&<UpgradeScreen onClose={()=>setShowUpgrade(false)}/>}
      </div>
    </>
  );
}
